/*
#HandlePageOnClick ==> for redirect pages 
#BreadcrumbsItem  ==> for dynamic breadcrumb
#imported material-ui components
#imported react-share components
#serviceProvider ==> for api call
*/

import React, { Component, useState, useEffect, useRef, useLayoutEffect } from "react";
import { HandlePageOnClick } from "../../webutils/webutils";
import Avatar from "@material-ui/core/Avatar";
import Box from "@material-ui/core/Box";
import { Link } from "react-router-dom";
import serviceProvider from '../../services/axios'
import Plyr from "plyr";
import "plyr/dist/plyr.css";
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from "react-share";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import { Helmet } from "react-helmet";
// training progressbar
const TrainProgressBar = (props) => {
    return (
        <>
            <div className="t__progressbar__wrapper">
                <div className="t__progressbar__left">
                    <p>Progress:</p>
                </div>
                <div className="t__progressbar__right">
                    <div className="t__progress__relative">
                        <div
                            className={
                                props.value < 100 && props.value > 0
                                    ? "t__progress__status__wrapper progress"
                                    : props.value === 100
                                        ? "t__progress__status__wrapper completed"
                                        : "t__progress__status__wrapper not__start"
                            }
                        >
                            <div className="t__progress__status" style={{ width: `${props.value}%` }}></div>
                        </div>
                        <div className="t__progress__txt">{props.value}%</div>
                    </div>
                </div>
                <div className="t__progressbar__space"></div>
                <div className="t__progressbar__left">
                    <p>
                        Done:<span className="b">{props.doneTime}</span>
                    </p>
                </div>
                <div className="t__progressbar__right">
                    <p>
                        Left:<span className="b">{props.leftTime}</span>
                    </p>
                </div>
            </div>
        </>
    );
};

// content list component
const ContentList = (props) => {
    return (
        <Link to={`/training-courses/${props.course_slug}/${props.section_slug}`}>

            <li className="course__inner__li" onClick={props.callBackFunction}>
                <div className="course__inner__li__icon">
                    <div className="course__inner__li__icon">
                        {props.status === "play" ? (
                            <img src={require("../../assets/img/course-overview/vid_play.svg").default} className="vid__play" alt="vid_play_img" />
                        ) : props.status === "complete" ? (
                            <img
                                src={require("../../assets/img/course-overview/vid_completed.svg").default}
                                className="vid-completed"
                                alt="vid_completed_img"
                            />
                        ) : (
                            <img src={require("../../assets/img/course-overview/vid_lock.svg").default} className="vid_lock" alt="vid_lock_img" />
                        )}
                    </div>
                </div>
                <div className="course__inner__li__txt">
                    <p className="h1__title">{props.listTitle}</p>
                    <p className="time__text">{props.listTime}</p>
                </div>
            </li>
        </Link>
    );
};

// SvgCircle component
const SvgCircle = (props) => {
    const { value } = props;
    return (
        <svg viewBox="0 0 36 36">
            <text className="percent__text" x="50%" y="50%" dominantBaseline="middle" textAnchor="middle" fontSize="10">
                {value}
                <tspan fontSize="5">%</tspan>
            </text>
            <path
                className="circle-bg"
                d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                stroke="#EBF5FA"
                strokeWidth="2.4"
                fill="none"
            ></path>
            <path
                className="circle"
                strokeDasharray={`${value}, 100`}
                d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                stroke={value < 80 && value > 0 ? "#FFBC1F" : value > 79 ? "#40D30D" : "transparent"}
                strokeWidth="2.4"
                fill="none"
            ></path>
        </svg>
    );
};

// CourseOverviewView Component
export const CourseOverviewView = (props) => {
    // const courseDataItems = props.courseData;
    // if (!courseDataItems.length) {
    //  return null;
    // }
    // const courseDataItem = props.courseData[0];
    const courseDataItem = {
        "uid": "2525",
        "id": "11",
        "certificate_ref_id": "1",
        "course_name": "Introduction to Industry 4.0",
        "course_slug": "introduction-to-industry-40",
        "course_icon": "course-symb.svg",
        "course_snippet": "Our introductory course intends to make participants become aware of the philosophy evolution and prepare teams for the digital transformation journey, creating excitement and a pull approach.",
        "course_technology": "",
        "course_description": "An introduction to Industry 4.0 disruption and its effect in modern manufacturing.<br\/><br\/>Our introductory course intends to make participants become aware of the philosophy evolution and prepare teams for the digital transformation journey, creating excitement and a pull approach.",
        "skill_desc": "Industry 4.0 disruption and its effect in modern manufacturing that can initiate an exiting digital transformation journey.",
        "course_image": "Introduction-to-Industry-40-Training.png",
        "course_instructor": "1",
        "course_order": "1",
        "social_url": "https:\/\/www.smarterchains.com\/industry-40-training-courses\/introduction-to-industry-40",
        "price": "0",
        "meta_desc": "Industry 4.0 introductory course intends to make you become aware of the philosophy evolution and prepare teams for the digital transformation journey, creating excitement and a pull approach.​",
        "meta_img": "Introduction-to-Industry-40-Training.png\n",
        "is_imd": "1",
        "is_active": "1",
        "i_name": "Angelos Tsoutsias",
        "i_position": "Industry 4.0 Research and Development team Lead",
        "i_from": "National Technical University of Athens",
        "i_linkedin": "https:\/\/gr.linkedin.com\/in\/angelos-v-tsoutsias",
        "i_avatar": "i_angelos.svg",
        "certificateUrl": "",
        "has_opt": 0,
        "has_completed": 0,
        "score": 0,
        "shortname": "ua",
        "name": "ui",
        "last_name": "admin",
        "initial": "u",
        "has_paid": 1,
        "details": [
            {
                "id": "7",
                "course_id": "11",
                "detail": "Get exposed to Industry 4.0 characteristics and enable the discovery of new knowledge"
            },
            {
                "id": "8",
                "course_id": "11",
                "detail": "Showcase the benefits of the Factory of the Future approach"
            },
            {
                "id": "9",
                "course_id": "11",
                "detail": "Gain knowledge over the changes in today’s Supply Chain and Manufacturing"
            },
            {
                "id": "10",
                "course_id": "11",
                "detail": "Engage with Industry 4.0 as continuity to the world of Industry 3.0"
            },
            {
                "id": "11",
                "course_id": "11",
                "detail": "Review an enterprise-wide strategy sprint case study"
            }
        ],
        "current": {
            "id": "44",
            "course_id": "11",
            "section_name": "Introduction",
            "section_detail": "Introduction to Industry 4.0 Training.",
            "section_duration": "51",
            "video_url": "11\/44.mp4",
            "has_quiz": "0",
            "section_order": "1",
            "slug": "introduction",
            "is_active": "1",
            "time_watched": "0",
            "has_seen": "1",
            "has_complete": "0"
        },
        "sections": [
            {
                "id": "44",
                "course_id": "11",
                "section_name": "Introduction",
                "section_slug": "introduction",
                "course_slug": "introduction-to-industry-40",
                "section_detail": "Introduction to Industry 4.0 Training.",
                "section_order": "1",
                "section_duration": "51",
                "video_url": "11\/44.mp4",
                "time_watched": "0",
                "has_complete": "0",
                "has_quiz": "0",
                "has_seen": "1"
            },
            {
                "id": "45",
                "course_id": "11",
                "section_name": "SmarterChains",
                "section_slug": "smarterchains",
                "course_slug": "introduction-to-industry-40",
                "section_detail": "Get to know SmarterChains.",
                "section_order": "2",
                "section_duration": "50",
                "video_url": "11\/45.mp4",
                "time_watched": 0,
                "has_complete": 0,
                "has_quiz": 0,
                "has_seen": 0
            },
            {
                "id": "46",
                "course_id": "11",
                "section_name": "Innovation",
                "section_slug": "innovation",
                "course_slug": "introduction-to-industry-40",
                "section_detail": "Defining Innovation in the concept of manufacturing.",
                "section_order": "3",
                "section_duration": "521",
                "video_url": "11\/46.mp4",
                "time_watched": 0,
                "has_complete": 0,
                "has_quiz": 0,
                "has_seen": 0
            },
            {
                "id": "47",
                "course_id": "11",
                "section_name": "Industry 4.0",
                "section_slug": "industry-40",
                "course_slug": "introduction-to-industry-40",
                "section_detail": "What is the impact Industry 4.0 brings to our lives.",
                "section_order": "4",
                "section_duration": "777",
                "video_url": "11\/47.mp4",
                "time_watched": 0,
                "has_complete": 0,
                "has_quiz": 0,
                "has_seen": 0
            },
            {
                "id": "48",
                "course_id": "11",
                "section_name": "Research & Development in Industry 4.0",
                "section_slug": "research-development-in-industry-40",
                "course_slug": "introduction-to-industry-40",
                "section_detail": "Examine the research activity around Industry 4.0.",
                "section_order": "5",
                "section_duration": "306",
                "video_url": "11\/48.mp4",
                "time_watched": 0,
                "has_complete": 0,
                "has_quiz": 0,
                "has_seen": 0
            },
            {
                "id": "49",
                "course_id": "11",
                "section_name": "Industry 4.0 on Society",
                "section_slug": "industry-40-on-society",
                "course_slug": "introduction-to-industry-40",
                "section_detail": "What are the changes that Industry 4.0 brings to society.",
                "section_order": "6",
                "section_duration": "329",
                "video_url": "11\/49.mp4",
                "time_watched": 0,
                "has_complete": 0,
                "has_quiz": 0,
                "has_seen": 0
            },
            {
                "id": "50",
                "course_id": "11",
                "section_name": "Industry 4.0 on Supply Chain",
                "section_slug": "industry-40-on-supply-chain",
                "course_slug": "introduction-to-industry-40",
                "section_detail": "Learn about the impact of Industry 4.0 on Supply Chain.",
                "section_order": "7",
                "section_duration": "273",
                "video_url": "11\/50.mp4",
                "time_watched": 0,
                "has_complete": 0,
                "has_quiz": 0,
                "has_seen": 0
            },
            {
                "id": "51",
                "course_id": "11",
                "section_name": "Industry 4.0 on Manufacturing",
                "section_slug": "industry-40-on-manufacturing",
                "course_slug": "introduction-to-industry-40",
                "section_detail": "Understand the relation between Industry 4.0 and Manufacturing.",
                "section_order": "8",
                "section_duration": "326",
                "video_url": "11\/51.mp4",
                "time_watched": 0,
                "has_complete": 0,
                "has_quiz": 0,
                "has_seen": 0
            },
            {
                "id": "52",
                "course_id": "11",
                "section_name": "Factory of the Future",
                "section_slug": "factory-of-the-future",
                "course_slug": "introduction-to-industry-40",
                "section_detail": "Learn about the vision of the Factory of the Future.",
                "section_order": "9",
                "section_duration": "93",
                "video_url": "11\/52.mp4",
                "time_watched": 0,
                "has_complete": 0,
                "has_quiz": 0,
                "has_seen": 0
            },
            {
                "id": "53",
                "course_id": "11",
                "section_name": "Factory of the Future Benefits",
                "section_slug": "factory-of-the-future-benefits",
                "course_slug": "introduction-to-industry-40",
                "section_detail": "Outcome generated from applying a Factory of the Future approach.",
                "section_order": "10",
                "section_duration": "78",
                "video_url": "11\/53.mp4",
                "time_watched": 0,
                "has_complete": 0,
                "has_quiz": 0,
                "has_seen": 0
            },
            {
                "id": "54",
                "course_id": "11",
                "section_name": "SmarterChains Framework",
                "section_slug": "smarterchains-framework",
                "course_slug": "introduction-to-industry-40",
                "section_detail": "Showcase the benefits of SmarterChains Framework.",
                "section_order": "11",
                "section_duration": "186",
                "video_url": "11\/54.mp4",
                "time_watched": 0,
                "has_complete": 0,
                "has_quiz": 0,
                "has_seen": 0
            },
            {
                "id": "113",
                "course_id": "11",
                "section_name": "Industry 4.0 Transformation Case Study",
                "section_slug": "industry-40-transformation-case-study",
                "course_slug": "introduction-to-industry-40",
                "section_detail": "See a real case study about an Industry 4.0 Enterprise Wide Strategy Sprint of a Fortune 100 Manufacturing Organization.",
                "section_order": "12",
                "section_duration": "152",
                "video_url": "11\/113.mp4",
                "time_watched": 0,
                "has_complete": 0,
                "has_quiz": 0,
                "has_seen": 0
            }
        ],
        "currentsid": "44",
        "allcomplete": 0,
        "is_first_quiz": "1",
        "questions": [
            {
                "id": "370",
                "course_id": "11",
                "user_id": "1786",
                "shortname": "AS",
                "initial": "a",
                "name": "Aman ",
                "last_name": "Singh",
                "avcolor": "cir-5",
                "question": "QA Ticket Raise",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "June 17, 2022 03:40 PM",
                "datecreated_default": "2022-06-17 15:40:34",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "368",
                "course_id": "11",
                "user_id": "2504",
                "shortname": "66",
                "initial": "6",
                "name": "64",
                "last_name": "64",
                "avcolor": "cir-21",
                "question": "11:06 GR",
                "section_name": "Introduction",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "June 16, 2022 11:06 AM",
                "datecreated_default": "2022-06-16 13:36:11",
                "answers": [
                    {
                        "id": "457",
                        "ques_id": "368",
                        "user_id": "1",
                        "is_star": "0",
                        "shortname": "SA",
                        "initial": "s",
                        "name": "SmarterChains",
                        "last_name": "Admin",
                        "avcolor": "cir-1",
                        "answer": "hi 11:06 GR",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 16, 2022 11:06 AM",
                        "datecreated_default": "2022-06-16 13:36:48",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "458",
                        "ques_id": "368",
                        "user_id": "2455",
                        "is_star": "0",
                        "shortname": "Rs",
                        "initial": "r",
                        "name": "R",
                        "last_name": "s",
                        "avcolor": "cir-24",
                        "answer": "Tesing local time 2:24",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 16, 2022 02:24 PM",
                        "datecreated_default": "2022-06-16 14:24:25",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "459",
                        "ques_id": "368",
                        "user_id": "1",
                        "is_star": "0",
                        "shortname": "SA",
                        "initial": "s",
                        "name": "SmarterChains",
                        "last_name": "Admin",
                        "avcolor": "cir-1",
                        "answer": "Testing Again",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 16, 2022 02:28 PM",
                        "datecreated_default": "2022-06-16 14:28:57",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "460",
                        "ques_id": "368",
                        "user_id": "2507",
                        "is_star": "0",
                        "shortname": "66",
                        "initial": "6",
                        "name": "65",
                        "last_name": "65",
                        "avcolor": "cir-24",
                        "answer": "Testing with another account",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 16, 2022 02:43 PM",
                        "datecreated_default": "2022-06-16 14:43:49",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 4
            },
            {
                "id": "367",
                "course_id": "11",
                "user_id": "2032",
                "shortname": "AS",
                "initial": "a",
                "name": "Aman ",
                "last_name": "Singh",
                "avcolor": "cir-17",
                "question": "Todaytest",
                "section_name": "Introduction",
                "total_votes": "1",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "June 16, 2022 10:58 AM",
                "datecreated_default": "2022-06-16 10:58:04",
                "answers": [
                    {
                        "id": "451",
                        "ques_id": "367",
                        "user_id": "2057",
                        "is_star": "0",
                        "shortname": "AS",
                        "initial": "a",
                        "name": "Aman ",
                        "last_name": "Singh",
                        "avcolor": "cir-16",
                        "answer": "HI TEST",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 16, 2022 11:06 AM",
                        "datecreated_default": "2022-06-16 11:06:04",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "453",
                        "ques_id": "367",
                        "user_id": "1",
                        "is_star": "0",
                        "shortname": "SA",
                        "initial": "s",
                        "name": "SmarterChains",
                        "last_name": "Admin",
                        "avcolor": "cir-1",
                        "answer": "Hii Admin",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 16, 2022 12:34 PM",
                        "datecreated_default": "2022-06-16 12:34:15",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 2
            },
            {
                "id": "366",
                "course_id": "11",
                "user_id": "2455",
                "shortname": "Rs",
                "initial": "r",
                "name": "R",
                "last_name": "s",
                "avcolor": "cir-24",
                "question": "Question Test",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "1",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "June 15, 2022 02:36 PM",
                "datecreated_default": "2022-06-15 14:36:14",
                "answers": [
                    {
                        "id": "450",
                        "ques_id": "366",
                        "user_id": "2455",
                        "is_star": "0",
                        "shortname": "Rs",
                        "initial": "r",
                        "name": "R",
                        "last_name": "s",
                        "avcolor": "cir-24",
                        "answer": "Nice\n",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 15, 2022 02:37 PM",
                        "datecreated_default": "2022-06-15 14:37:06",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 1
            },
            {
                "id": "365",
                "course_id": "11",
                "user_id": "2407",
                "shortname": "AA",
                "initial": "a",
                "name": "AP",
                "last_name": "AS",
                "avcolor": "cir-2",
                "question": "hii test",
                "section_name": "Introduction",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "June 15, 2022 01:14 PM",
                "datecreated_default": "2022-06-15 13:14:29",
                "answers": [
                    {
                        "id": "441",
                        "ques_id": "365",
                        "user_id": "1",
                        "is_star": "0",
                        "shortname": "SA",
                        "initial": "s",
                        "name": "SmarterChains",
                        "last_name": "Admin",
                        "avcolor": "cir-1",
                        "answer": "hii",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 15, 2022 01:20 PM",
                        "datecreated_default": "2022-06-15 13:20:55",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "449",
                        "ques_id": "365",
                        "user_id": "1",
                        "is_star": "0",
                        "shortname": "SA",
                        "initial": "s",
                        "name": "SmarterChains",
                        "last_name": "Admin",
                        "avcolor": "cir-1",
                        "answer": "Hi.",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 15, 2022 02:05 PM",
                        "datecreated_default": "2022-06-15 14:05:31",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 2
            },
            {
                "id": "364",
                "course_id": "11",
                "user_id": "2347",
                "shortname": "55",
                "initial": "5",
                "name": "59",
                "last_name": "59",
                "avcolor": "cir-20",
                "question": "color issue",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "June 14, 2022 04:07 PM",
                "datecreated_default": "2022-06-14 18:37:25",
                "answers": [
                    {
                        "id": "440",
                        "ques_id": "364",
                        "user_id": "1",
                        "is_star": "0",
                        "shortname": "SA",
                        "initial": "s",
                        "name": "SmarterChains",
                        "last_name": "Admin",
                        "avcolor": "cir-1",
                        "answer": "ok",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 14, 2022 09:56 PM",
                        "datecreated_default": "2022-06-14 21:55:57",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 1
            },
            {
                "id": "362",
                "course_id": "11",
                "user_id": "2455",
                "shortname": "Rs",
                "initial": "r",
                "name": "R",
                "last_name": "s",
                "avcolor": "cir-24",
                "question": "We are testing for question.",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "June 14, 2022 11:12 AM",
                "datecreated_default": "2022-06-14 11:12:01",
                "answers": [
                    {
                        "id": "433",
                        "ques_id": "362",
                        "user_id": "2455",
                        "is_star": "0",
                        "shortname": "Rs",
                        "initial": "r",
                        "name": "R",
                        "last_name": "s",
                        "avcolor": "cir-24",
                        "answer": "ok..",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 14, 2022 11:21 AM",
                        "datecreated_default": "2022-06-14 11:21:55",
                        "reply_ans": [
                            {
                                "id": "259",
                                "ans_id": "433",
                                "user_id": "2455",
                                "is_star": "0",
                                "shortname": "Rs",
                                "initial": "r",
                                "name": "R",
                                "last_name": "s",
                                "avcolor": "cir-24",
                                "answer": "Very Very Good",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Industry 4.0 Transformation Case Study",
                                "like": "",
                                "datecreated": "June 14, 2022 11:28 AM",
                                "datecreated_default": "2022-06-14 11:28:30"
                            }
                        ],
                        "total_reply": 1
                    },
                    {
                        "id": "434",
                        "ques_id": "362",
                        "user_id": "1",
                        "is_star": "0",
                        "shortname": "SA",
                        "initial": "s",
                        "name": "SmarterChains",
                        "last_name": "Admin",
                        "avcolor": "cir-1",
                        "answer": "its working",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 14, 2022 11:41 AM",
                        "datecreated_default": "2022-06-14 11:40:54",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "435",
                        "ques_id": "362",
                        "user_id": "1",
                        "is_star": "0",
                        "shortname": "SA",
                        "initial": "s",
                        "name": "SmarterChains",
                        "last_name": "Admin",
                        "avcolor": "cir-1",
                        "answer": "Again Testing",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 14, 2022 12:23 PM",
                        "datecreated_default": "2022-06-14 12:23:01",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "436",
                        "ques_id": "362",
                        "user_id": "2466",
                        "is_star": "0",
                        "shortname": "RR",
                        "initial": "r",
                        "name": "Rang",
                        "last_name": "Rang",
                        "avcolor": "cir-9",
                        "answer": "Testing from another account ",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 14, 2022 01:03 PM",
                        "datecreated_default": "2022-06-14 13:03:10",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 5
            },
            {
                "id": "355",
                "course_id": "11",
                "user_id": "1786",
                "shortname": "AS",
                "initial": "a",
                "name": "Aman ",
                "last_name": "Singh",
                "avcolor": "cir-5",
                "question": "Aman reply on it.",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "1",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "June 10, 2022 10:28 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "414",
                        "ques_id": "355",
                        "user_id": "1714",
                        "is_star": "0",
                        "shortname": "AS",
                        "initial": "a",
                        "name": "Aman ",
                        "last_name": "Singh",
                        "avcolor": "cir-11",
                        "answer": "hiii reply",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 10, 2022 10:29 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [
                            {
                                "id": "257",
                                "ans_id": "414",
                                "user_id": "2217",
                                "is_star": "0",
                                "shortname": "ss",
                                "initial": "s",
                                "name": "shubh",
                                "last_name": "srivastava",
                                "avcolor": "cir-20",
                                "answer": "new",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Industry 4.0 Transformation Case Study",
                                "like": "",
                                "datecreated": "June 13, 2022 05:30 AM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            }
                        ],
                        "total_reply": 1
                    },
                    {
                        "id": "415",
                        "ques_id": "355",
                        "user_id": "1714",
                        "is_star": "0",
                        "shortname": "AS",
                        "initial": "a",
                        "name": "Aman ",
                        "last_name": "Singh",
                        "avcolor": "cir-11",
                        "answer": "again reply to your que.",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 10, 2022 10:39 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 3
            },
            {
                "id": "352",
                "course_id": "11",
                "user_id": "2438",
                "shortname": "PY",
                "initial": "p",
                "name": "Prem",
                "last_name": "Yadav",
                "avcolor": "cir-7",
                "question": "First Time Question Posting",
                "section_name": "Introduction",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "June 10, 2022 08:14 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "404",
                        "ques_id": "352",
                        "user_id": "2417",
                        "is_star": "0",
                        "shortname": "TY",
                        "initial": "t",
                        "name": "Tejash",
                        "last_name": "Yadav",
                        "avcolor": "cir-12",
                        "answer": "TEsT",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 10, 2022 08:18 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 1
            },
            {
                "id": "351",
                "course_id": "11",
                "user_id": "2417",
                "shortname": "TY",
                "initial": "t",
                "name": "Tejash",
                "last_name": "Yadav",
                "avcolor": "cir-12",
                "question": "Tesing again.",
                "section_name": "Introduction",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "June 10, 2022 08:04 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "402",
                        "ques_id": "351",
                        "user_id": "2417",
                        "is_star": "0",
                        "shortname": "TY",
                        "initial": "t",
                        "name": "Tejash",
                        "last_name": "Yadav",
                        "avcolor": "cir-12",
                        "answer": "Hi.",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 10, 2022 08:10 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 1
            },
            {
                "id": "350",
                "course_id": "11",
                "user_id": "2438",
                "shortname": "PY",
                "initial": "p",
                "name": "Prem",
                "last_name": "Yadav",
                "avcolor": "cir-7",
                "question": "Testing",
                "section_name": "Introduction",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "June 10, 2022 08:02 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "403",
                        "ques_id": "350",
                        "user_id": "2417",
                        "is_star": "0",
                        "shortname": "TY",
                        "initial": "t",
                        "name": "Tejash",
                        "last_name": "Yadav",
                        "avcolor": "cir-12",
                        "answer": "Just Reply",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 10, 2022 08:12 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 1
            },
            {
                "id": "349",
                "course_id": "11",
                "user_id": "2438",
                "shortname": "PY",
                "initial": "p",
                "name": "Prem",
                "last_name": "Yadav",
                "avcolor": "cir-7",
                "question": "Looking for reply form another id",
                "section_name": "Introduction",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "June 10, 2022 07:59 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "401",
                        "ques_id": "349",
                        "user_id": "2417",
                        "is_star": "0",
                        "shortname": "TY",
                        "initial": "t",
                        "name": "Tejash",
                        "last_name": "Yadav",
                        "avcolor": "cir-12",
                        "answer": "ok",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 10, 2022 08:01 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 1
            },
            {
                "id": "348",
                "course_id": "11",
                "user_id": "1714",
                "shortname": "AS",
                "initial": "a",
                "name": "Aman ",
                "last_name": "Singh",
                "avcolor": "cir-11",
                "question": "Hii",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "June 10, 2022 05:29 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "393",
                        "ques_id": "348",
                        "user_id": "1",
                        "is_star": "0",
                        "shortname": "SA",
                        "initial": "s",
                        "name": "SmarterChains",
                        "last_name": "Admin",
                        "avcolor": "cir-1",
                        "answer": "Hello",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 10, 2022 05:29 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [
                            {
                                "id": "246",
                                "ans_id": "393",
                                "user_id": "1714",
                                "is_star": "0",
                                "shortname": "AS",
                                "initial": "a",
                                "name": "Aman ",
                                "last_name": "Singh",
                                "avcolor": "cir-11",
                                "answer": "how are you",
                                "total_votes": "1",
                                "is_edited": "0",
                                "section_name": "Industry 4.0 Transformation Case Study",
                                "like": "",
                                "datecreated": "June 10, 2022 05:30 AM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            },
                            {
                                "id": "249",
                                "ans_id": "393",
                                "user_id": "1714",
                                "is_star": "0",
                                "shortname": "AS",
                                "initial": "a",
                                "name": "Aman ",
                                "last_name": "Singh",
                                "avcolor": "cir-11",
                                "answer": "hii",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Industry 4.0 Transformation Case Study",
                                "like": "",
                                "datecreated": "June 10, 2022 05:45 AM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            },
                            {
                                "id": "250",
                                "ans_id": "393",
                                "user_id": "1714",
                                "is_star": "0",
                                "shortname": "AS",
                                "initial": "a",
                                "name": "Aman ",
                                "last_name": "Singh",
                                "avcolor": "cir-11",
                                "answer": "testtt45",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Industry 4.0 Transformation Case Study",
                                "like": "",
                                "datecreated": "June 10, 2022 05:50 AM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            }
                        ],
                        "total_reply": 3
                    },
                    {
                        "id": "394",
                        "ques_id": "348",
                        "user_id": "1714",
                        "is_star": "0",
                        "shortname": "AS",
                        "initial": "a",
                        "name": "Aman ",
                        "last_name": "Singh",
                        "avcolor": "cir-11",
                        "answer": "yes",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 10, 2022 05:30 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "395",
                        "ques_id": "348",
                        "user_id": "1",
                        "is_star": "0",
                        "shortname": "SA",
                        "initial": "s",
                        "name": "SmarterChains",
                        "last_name": "Admin",
                        "avcolor": "cir-1",
                        "answer": "how r you ?",
                        "opted": 1,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 10, 2022 05:32 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [
                            {
                                "id": "247",
                                "ans_id": "395",
                                "user_id": "1714",
                                "is_star": "0",
                                "shortname": "AS",
                                "initial": "a",
                                "name": "Aman ",
                                "last_name": "Singh",
                                "avcolor": "cir-11",
                                "answer": "Good",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Industry 4.0 Transformation Case Study",
                                "like": "",
                                "datecreated": "June 10, 2022 05:33 AM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            }
                        ],
                        "total_reply": 1
                    },
                    {
                        "id": "396",
                        "ques_id": "348",
                        "user_id": "1714",
                        "is_star": "0",
                        "shortname": "AS",
                        "initial": "a",
                        "name": "Aman ",
                        "last_name": "Singh",
                        "avcolor": "cir-11",
                        "answer": "finee",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 10, 2022 05:32 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "397",
                        "ques_id": "348",
                        "user_id": "1",
                        "is_star": "0",
                        "shortname": "SA",
                        "initial": "s",
                        "name": "SmarterChains",
                        "last_name": "Admin",
                        "avcolor": "cir-1",
                        "answer": "okay",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 10, 2022 05:33 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [
                            {
                                "id": "248",
                                "ans_id": "397",
                                "user_id": "1714",
                                "is_star": "0",
                                "shortname": "AS",
                                "initial": "a",
                                "name": "Aman ",
                                "last_name": "Singh",
                                "avcolor": "cir-11",
                                "answer": "test123",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Industry 4.0 Transformation Case Study",
                                "like": "",
                                "datecreated": "June 10, 2022 05:39 AM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            }
                        ],
                        "total_reply": 1
                    },
                    {
                        "id": "398",
                        "ques_id": "348",
                        "user_id": "1714",
                        "is_star": "0",
                        "shortname": "AS",
                        "initial": "a",
                        "name": "Aman ",
                        "last_name": "Singh",
                        "avcolor": "cir-11",
                        "answer": "hn12",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 10, 2022 05:38 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "399",
                        "ques_id": "348",
                        "user_id": "1",
                        "is_star": "0",
                        "shortname": "SA",
                        "initial": "s",
                        "name": "SmarterChains",
                        "last_name": "Admin",
                        "avcolor": "cir-1",
                        "answer": "you",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 10, 2022 06:42 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "400",
                        "ques_id": "348",
                        "user_id": "1714",
                        "is_star": "0",
                        "shortname": "AS",
                        "initial": "a",
                        "name": "Aman ",
                        "last_name": "Singh",
                        "avcolor": "cir-11",
                        "answer": "yes78",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 10, 2022 07:14 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 13
            },
            {
                "id": "347",
                "course_id": "11",
                "user_id": "1714",
                "shortname": "AS",
                "initial": "a",
                "name": "Aman ",
                "last_name": "Singh",
                "avcolor": "cir-11",
                "question": "test12",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "June 10, 2022 04:40 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "392",
                        "ques_id": "347",
                        "user_id": "1",
                        "is_star": "0",
                        "shortname": "SA",
                        "initial": "s",
                        "name": "SmarterChains",
                        "last_name": "Admin",
                        "avcolor": "cir-1",
                        "answer": "ok",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 10, 2022 04:40 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 1
            },
            {
                "id": "346",
                "course_id": "11",
                "user_id": "2419",
                "shortname": "AJ",
                "initial": "a",
                "name": "Aman",
                "last_name": "Jadon",
                "avcolor": "cir-14",
                "question": "new timezone",
                "section_name": "Introduction",
                "total_votes": "1",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "June 09, 2022 01:07 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "389",
                        "ques_id": "346",
                        "user_id": "2417",
                        "is_star": "0",
                        "shortname": "TY",
                        "initial": "t",
                        "name": "Tejash",
                        "last_name": "Yadav",
                        "avcolor": "cir-12",
                        "answer": "nice",
                        "opted": 0,
                        "total_votes": "1",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 09, 2022 01:08 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [
                            {
                                "id": "245",
                                "ans_id": "389",
                                "user_id": "2419",
                                "is_star": "0",
                                "shortname": "AJ",
                                "initial": "a",
                                "name": "Aman",
                                "last_name": "Jadon",
                                "avcolor": "cir-14",
                                "answer": "thnks",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Introduction",
                                "like": "",
                                "datecreated": "June 09, 2022 01:09 PM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            }
                        ],
                        "total_reply": 1
                    },
                    {
                        "id": "390",
                        "ques_id": "346",
                        "user_id": "1",
                        "is_star": "0",
                        "shortname": "SA",
                        "initial": "s",
                        "name": "SmarterChains",
                        "last_name": "Admin",
                        "avcolor": "cir-1",
                        "answer": "yes",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 09, 2022 01:13 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "391",
                        "ques_id": "346",
                        "user_id": "1",
                        "is_star": "0",
                        "shortname": "SA",
                        "initial": "s",
                        "name": "SmarterChains",
                        "last_name": "Admin",
                        "avcolor": "cir-1",
                        "answer": "Working..",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 09, 2022 01:42 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 4
            },
            {
                "id": "345",
                "course_id": "11",
                "user_id": "2419",
                "shortname": "AJ",
                "initial": "a",
                "name": "Aman",
                "last_name": "Jadon",
                "avcolor": "cir-14",
                "question": "hi test",
                "section_name": "Introduction",
                "total_votes": "1",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "June 09, 2022 12:44 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "387",
                        "ques_id": "345",
                        "user_id": "2118",
                        "is_star": "0",
                        "shortname": "AS",
                        "initial": "a",
                        "name": "Aman ",
                        "last_name": "Singh",
                        "avcolor": "cir-25",
                        "answer": "testing15",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 09, 2022 12:46 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [
                            {
                                "id": "244",
                                "ans_id": "387",
                                "user_id": "2419",
                                "is_star": "0",
                                "shortname": "AJ",
                                "initial": "a",
                                "name": "Aman",
                                "last_name": "Jadon",
                                "avcolor": "cir-14",
                                "answer": "yyytes",
                                "total_votes": "2",
                                "is_edited": "0",
                                "section_name": "Introduction",
                                "like": "",
                                "datecreated": "June 09, 2022 12:56 PM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            }
                        ],
                        "total_reply": 1
                    },
                    {
                        "id": "388",
                        "ques_id": "345",
                        "user_id": "1",
                        "is_star": "0",
                        "shortname": "SA",
                        "initial": "s",
                        "name": "SmarterChains",
                        "last_name": "Admin",
                        "avcolor": "cir-1",
                        "answer": "hi",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 09, 2022 12:55 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 3
            },
            {
                "id": "344",
                "course_id": "11",
                "user_id": "2429",
                "shortname": "AP",
                "initial": "a",
                "name": "Aman",
                "last_name": "Pratap Singh",
                "avcolor": "cir-24",
                "question": "hi at ep",
                "section_name": "Introduction",
                "total_votes": "1",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "June 09, 2022 11:46 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "379",
                        "ques_id": "344",
                        "user_id": "1714",
                        "is_star": "0",
                        "shortname": "AS",
                        "initial": "a",
                        "name": "Aman ",
                        "last_name": "Singh",
                        "avcolor": "cir-11",
                        "answer": "yes hi",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 09, 2022 11:48 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "380",
                        "ques_id": "344",
                        "user_id": "1",
                        "is_star": "0",
                        "shortname": "SA",
                        "initial": "s",
                        "name": "SmarterChains",
                        "last_name": "Admin",
                        "avcolor": "cir-1",
                        "answer": "yes ok",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 09, 2022 11:50 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "381",
                        "ques_id": "344",
                        "user_id": "1",
                        "is_star": "0",
                        "shortname": "SA",
                        "initial": "s",
                        "name": "SmarterChains",
                        "last_name": "Admin",
                        "avcolor": "cir-1",
                        "answer": "hello",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 09, 2022 11:53 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [
                            {
                                "id": "243",
                                "ans_id": "381",
                                "user_id": "2429",
                                "is_star": "0",
                                "shortname": "AP",
                                "initial": "a",
                                "name": "Aman",
                                "last_name": "Pratap Singh",
                                "avcolor": "cir-24",
                                "answer": "hii us",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Introduction",
                                "like": "",
                                "datecreated": "June 09, 2022 11:55 AM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            }
                        ],
                        "total_reply": 1
                    }
                ],
                "total_ans": 4
            },
            {
                "id": "343",
                "course_id": "11",
                "user_id": "2417",
                "shortname": "TY",
                "initial": "t",
                "name": "Tejash",
                "last_name": "Yadav",
                "avcolor": "cir-12",
                "question": "Two Time Zone Question",
                "section_name": "Introduction",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "June 09, 2022 08:50 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "371",
                        "ques_id": "343",
                        "user_id": "1",
                        "is_star": "0",
                        "shortname": "SA",
                        "initial": "s",
                        "name": "SmarterChains",
                        "last_name": "Admin",
                        "avcolor": "cir-1",
                        "answer": "Test",
                        "opted": 0,
                        "total_votes": "1",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 09, 2022 08:54 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "372",
                        "ques_id": "343",
                        "user_id": "2417",
                        "is_star": "0",
                        "shortname": "TY",
                        "initial": "t",
                        "name": "Tejash",
                        "last_name": "Yadav",
                        "avcolor": "cir-12",
                        "answer": "Two Time Zone Reply",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 09, 2022 09:24 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "373",
                        "ques_id": "343",
                        "user_id": "2417",
                        "is_star": "0",
                        "shortname": "TY",
                        "initial": "t",
                        "name": "Tejash",
                        "last_name": "Yadav",
                        "avcolor": "cir-12",
                        "answer": "Two Time Zone Reply 2",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 09, 2022 09:41 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [
                            {
                                "id": "241",
                                "ans_id": "373",
                                "user_id": "2417",
                                "is_star": "0",
                                "shortname": "TY",
                                "initial": "t",
                                "name": "Tejash",
                                "last_name": "Yadav",
                                "avcolor": "cir-12",
                                "answer": "ok its Working.",
                                "total_votes": "1",
                                "is_edited": "0",
                                "section_name": "Introduction",
                                "like": "",
                                "datecreated": "June 09, 2022 03:15 PM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            }
                        ],
                        "total_reply": 1
                    },
                    {
                        "id": "374",
                        "ques_id": "343",
                        "user_id": "2417",
                        "is_star": "0",
                        "shortname": "TY",
                        "initial": "t",
                        "name": "Tejash",
                        "last_name": "Yadav",
                        "avcolor": "cir-12",
                        "answer": "Great",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 09, 2022 11:06 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "376",
                        "ques_id": "343",
                        "user_id": "1",
                        "is_star": "0",
                        "shortname": "SA",
                        "initial": "s",
                        "name": "SmarterChains",
                        "last_name": "Admin",
                        "avcolor": "cir-1",
                        "answer": "Happy",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 09, 2022 11:21 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [
                            {
                                "id": "242",
                                "ans_id": "376",
                                "user_id": "2417",
                                "is_star": "0",
                                "shortname": "TY",
                                "initial": "t",
                                "name": "Tejash",
                                "last_name": "Yadav",
                                "avcolor": "cir-12",
                                "answer": "Good",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Introduction",
                                "like": "",
                                "datecreated": "June 09, 2022 11:23 AM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            }
                        ],
                        "total_reply": 1
                    },
                    {
                        "id": "378",
                        "ques_id": "343",
                        "user_id": "1",
                        "is_star": "0",
                        "shortname": "SA",
                        "initial": "s",
                        "name": "SmarterChains",
                        "last_name": "Admin",
                        "avcolor": "cir-1",
                        "answer": "Perfact",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 09, 2022 11:34 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "382",
                        "ques_id": "343",
                        "user_id": "1",
                        "is_star": "0",
                        "shortname": "SA",
                        "initial": "s",
                        "name": "SmarterChains",
                        "last_name": "Admin",
                        "avcolor": "cir-1",
                        "answer": "Retesting",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 09, 2022 12:00 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "383",
                        "ques_id": "343",
                        "user_id": "1",
                        "is_star": "0",
                        "shortname": "SA",
                        "initial": "s",
                        "name": "SmarterChains",
                        "last_name": "Admin",
                        "avcolor": "cir-1",
                        "answer": "Again Testing",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 09, 2022 12:02 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "384",
                        "ques_id": "343",
                        "user_id": "1",
                        "is_star": "0",
                        "shortname": "SA",
                        "initial": "s",
                        "name": "SmarterChains",
                        "last_name": "Admin",
                        "avcolor": "cir-1",
                        "answer": "Prem Testing.",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 09, 2022 12:21 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "385",
                        "ques_id": "343",
                        "user_id": "1",
                        "is_star": "0",
                        "shortname": "SA",
                        "initial": "s",
                        "name": "SmarterChains",
                        "last_name": "Admin",
                        "avcolor": "cir-1",
                        "answer": "Pankaj Testing",
                        "opted": 0,
                        "total_votes": "1",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 09, 2022 12:25 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 12
            },
            {
                "id": "342",
                "course_id": "11",
                "user_id": "2417",
                "shortname": "TY",
                "initial": "t",
                "name": "Tejash",
                "last_name": "Yadav",
                "avcolor": "cir-12",
                "question": "Two Time Zone Question",
                "section_name": "Introduction",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "June 09, 2022 08:50 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "341",
                "course_id": "11",
                "user_id": "2417",
                "shortname": "TY",
                "initial": "t",
                "name": "Tejash",
                "last_name": "Yadav",
                "avcolor": "cir-12",
                "question": "2 Timezone Questions",
                "section_name": "Introduction",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "June 09, 2022 07:10 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "340",
                "course_id": "11",
                "user_id": "2417",
                "shortname": "TY",
                "initial": "t",
                "name": "Tejash",
                "last_name": "Yadav",
                "avcolor": "cir-12",
                "question": "Final Questions Testing.",
                "section_name": "Introduction",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "June 09, 2022 12:14 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "339",
                "course_id": "11",
                "user_id": "2417",
                "shortname": "TY",
                "initial": "t",
                "name": "Tejash",
                "last_name": "Yadav",
                "avcolor": "cir-12",
                "question": "First Questions",
                "section_name": "Introduction",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "June 09, 2022 06:33 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "338",
                "course_id": "11",
                "user_id": "2417",
                "shortname": "TY",
                "initial": "t",
                "name": "Tejash",
                "last_name": "Yadav",
                "avcolor": "cir-12",
                "question": "Testing.ok\n",
                "section_name": "Introduction",
                "total_votes": "0",
                "is_edited": "1",
                "follow": 0,
                "like": "",
                "datecreated": "June 09, 2022 06:11 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "337",
                "course_id": "11",
                "user_id": "1714",
                "shortname": "AS",
                "initial": "a",
                "name": "Aman ",
                "last_name": "Singh",
                "avcolor": "cir-11",
                "question": "EPP",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "June 08, 2022 12:35 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "370",
                        "ques_id": "337",
                        "user_id": "1",
                        "is_star": "0",
                        "shortname": "SA",
                        "initial": "s",
                        "name": "SmarterChains",
                        "last_name": "Admin",
                        "avcolor": "cir-1",
                        "answer": "YESS",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 08, 2022 12:35 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [
                            {
                                "id": "239",
                                "ans_id": "370",
                                "user_id": "2217",
                                "is_star": "0",
                                "shortname": "ss",
                                "initial": "s",
                                "name": "shubh",
                                "last_name": "srivastava",
                                "avcolor": "cir-20",
                                "answer": "new",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Industry 4.0 Transformation Case Study",
                                "like": "",
                                "datecreated": "June 08, 2022 06:23 PM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            },
                            {
                                "id": "240",
                                "ans_id": "370",
                                "user_id": "2217",
                                "is_star": "0",
                                "shortname": "ss",
                                "initial": "s",
                                "name": "shubh",
                                "last_name": "srivastava",
                                "avcolor": "cir-20",
                                "answer": "new",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Industry 4.0 Transformation Case Study",
                                "like": "",
                                "datecreated": "June 08, 2022 06:23 PM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            }
                        ],
                        "total_reply": 2
                    }
                ],
                "total_ans": 3
            },
            {
                "id": "336",
                "course_id": "11",
                "user_id": "1314",
                "shortname": "AS",
                "initial": "a",
                "name": "Aman ",
                "last_name": "Singh",
                "avcolor": "cir-3",
                "question": "neww for EP",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "June 08, 2022 12:22 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "368",
                        "ques_id": "336",
                        "user_id": "1786",
                        "is_star": "0",
                        "shortname": "AS",
                        "initial": "a",
                        "name": "Aman ",
                        "last_name": "Singh",
                        "avcolor": "cir-5",
                        "answer": "EP Time",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 08, 2022 12:23 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "369",
                        "ques_id": "336",
                        "user_id": "1",
                        "is_star": "0",
                        "shortname": "SA",
                        "initial": "s",
                        "name": "SmarterChains",
                        "last_name": "Admin",
                        "avcolor": "cir-1",
                        "answer": "ok",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 08, 2022 12:24 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 2
            },
            {
                "id": "335",
                "course_id": "11",
                "user_id": "1314",
                "shortname": "AS",
                "initial": "a",
                "name": "Aman ",
                "last_name": "Singh",
                "avcolor": "cir-3",
                "question": "new12",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "June 08, 2022 05:45 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "366",
                        "ques_id": "335",
                        "user_id": "1786",
                        "is_star": "0",
                        "shortname": "AS",
                        "initial": "a",
                        "name": "Aman ",
                        "last_name": "Singh",
                        "avcolor": "cir-5",
                        "answer": "New Yes.\n",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 08, 2022 05:46 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "367",
                        "ques_id": "335",
                        "user_id": "1",
                        "is_star": "0",
                        "shortname": "SA",
                        "initial": "s",
                        "name": "SmarterChains",
                        "last_name": "Admin",
                        "avcolor": "cir-1",
                        "answer": "yes",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 08, 2022 12:18 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 2
            },
            {
                "id": "334",
                "course_id": "11",
                "user_id": "1714",
                "shortname": "AS",
                "initial": "a",
                "name": "Aman ",
                "last_name": "Singh",
                "avcolor": "cir-11",
                "question": "EP TESTING",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "1",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "June 08, 2022 05:40 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "364",
                        "ques_id": "334",
                        "user_id": "1314",
                        "is_star": "0",
                        "shortname": "AS",
                        "initial": "a",
                        "name": "Aman ",
                        "last_name": "Singh",
                        "avcolor": "cir-3",
                        "answer": "YES 123",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 08, 2022 12:11 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "365",
                        "ques_id": "334",
                        "user_id": "1786",
                        "is_star": "0",
                        "shortname": "AS",
                        "initial": "a",
                        "name": "Aman ",
                        "last_name": "Singh",
                        "avcolor": "cir-5",
                        "answer": "Yes",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 08, 2022 12:13 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 2
            },
            {
                "id": "333",
                "course_id": "11",
                "user_id": "2408",
                "shortname": "As",
                "initial": "a",
                "name": "Aman ",
                "last_name": "sfa",
                "avcolor": "cir-3",
                "question": "EP Q&A",
                "section_name": "Introduction",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "June 08, 2022 11:58 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "362",
                        "ques_id": "333",
                        "user_id": "1",
                        "is_star": "0",
                        "shortname": "SA",
                        "initial": "s",
                        "name": "SmarterChains",
                        "last_name": "Admin",
                        "avcolor": "cir-1",
                        "answer": "YES",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 08, 2022 12:00 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "363",
                        "ques_id": "333",
                        "user_id": "1714",
                        "is_star": "0",
                        "shortname": "AS",
                        "initial": "a",
                        "name": "Aman ",
                        "last_name": "Singh",
                        "avcolor": "cir-11",
                        "answer": "test",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 08, 2022 12:01 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 2
            },
            {
                "id": "332",
                "course_id": "11",
                "user_id": "1786",
                "shortname": "AS",
                "initial": "a",
                "name": "Aman ",
                "last_name": "Singh",
                "avcolor": "cir-5",
                "question": "EP Testing from Frontend",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "1",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "June 08, 2022 03:13 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "358",
                        "ques_id": "332",
                        "user_id": "2404",
                        "is_star": "0",
                        "shortname": "AS",
                        "initial": "a",
                        "name": "Aman ",
                        "last_name": "Singh",
                        "avcolor": "cir-25",
                        "answer": "EP TESTING BY A",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 08, 2022 09:50 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [
                            {
                                "id": "238",
                                "ans_id": "358",
                                "user_id": "1786",
                                "is_star": "0",
                                "shortname": "AS",
                                "initial": "a",
                                "name": "Aman ",
                                "last_name": "Singh",
                                "avcolor": "cir-5",
                                "answer": "ok",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Industry 4.0 Transformation Case Study",
                                "like": "",
                                "datecreated": "June 08, 2022 03:22 PM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            }
                        ],
                        "total_reply": 1
                    },
                    {
                        "id": "360",
                        "ques_id": "332",
                        "user_id": "1",
                        "is_star": "0",
                        "shortname": "SA",
                        "initial": "s",
                        "name": "SmarterChains",
                        "last_name": "Admin",
                        "avcolor": "cir-1",
                        "answer": "yess",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 08, 2022 09:56 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "361",
                        "ques_id": "332",
                        "user_id": "1",
                        "is_star": "0",
                        "shortname": "SA",
                        "initial": "s",
                        "name": "SmarterChains",
                        "last_name": "Admin",
                        "avcolor": "cir-1",
                        "answer": "ok",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 08, 2022 10:10 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 4
            },
            {
                "id": "331",
                "course_id": "11",
                "user_id": "1786",
                "shortname": "AS",
                "initial": "a",
                "name": "Aman ",
                "last_name": "Singh",
                "avcolor": "cir-5",
                "question": "ET",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "June 08, 2022 09:34 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "330",
                "course_id": "11",
                "user_id": "2404",
                "shortname": "AS",
                "initial": "a",
                "name": "Aman ",
                "last_name": "Singh",
                "avcolor": "cir-25",
                "question": "testing",
                "section_name": "Introduction",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "June 08, 2022 09:26 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "329",
                "course_id": "11",
                "user_id": "2393",
                "shortname": "ae",
                "initial": "a",
                "name": "as",
                "last_name": "ee",
                "avcolor": "cir-14",
                "question": "TEST123",
                "section_name": "Introduction",
                "total_votes": "1",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "June 08, 2022 07:25 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "356",
                        "ques_id": "329",
                        "user_id": "1832",
                        "is_star": "0",
                        "shortname": "AP",
                        "initial": "a",
                        "name": "Aman",
                        "last_name": "Pratap Singh",
                        "avcolor": "cir-25",
                        "answer": "errror11",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 08, 2022 07:26 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 1
            },
            {
                "id": "328",
                "course_id": "11",
                "user_id": "2395",
                "shortname": "vp",
                "initial": "v",
                "name": "veullu",
                "last_name": "prennilo",
                "avcolor": "cir-16",
                "question": "Hello",
                "section_name": "Introduction",
                "total_votes": "2",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "June 08, 2022 07:05 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "355",
                        "ques_id": "328",
                        "user_id": "2345",
                        "is_star": "0",
                        "shortname": "cp",
                        "initial": "c",
                        "name": "cruta",
                        "last_name": "pusojoi",
                        "avcolor": "cir-18",
                        "answer": "hi\n",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 08, 2022 07:25 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "357",
                        "ques_id": "328",
                        "user_id": "2333",
                        "is_star": "0",
                        "shortname": "kf",
                        "initial": "k",
                        "name": "keuttique",
                        "last_name": "frufau",
                        "avcolor": "cir-6",
                        "answer": "hi\n",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 08, 2022 07:27 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 2
            },
            {
                "id": "327",
                "course_id": "11",
                "user_id": "2393",
                "shortname": "ae",
                "initial": "a",
                "name": "as",
                "last_name": "ee",
                "avcolor": "cir-14",
                "question": "error12",
                "section_name": "Introduction",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "June 08, 2022 07:02 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "354",
                        "ques_id": "327",
                        "user_id": "1832",
                        "is_star": "0",
                        "shortname": "AP",
                        "initial": "a",
                        "name": "Aman",
                        "last_name": "Pratap Singh",
                        "avcolor": "cir-25",
                        "answer": "error2",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 08, 2022 07:21 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 1
            },
            {
                "id": "326",
                "course_id": "11",
                "user_id": "2312",
                "shortname": "55",
                "initial": "5",
                "name": "57",
                "last_name": "57",
                "avcolor": "cir-11",
                "question": "error",
                "section_name": "Introduction",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "June 06, 2022 09:14 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "352",
                        "ques_id": "326",
                        "user_id": "1",
                        "is_star": "0",
                        "shortname": "SA",
                        "initial": "s",
                        "name": "SmarterChains",
                        "last_name": "Admin",
                        "avcolor": "cir-1",
                        "answer": "error",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 06, 2022 09:15 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 1
            },
            {
                "id": "325",
                "course_id": "11",
                "user_id": "2283",
                "shortname": "vh",
                "initial": "v",
                "name": "v",
                "last_name": "h",
                "avcolor": "cir-8",
                "question": "y",
                "section_name": "Introduction",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "June 02, 2022 03:17 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "324",
                "course_id": "11",
                "user_id": "2227",
                "shortname": "PA",
                "initial": "p",
                "name": "Pedro de la maria",
                "last_name": "Angus de le alpi",
                "avcolor": "cir-4",
                "question": "55",
                "section_name": "Introduction",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "June 02, 2022 01:10 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "351",
                        "ques_id": "324",
                        "user_id": "1",
                        "is_star": "0",
                        "shortname": "SA",
                        "initial": "s",
                        "name": "SmarterChains",
                        "last_name": "Admin",
                        "avcolor": "cir-1",
                        "answer": "5",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 02, 2022 01:11 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 1
            },
            {
                "id": "323",
                "course_id": "11",
                "user_id": "2050",
                "shortname": "u1",
                "initial": "u",
                "name": "user",
                "last_name": "1",
                "avcolor": "cir-9",
                "question": "15:13 GR",
                "section_name": "Introduction",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "May 26, 2022 12:13 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "350",
                        "ques_id": "323",
                        "user_id": "1",
                        "is_star": "0",
                        "shortname": "SA",
                        "initial": "s",
                        "name": "SmarterChains",
                        "last_name": "Admin",
                        "avcolor": "cir-1",
                        "answer": "45",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "May 26, 2022 12:13 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 1
            },
            {
                "id": "320",
                "course_id": "11",
                "user_id": "1786",
                "shortname": "AS",
                "initial": "a",
                "name": "Aman ",
                "last_name": "Singh",
                "avcolor": "cir-5",
                "question": "Test Pre",
                "section_name": "Introduction",
                "total_votes": "1",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "May 26, 2022 10:34 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "345",
                        "ques_id": "320",
                        "user_id": "1",
                        "is_star": "0",
                        "shortname": "SA",
                        "initial": "s",
                        "name": "SmarterChains",
                        "last_name": "Admin",
                        "avcolor": "cir-1",
                        "answer": "Yes This Is",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "May 26, 2022 10:35 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "346",
                        "ques_id": "320",
                        "user_id": "1786",
                        "is_star": "0",
                        "shortname": "AS",
                        "initial": "a",
                        "name": "Aman ",
                        "last_name": "Singh",
                        "avcolor": "cir-5",
                        "answer": "No ",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "May 26, 2022 04:06 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "347",
                        "ques_id": "320",
                        "user_id": "1786",
                        "is_star": "0",
                        "shortname": "AS",
                        "initial": "a",
                        "name": "Aman ",
                        "last_name": "Singh",
                        "avcolor": "cir-5",
                        "answer": "no no",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "May 26, 2022 10:41 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "353",
                        "ques_id": "320",
                        "user_id": "2393",
                        "is_star": "0",
                        "shortname": "ae",
                        "initial": "a",
                        "name": "as",
                        "last_name": "ee",
                        "avcolor": "cir-14",
                        "answer": "testing1233",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "June 08, 2022 07:01 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 4
            },
            {
                "id": "319",
                "course_id": "11",
                "user_id": "1786",
                "shortname": "AS",
                "initial": "a",
                "name": "Aman ",
                "last_name": "Singh",
                "avcolor": "cir-5",
                "question": "Pr Test",
                "section_name": "Introduction",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "May 26, 2022 03:16 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "344",
                        "ques_id": "319",
                        "user_id": "1",
                        "is_star": "0",
                        "shortname": "SA",
                        "initial": "s",
                        "name": "SmarterChains",
                        "last_name": "Admin",
                        "avcolor": "cir-1",
                        "answer": "Pre Test",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "May 26, 2022 10:16 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 1
            },
            {
                "id": "318",
                "course_id": "11",
                "user_id": "1786",
                "shortname": "AS",
                "initial": "a",
                "name": "Aman ",
                "last_name": "Singh",
                "avcolor": "cir-5",
                "question": "ttest",
                "section_name": "Introduction",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "May 26, 2022 03:04 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "343",
                        "ques_id": "318",
                        "user_id": "1786",
                        "is_star": "0",
                        "shortname": "AS",
                        "initial": "a",
                        "name": "Aman ",
                        "last_name": "Singh",
                        "avcolor": "cir-5",
                        "answer": "5451",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "May 26, 2022 03:04 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 1
            },
            {
                "id": "316",
                "course_id": "11",
                "user_id": "2140",
                "shortname": "AS",
                "initial": "a",
                "name": "Aman ",
                "last_name": "Singh",
                "avcolor": "cir-21",
                "question": "test",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "May 26, 2022 02:50 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "341",
                        "ques_id": "316",
                        "user_id": "2140",
                        "is_star": "0",
                        "shortname": "AS",
                        "initial": "a",
                        "name": "Aman ",
                        "last_name": "Singh",
                        "avcolor": "cir-21",
                        "answer": "yess",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "May 26, 2022 02:53 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 1
            },
            {
                "id": "315",
                "course_id": "11",
                "user_id": "2053",
                "shortname": "55",
                "initial": "5",
                "name": "52",
                "last_name": "52",
                "avcolor": "cir-12",
                "question": "11:48 GR",
                "section_name": "Introduction",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "May 26, 2022 11:48 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "340",
                        "ques_id": "315",
                        "user_id": "1",
                        "is_star": "0",
                        "shortname": "SA",
                        "initial": "s",
                        "name": "SmarterChains",
                        "last_name": "Admin",
                        "avcolor": "cir-1",
                        "answer": "hi Q&A",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "May 26, 2022 08:49 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 1
            },
            {
                "id": "313",
                "course_id": "11",
                "user_id": "2039",
                "shortname": "55",
                "initial": "5",
                "name": "51",
                "last_name": "51",
                "avcolor": "cir-24",
                "question": "14:21 GR",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "May 24, 2022 02:21 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "338",
                        "ques_id": "313",
                        "user_id": "1",
                        "is_star": "0",
                        "shortname": "SA",
                        "initial": "s",
                        "name": "SmarterChains",
                        "last_name": "Admin",
                        "avcolor": "cir-1",
                        "answer": "55",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "May 24, 2022 02:22 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 1
            },
            {
                "id": "312",
                "course_id": "11",
                "user_id": "2106",
                "shortname": "AB",
                "initial": "a",
                "name": "Ajdjnd",
                "last_name": "Bjajdj",
                "avcolor": "cir-13",
                "question": "gghjghj hggggggggggggggggggggggggggggggg knklugiluiopppppppppppppppppppppppppppp",
                "section_name": "Factory of the Future",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "May 23, 2022 01:28 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "311",
                "course_id": "11",
                "user_id": "2074",
                "shortname": "JD",
                "initial": "j",
                "name": "John",
                "last_name": "Due",
                "avcolor": "cir-7",
                "question": "heloo",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "May 19, 2022 01:39 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "310",
                "course_id": "11",
                "user_id": "2057",
                "shortname": "AS",
                "initial": "a",
                "name": "Aman ",
                "last_name": "Singh",
                "avcolor": "cir-16",
                "question": "Testtt",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "1",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "May 13, 2022 03:32 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "336",
                        "ques_id": "310",
                        "user_id": "2059",
                        "is_star": "0",
                        "shortname": "AF",
                        "initial": "a",
                        "name": "AS",
                        "last_name": "FF",
                        "avcolor": "cir-18",
                        "answer": "Test",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "May 18, 2022 11:45 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 1
            },
            {
                "id": "309",
                "course_id": "11",
                "user_id": "1180",
                "shortname": "JD",
                "initial": "j",
                "name": "Jim",
                "last_name": "Dem",
                "avcolor": "cir-1",
                "question": "New question",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "May 04, 2022 02:44 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "335",
                        "ques_id": "309",
                        "user_id": "1",
                        "is_star": "0",
                        "shortname": "SA",
                        "initial": "s",
                        "name": "SmarterChains",
                        "last_name": "Admin",
                        "avcolor": "cir-1",
                        "answer": "new answer from admin",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "May 04, 2022 02:44 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [
                            {
                                "id": "237",
                                "ans_id": "335",
                                "user_id": "1180",
                                "is_star": "0",
                                "shortname": "JD",
                                "initial": "j",
                                "name": "Jim",
                                "last_name": "Dem",
                                "avcolor": "cir-1",
                                "answer": "follow up",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Industry 4.0 Transformation Case Study",
                                "like": "",
                                "datecreated": "May 04, 2022 02:45 PM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            }
                        ],
                        "total_reply": 1
                    }
                ],
                "total_ans": 2
            },
            {
                "id": "308",
                "course_id": "11",
                "user_id": "1943",
                "shortname": "33",
                "initial": "3",
                "name": "32",
                "last_name": "32",
                "avcolor": "cir-6",
                "question": "df",
                "section_name": "Introduction",
                "total_votes": "1",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "February 21, 2022 09:54 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "331",
                        "ques_id": "308",
                        "user_id": "152",
                        "is_star": "0",
                        "shortname": "NM",
                        "initial": "n",
                        "name": "Neos",
                        "last_name": "Mousakas",
                        "avcolor": "cir-16",
                        "answer": "new",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "April 18, 2022 05:05 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [
                            {
                                "id": "219",
                                "ans_id": "331",
                                "user_id": "152",
                                "is_star": "0",
                                "shortname": "NM",
                                "initial": "n",
                                "name": "Neos",
                                "last_name": "Mousakas",
                                "avcolor": "cir-16",
                                "answer": "sss",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Introduction",
                                "like": "",
                                "datecreated": "April 29, 2022 03:12 PM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            }
                        ],
                        "total_reply": 1
                    }
                ],
                "total_ans": 2
            },
            {
                "id": "307",
                "course_id": "11",
                "user_id": "1102",
                "shortname": "ss",
                "initial": "s",
                "name": "shubhesh",
                "last_name": "srivastava",
                "avcolor": "cir-7",
                "question": "new template testing\n",
                "section_name": "Introduction",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "February 18, 2022 10:48 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "327",
                        "ques_id": "307",
                        "user_id": "1838",
                        "is_star": "0",
                        "shortname": "ss",
                        "initial": "s",
                        "name": "shubh",
                        "last_name": "srivastava",
                        "avcolor": "cir-5",
                        "answer": "reply testing template\n",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "February 18, 2022 10:49 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [
                            {
                                "id": "224",
                                "ans_id": "327",
                                "user_id": "1330",
                                "is_star": "0",
                                "shortname": "AK",
                                "initial": "a",
                                "name": "Amit",
                                "last_name": "Kumar",
                                "avcolor": "cir-19",
                                "answer": "hello Shubh",
                                "total_votes": "0",
                                "is_edited": "1",
                                "section_name": "Introduction",
                                "like": "",
                                "datecreated": "May 02, 2022 10:56 AM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            },
                            {
                                "id": "225",
                                "ans_id": "327",
                                "user_id": "1330",
                                "is_star": "0",
                                "shortname": "AK",
                                "initial": "a",
                                "name": "Amit",
                                "last_name": "Kumar",
                                "avcolor": "cir-19",
                                "answer": "Hi",
                                "total_votes": "0",
                                "is_edited": "1",
                                "section_name": "Introduction",
                                "like": "",
                                "datecreated": "May 02, 2022 11:06 AM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            },
                            {
                                "id": "226",
                                "ans_id": "327",
                                "user_id": "1330",
                                "is_star": "0",
                                "shortname": "AK",
                                "initial": "a",
                                "name": "Amit",
                                "last_name": "Kumar",
                                "avcolor": "cir-19",
                                "answer": "hixvvcvcvcvcvcv",
                                "total_votes": "0",
                                "is_edited": "1",
                                "section_name": "Introduction",
                                "like": "",
                                "datecreated": "May 02, 2022 11:34 AM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            }
                        ],
                        "total_reply": 3
                    },
                    {
                        "id": "334",
                        "ques_id": "307",
                        "user_id": "1330",
                        "is_star": "0",
                        "shortname": "AK",
                        "initial": "a",
                        "name": "Amit",
                        "last_name": "Kumar",
                        "avcolor": "cir-19",
                        "answer": "hi",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "May 02, 2022 10:55 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 5
            },
            {
                "id": "306",
                "course_id": "11",
                "user_id": "152",
                "shortname": "NM",
                "initial": "n",
                "name": "Neos",
                "last_name": "Mousakas",
                "avcolor": "cir-16",
                "question": "shubhesh testing\n",
                "section_name": "SmarterChains",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "February 17, 2022 11:50 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "326",
                        "ques_id": "306",
                        "user_id": "1330",
                        "is_star": "0",
                        "shortname": "AK",
                        "initial": "a",
                        "name": "Amit",
                        "last_name": "Kumar",
                        "avcolor": "cir-19",
                        "answer": "comment testing\n",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "February 17, 2022 11:51 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [
                            {
                                "id": "218",
                                "ans_id": "326",
                                "user_id": "1",
                                "is_star": "0",
                                "shortname": "SA",
                                "initial": "s",
                                "name": "SmarterChains",
                                "last_name": "Admin",
                                "avcolor": "cir-1",
                                "answer": "new reply",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "SmarterChains",
                                "like": "",
                                "datecreated": "February 17, 2022 01:15 PM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            }
                        ],
                        "total_reply": 1
                    }
                ],
                "total_ans": 2
            },
            {
                "id": "305",
                "course_id": "11",
                "user_id": "1773",
                "shortname": "ss",
                "initial": "s",
                "name": "shruti",
                "last_name": "singh",
                "avcolor": "cir-18",
                "question": "testing",
                "section_name": "Introduction",
                "total_votes": "1",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "February 16, 2022 03:26 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "325",
                        "ques_id": "305",
                        "user_id": "1314",
                        "is_star": "0",
                        "shortname": "AS",
                        "initial": "a",
                        "name": "Aman ",
                        "last_name": "Singh",
                        "avcolor": "cir-3",
                        "answer": "test",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "February 16, 2022 03:28 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [
                            {
                                "id": "222",
                                "ans_id": "325",
                                "user_id": "1330",
                                "is_star": "0",
                                "shortname": "AK",
                                "initial": "a",
                                "name": "Amit",
                                "last_name": "Kumar",
                                "avcolor": "cir-19",
                                "answer": "Hello",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Introduction",
                                "like": "",
                                "datecreated": "April 29, 2022 07:40 PM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            },
                            {
                                "id": "223",
                                "ans_id": "325",
                                "user_id": "1330",
                                "is_star": "0",
                                "shortname": "AK",
                                "initial": "a",
                                "name": "Amit",
                                "last_name": "Kumar",
                                "avcolor": "cir-19",
                                "answer": "yes",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Introduction",
                                "like": "",
                                "datecreated": "April 29, 2022 07:46 PM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            }
                        ],
                        "total_reply": 2
                    },
                    {
                        "id": "333",
                        "ques_id": "305",
                        "user_id": "1330",
                        "is_star": "0",
                        "shortname": "AK",
                        "initial": "a",
                        "name": "Amit",
                        "last_name": "Kumar",
                        "avcolor": "cir-19",
                        "answer": "yes",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "April 29, 2022 07:46 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "337",
                        "ques_id": "305",
                        "user_id": "1",
                        "is_star": "0",
                        "shortname": "SA",
                        "initial": "s",
                        "name": "SmarterChains",
                        "last_name": "Admin",
                        "avcolor": "cir-1",
                        "answer": "FDZGDFH",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "May 20, 2022 11:35 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 5
            },
            {
                "id": "304",
                "course_id": "11",
                "user_id": "1314",
                "shortname": "AS",
                "initial": "a",
                "name": "Aman ",
                "last_name": "Singh",
                "avcolor": "cir-3",
                "question": "shruti test",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "February 16, 2022 03:22 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "303",
                "course_id": "11",
                "user_id": "1714",
                "shortname": "AS",
                "initial": "a",
                "name": "Aman ",
                "last_name": "Singh",
                "avcolor": "cir-11",
                "question": "test123",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "February 16, 2022 03:10 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "323",
                        "ques_id": "303",
                        "user_id": "1314",
                        "is_star": "0",
                        "shortname": "AS",
                        "initial": "a",
                        "name": "Aman ",
                        "last_name": "Singh",
                        "avcolor": "cir-3",
                        "answer": "shruti",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "February 16, 2022 03:22 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "324",
                        "ques_id": "303",
                        "user_id": "1773",
                        "is_star": "0",
                        "shortname": "ss",
                        "initial": "s",
                        "name": "shruti",
                        "last_name": "singh",
                        "avcolor": "cir-18",
                        "answer": "testing",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "February 16, 2022 03:25 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 2
            },
            {
                "id": "302",
                "course_id": "11",
                "user_id": "1123",
                "shortname": "MP",
                "initial": "m",
                "name": "Martha",
                "last_name": "Pontika",
                "avcolor": "cir-22",
                "question": "new",
                "section_name": "Research & Development in Industry 4.0",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "February 16, 2022 09:32 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "320",
                        "ques_id": "302",
                        "user_id": "1571",
                        "is_star": "0",
                        "shortname": "ee",
                        "initial": "e",
                        "name": "ew",
                        "last_name": "eww",
                        "avcolor": "cir-24",
                        "answer": "wqwq",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "February 16, 2022 09:32 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 1
            },
            {
                "id": "300",
                "course_id": "11",
                "user_id": "1714",
                "shortname": "AS",
                "initial": "a",
                "name": "Aman ",
                "last_name": "Singh",
                "avcolor": "cir-11",
                "question": "test123\n",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "2",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "February 15, 2022 03:10 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "315",
                        "ques_id": "300",
                        "user_id": "1314",
                        "is_star": "0",
                        "shortname": "AS",
                        "initial": "a",
                        "name": "Aman ",
                        "last_name": "Singh",
                        "avcolor": "cir-3",
                        "answer": "shruti",
                        "opted": 0,
                        "total_votes": "1",
                        "is_edited": "1",
                        "like": "",
                        "datecreated": "February 15, 2022 03:54 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "316",
                        "ques_id": "300",
                        "user_id": "1714",
                        "is_star": "0",
                        "shortname": "AS",
                        "initial": "a",
                        "name": "Aman ",
                        "last_name": "Singh",
                        "avcolor": "cir-11",
                        "answer": "testing11",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "February 15, 2022 07:27 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 2
            },
            {
                "id": "299",
                "course_id": "11",
                "user_id": "1648",
                "shortname": "sr",
                "initial": "s",
                "name": "sangeeta",
                "last_name": "rathore",
                "avcolor": "cir-23",
                "question": "hygt sdwdwd ?",
                "section_name": "Introduction",
                "total_votes": "1",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "February 15, 2022 02:41 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "313",
                        "ques_id": "299",
                        "user_id": "1330",
                        "is_star": "0",
                        "shortname": "AK",
                        "initial": "a",
                        "name": "Amit",
                        "last_name": "Kumar",
                        "avcolor": "cir-19",
                        "answer": "sfcsff",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "February 15, 2022 02:42 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 1
            },
            {
                "id": "298",
                "course_id": "11",
                "user_id": "152",
                "shortname": "NM",
                "initial": "n",
                "name": "Neos",
                "last_name": "Mousakas",
                "avcolor": "cir-16",
                "question": "working tejjkklllllkhjg",
                "section_name": "SmarterChains",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "February 15, 2022 02:36 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "297",
                "course_id": "11",
                "user_id": "1648",
                "shortname": "sr",
                "initial": "s",
                "name": "sangeeta",
                "last_name": "rathore",
                "avcolor": "cir-23",
                "question": "how  do you do?",
                "section_name": "Introduction",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "February 15, 2022 02:31 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "312",
                        "ques_id": "297",
                        "user_id": "1330",
                        "is_star": "0",
                        "shortname": "AK",
                        "initial": "a",
                        "name": "Amit",
                        "last_name": "Kumar",
                        "avcolor": "cir-19",
                        "answer": "work",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "February 15, 2022 02:32 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [
                            {
                                "id": "217",
                                "ans_id": "312",
                                "user_id": "152",
                                "is_star": "0",
                                "shortname": "NM",
                                "initial": "n",
                                "name": "Neos",
                                "last_name": "Mousakas",
                                "avcolor": "cir-16",
                                "answer": "dsfg",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Introduction",
                                "like": "",
                                "datecreated": "February 16, 2022 02:08 PM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            }
                        ],
                        "total_reply": 1
                    }
                ],
                "total_ans": 2
            },
            {
                "id": "296",
                "course_id": "11",
                "user_id": "1905",
                "shortname": "TQ",
                "initial": "t",
                "name": "Testing",
                "last_name": "Qa",
                "avcolor": "cir-20",
                "question": "hellosdfsfsfsdfsdf",
                "section_name": "Research & Development in Industry 4.0",
                "total_votes": "0",
                "is_edited": "1",
                "follow": 0,
                "like": "",
                "datecreated": "February 09, 2022 01:44 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "306",
                        "ques_id": "296",
                        "user_id": "1123",
                        "is_star": "0",
                        "shortname": "MP",
                        "initial": "m",
                        "name": "Martha",
                        "last_name": "Pontika",
                        "avcolor": "cir-22",
                        "answer": "123456",
                        "opted": 0,
                        "total_votes": "1",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "February 09, 2022 01:44 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "314",
                        "ques_id": "296",
                        "user_id": "1314",
                        "is_star": "0",
                        "shortname": "AS",
                        "initial": "a",
                        "name": "Aman ",
                        "last_name": "Singh",
                        "avcolor": "cir-3",
                        "answer": "test123",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "February 15, 2022 03:51 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "319",
                        "ques_id": "296",
                        "user_id": "1571",
                        "is_star": "0",
                        "shortname": "ee",
                        "initial": "e",
                        "name": "ew",
                        "last_name": "eww",
                        "avcolor": "cir-24",
                        "answer": "aihkhf",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "February 16, 2022 09:32 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 3
            },
            {
                "id": "295",
                "course_id": "11",
                "user_id": "1905",
                "shortname": "TQ",
                "initial": "t",
                "name": "Testing",
                "last_name": "Qa",
                "avcolor": "cir-20",
                "question": "Tips on raising a question   WWWWWWWWW1111111111111@hhhhkhhkddd325\n\nUse the search box to make sure your question is unique\nKeep your question relevant to this training courseAadawvq3wqw4eaebr",
                "section_name": "Research & Development in Industry 4.0",
                "total_votes": "2",
                "is_edited": "1",
                "follow": 0,
                "like": "",
                "datecreated": "February 09, 2022 12:55 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "304",
                        "ques_id": "295",
                        "user_id": "1905",
                        "is_star": "0",
                        "shortname": "TQ",
                        "initial": "t",
                        "name": "Testing",
                        "last_name": "Qa",
                        "avcolor": "cir-20",
                        "answer": "SADFfqRQ",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "February 09, 2022 12:56 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 1
            },
            {
                "id": "294",
                "course_id": "11",
                "user_id": "941",
                "shortname": "vv",
                "initial": "v",
                "name": "vvv",
                "last_name": "vvv",
                "avcolor": "cir-6",
                "question": "kjgy",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "1",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "February 09, 2022 12:47 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "302",
                        "ques_id": "294",
                        "user_id": "1887",
                        "is_star": "0",
                        "shortname": "tr",
                        "initial": "t",
                        "name": "trareilo",
                        "last_name": "rikei",
                        "avcolor": "cir-2",
                        "answer": "iyiu",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "February 09, 2022 12:48 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "303",
                        "ques_id": "294",
                        "user_id": "1097",
                        "is_star": "0",
                        "shortname": "AL",
                        "initial": "a",
                        "name": "Amarillis",
                        "last_name": "Loufardaki",
                        "avcolor": "cir-3",
                        "answer": "oy",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "February 09, 2022 12:49 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 2
            },
            {
                "id": "293",
                "course_id": "11",
                "user_id": "1887",
                "shortname": "tr",
                "initial": "t",
                "name": "trareilo",
                "last_name": "rikei",
                "avcolor": "cir-2",
                "question": "fs\\iugh",
                "section_name": "SmarterChains",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "February 09, 2022 12:47 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "292",
                "course_id": "11",
                "user_id": "1905",
                "shortname": "TQ",
                "initial": "t",
                "name": "Testing",
                "last_name": "Qa",
                "avcolor": "cir-20",
                "question": "NEW1",
                "section_name": "Industry 4.0",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "February 09, 2022 12:39 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "283",
                "course_id": "11",
                "user_id": "1618",
                "shortname": "SS",
                "initial": "s",
                "name": "Shruti",
                "last_name": "Sharma",
                "avcolor": "cir-19",
                "question": "test",
                "section_name": "Introduction",
                "total_votes": "3",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "February 09, 2022 11:36 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "322",
                        "ques_id": "283",
                        "user_id": "1314",
                        "is_star": "0",
                        "shortname": "AS",
                        "initial": "a",
                        "name": "Aman ",
                        "last_name": "Singh",
                        "avcolor": "cir-3",
                        "answer": "testing123",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "February 16, 2022 03:13 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 1
            },
            {
                "id": "282",
                "course_id": "11",
                "user_id": "1714",
                "shortname": "AS",
                "initial": "a",
                "name": "Aman ",
                "last_name": "Singh",
                "avcolor": "cir-11",
                "question": "testgjugkij\n\\",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "February 09, 2022 11:34 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "281",
                "course_id": "11",
                "user_id": "1714",
                "shortname": "AS",
                "initial": "a",
                "name": "Aman ",
                "last_name": "Singh",
                "avcolor": "cir-11",
                "question": "test",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "1",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "February 09, 2022 11:24 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "291",
                        "ques_id": "281",
                        "user_id": "1714",
                        "is_star": "0",
                        "shortname": "AS",
                        "initial": "a",
                        "name": "Aman ",
                        "last_name": "Singh",
                        "avcolor": "cir-11",
                        "answer": "test12",
                        "opted": 0,
                        "total_votes": "1",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "February 09, 2022 11:25 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 1
            },
            {
                "id": "280",
                "course_id": "11",
                "user_id": "1832",
                "shortname": "AP",
                "initial": "a",
                "name": "Aman",
                "last_name": "Pratap Singh",
                "avcolor": "cir-25",
                "question": "test123",
                "section_name": "Introduction",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "February 09, 2022 10:52 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "277",
                "course_id": "11",
                "user_id": "1901",
                "shortname": "I1",
                "initial": "i",
                "name": "Invite",
                "last_name": "1",
                "avcolor": "cir-16",
                "question": "new q",
                "section_name": "Introduction",
                "total_votes": "1",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "February 08, 2022 12:50 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "289",
                        "ques_id": "277",
                        "user_id": "941",
                        "is_star": "0",
                        "shortname": "vv",
                        "initial": "v",
                        "name": "vvv",
                        "last_name": "vvv",
                        "avcolor": "cir-6",
                        "answer": "response\n",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "February 08, 2022 12:52 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 1
            },
            {
                "id": "276",
                "course_id": "11",
                "user_id": "1330",
                "shortname": "AK",
                "initial": "a",
                "name": "Amit",
                "last_name": "Kumar",
                "avcolor": "cir-19",
                "question": "this is a new question",
                "section_name": "Innovation",
                "total_votes": "3",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "February 08, 2022 12:38 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "287",
                        "ques_id": "276",
                        "user_id": "1330",
                        "is_star": "0",
                        "shortname": "AK",
                        "initial": "a",
                        "name": "Amit",
                        "last_name": "Kumar",
                        "avcolor": "cir-19",
                        "answer": "this is reply",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "February 08, 2022 12:39 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "288",
                        "ques_id": "276",
                        "user_id": "1889",
                        "is_star": "0",
                        "shortname": "AK",
                        "initial": "a",
                        "name": "Amit",
                        "last_name": "Kumar",
                        "avcolor": "cir-4",
                        "answer": "This is Amit's reply",
                        "opted": 0,
                        "total_votes": "1",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "February 08, 2022 12:44 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 2
            },
            {
                "id": "275",
                "course_id": "11",
                "user_id": "1890",
                "shortname": "xs",
                "initial": "x",
                "name": "xdas ",
                "last_name": "sdasdawdad",
                "avcolor": "cir-5",
                "question": "Search questions",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "1",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "February 07, 2022 04:17 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "286",
                        "ques_id": "275",
                        "user_id": "1571",
                        "is_star": "0",
                        "shortname": "ee",
                        "initial": "e",
                        "name": "ew",
                        "last_name": "eww",
                        "avcolor": "cir-24",
                        "answer": "??????",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "February 07, 2022 04:17 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 1
            },
            {
                "id": "274",
                "course_id": "11",
                "user_id": "1180",
                "shortname": "JD",
                "initial": "j",
                "name": "Jim",
                "last_name": "Dem",
                "avcolor": "cir-1",
                "question": "new Q\nDeme",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "1",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "February 07, 2022 12:45 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "267",
                "course_id": "11",
                "user_id": "1884",
                "shortname": "TT",
                "initial": "t",
                "name": "Testing",
                "last_name": "Test",
                "avcolor": "cir-25",
                "question": "newQ",
                "section_name": "Industry 4.0",
                "total_votes": "3",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "February 07, 2022 10:29 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "280",
                        "ques_id": "267",
                        "user_id": "1884",
                        "is_star": "0",
                        "shortname": "TT",
                        "initial": "t",
                        "name": "Testing",
                        "last_name": "Test",
                        "avcolor": "cir-25",
                        "answer": "another one",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "February 07, 2022 10:58 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "281",
                        "ques_id": "267",
                        "user_id": "1571",
                        "is_star": "0",
                        "shortname": "ee",
                        "initial": "e",
                        "name": "ew",
                        "last_name": "eww",
                        "avcolor": "cir-24",
                        "answer": "new answer",
                        "opted": 1,
                        "total_votes": "1",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "February 07, 2022 11:02 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "282",
                        "ques_id": "267",
                        "user_id": "1884",
                        "is_star": "0",
                        "shortname": "TT",
                        "initial": "t",
                        "name": "Testing",
                        "last_name": "Test",
                        "avcolor": "cir-25",
                        "answer": "replying",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "February 07, 2022 11:17 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 3
            },
            {
                "id": "265",
                "course_id": "11",
                "user_id": "1866",
                "shortname": "22",
                "initial": "2",
                "name": "23",
                "last_name": "23",
                "avcolor": "cir-7",
                "question": "test 3\/2",
                "section_name": "Introduction",
                "total_votes": "1",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "February 03, 2022 11:50 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "277",
                        "ques_id": "265",
                        "user_id": "1",
                        "is_star": "0",
                        "shortname": "SA",
                        "initial": "s",
                        "name": "SmarterChains",
                        "last_name": "Admin",
                        "avcolor": "cir-1",
                        "answer": "9478",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "February 03, 2022 11:50 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 1
            },
            {
                "id": "263",
                "course_id": "11",
                "user_id": "1562",
                "shortname": "vv",
                "initial": "v",
                "name": "vinod",
                "last_name": "valsan",
                "avcolor": "cir-15",
                "question": "Test-question 3",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "2",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "January 10, 2022 03:53 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "273",
                        "ques_id": "263",
                        "user_id": "1696",
                        "is_star": "0",
                        "shortname": "vv",
                        "initial": "v",
                        "name": "vinod",
                        "last_name": "v",
                        "avcolor": "cir-19",
                        "answer": "test",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "January 10, 2022 03:53 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "275",
                        "ques_id": "263",
                        "user_id": "1410",
                        "is_star": "0",
                        "shortname": "AM",
                        "initial": "a",
                        "name": "ASHutosh",
                        "last_name": "Mishra",
                        "avcolor": "cir-21",
                        "answer": "test",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "January 14, 2022 04:08 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 2
            },
            {
                "id": "259",
                "course_id": "11",
                "user_id": "1677",
                "shortname": "aa",
                "initial": "a",
                "name": "a",
                "last_name": "a",
                "avcolor": "cir-26",
                "question": "NEW 7",
                "section_name": "Introduction",
                "total_votes": "1",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "January 05, 2022 11:26 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "269",
                        "ques_id": "259",
                        "user_id": "1",
                        "is_star": "0",
                        "shortname": "SA",
                        "initial": "s",
                        "name": "SmarterChains",
                        "last_name": "Admin",
                        "avcolor": "cir-1",
                        "answer": "Answer from admin",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "January 05, 2022 11:46 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 1
            },
            {
                "id": "258",
                "course_id": "11",
                "user_id": "1677",
                "shortname": "aa",
                "initial": "a",
                "name": "a",
                "last_name": "a",
                "avcolor": "cir-26",
                "question": "NEW 6",
                "section_name": "Introduction",
                "total_votes": "1",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "January 05, 2022 11:25 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "257",
                "course_id": "11",
                "user_id": "1677",
                "shortname": "aa",
                "initial": "a",
                "name": "a",
                "last_name": "a",
                "avcolor": "cir-26",
                "question": "NEW 5",
                "section_name": "Introduction",
                "total_votes": "1",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "January 05, 2022 11:24 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "256",
                "course_id": "11",
                "user_id": "1677",
                "shortname": "aa",
                "initial": "a",
                "name": "a",
                "last_name": "a",
                "avcolor": "cir-26",
                "question": "1",
                "section_name": "Introduction",
                "total_votes": "1",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "January 05, 2022 11:22 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "255",
                "course_id": "11",
                "user_id": "1677",
                "shortname": "aa",
                "initial": "a",
                "name": "a",
                "last_name": "a",
                "avcolor": "cir-26",
                "question": "25",
                "section_name": "Introduction",
                "total_votes": "1",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "January 05, 2022 11:14 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "254",
                "course_id": "11",
                "user_id": "1677",
                "shortname": "aa",
                "initial": "a",
                "name": "a",
                "last_name": "a",
                "avcolor": "cir-26",
                "question": "20",
                "section_name": "Introduction",
                "total_votes": "1",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "January 05, 2022 11:14 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "253",
                "course_id": "11",
                "user_id": "1677",
                "shortname": "aa",
                "initial": "a",
                "name": "a",
                "last_name": "a",
                "avcolor": "cir-26",
                "question": "25",
                "section_name": "Introduction",
                "total_votes": "1",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "January 05, 2022 11:12 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "252",
                "course_id": "11",
                "user_id": "1677",
                "shortname": "aa",
                "initial": "a",
                "name": "a",
                "last_name": "a",
                "avcolor": "cir-26",
                "question": "20",
                "section_name": "Introduction",
                "total_votes": "1",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "January 05, 2022 11:12 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "251",
                "course_id": "11",
                "user_id": "1677",
                "shortname": "aa",
                "initial": "a",
                "name": "a",
                "last_name": "a",
                "avcolor": "cir-26",
                "question": "20",
                "section_name": "Introduction",
                "total_votes": "1",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "January 05, 2022 11:11 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "250",
                "course_id": "11",
                "user_id": "1677",
                "shortname": "aa",
                "initial": "a",
                "name": "a",
                "last_name": "a",
                "avcolor": "cir-26",
                "question": "10",
                "section_name": "Introduction",
                "total_votes": "1",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "January 05, 2022 11:11 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "249",
                "course_id": "11",
                "user_id": "1680",
                "shortname": "sa",
                "initial": "s",
                "name": "s",
                "last_name": "a",
                "avcolor": "cir-3",
                "question": "Tips on raising a question\n\nUse the search box to make sure your question is unique\nKeep your question relevant to this training course",
                "section_name": "Introduction",
                "total_votes": "1",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "January 05, 2022 10:32 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "266",
                        "ques_id": "249",
                        "user_id": "1677",
                        "is_star": "0",
                        "shortname": "aa",
                        "initial": "a",
                        "name": "a",
                        "last_name": "a",
                        "avcolor": "cir-26",
                        "answer": "new1",
                        "opted": 1,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "January 05, 2022 10:33 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [
                            {
                                "id": "212",
                                "ans_id": "266",
                                "user_id": "1680",
                                "is_star": "0",
                                "shortname": "sa",
                                "initial": "s",
                                "name": "s",
                                "last_name": "a",
                                "avcolor": "cir-3",
                                "answer": "new2",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Introduction",
                                "like": "",
                                "datecreated": "January 05, 2022 10:34 AM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            },
                            {
                                "id": "213",
                                "ans_id": "266",
                                "user_id": "1680",
                                "is_star": "0",
                                "shortname": "sa",
                                "initial": "s",
                                "name": "s",
                                "last_name": "a",
                                "avcolor": "cir-3",
                                "answer": "new 3",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Introduction",
                                "like": "",
                                "datecreated": "January 05, 2022 10:34 AM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            },
                            {
                                "id": "214",
                                "ans_id": "266",
                                "user_id": "1677",
                                "is_star": "0",
                                "shortname": "aa",
                                "initial": "a",
                                "name": "a",
                                "last_name": "a",
                                "avcolor": "cir-26",
                                "answer": "new 4",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Introduction",
                                "like": "",
                                "datecreated": "January 05, 2022 10:36 AM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            },
                            {
                                "id": "215",
                                "ans_id": "266",
                                "user_id": "1680",
                                "is_star": "0",
                                "shortname": "sa",
                                "initial": "s",
                                "name": "s",
                                "last_name": "a",
                                "avcolor": "cir-3",
                                "answer": "new 5",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Introduction",
                                "like": "",
                                "datecreated": "January 05, 2022 10:44 AM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            },
                            {
                                "id": "216",
                                "ans_id": "266",
                                "user_id": "1680",
                                "is_star": "0",
                                "shortname": "sa",
                                "initial": "s",
                                "name": "s",
                                "last_name": "a",
                                "avcolor": "cir-3",
                                "answer": "new 6",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Introduction",
                                "like": "",
                                "datecreated": "January 05, 2022 10:45 AM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            }
                        ],
                        "total_reply": 5
                    },
                    {
                        "id": "267",
                        "ques_id": "249",
                        "user_id": "1677",
                        "is_star": "0",
                        "shortname": "aa",
                        "initial": "a",
                        "name": "a",
                        "last_name": "a",
                        "avcolor": "cir-26",
                        "answer": "1",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "January 05, 2022 10:35 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "268",
                        "ques_id": "249",
                        "user_id": "1677",
                        "is_star": "0",
                        "shortname": "aa",
                        "initial": "a",
                        "name": "a",
                        "last_name": "a",
                        "avcolor": "cir-26",
                        "answer": "2",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "January 05, 2022 10:35 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 8
            },
            {
                "id": "248",
                "course_id": "11",
                "user_id": "1097",
                "shortname": "AL",
                "initial": "a",
                "name": "Amarillis",
                "last_name": "Loufardaki",
                "avcolor": "cir-3",
                "question": "question",
                "section_name": "Introduction",
                "total_votes": "1",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "January 05, 2022 10:30 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "247",
                "course_id": "11",
                "user_id": "1673",
                "shortname": "qq",
                "initial": "q",
                "name": "q",
                "last_name": "q",
                "avcolor": "cir-22",
                "question": "New Comment 2",
                "section_name": "Introduction",
                "total_votes": "3",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "January 04, 2022 02:03 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "265",
                        "ques_id": "247",
                        "user_id": "1506",
                        "is_star": "0",
                        "shortname": "mv",
                        "initial": "m",
                        "name": "mv",
                        "last_name": "vm",
                        "avcolor": "cir-11",
                        "answer": "iadpisihjsx",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "January 04, 2022 04:16 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 1
            },
            {
                "id": "246",
                "course_id": "11",
                "user_id": "1673",
                "shortname": "qq",
                "initial": "q",
                "name": "q",
                "last_name": "q",
                "avcolor": "cir-22",
                "question": "New Comment 1",
                "section_name": "Introduction",
                "total_votes": "2",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "January 04, 2022 02:02 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "263",
                        "ques_id": "246",
                        "user_id": "1673",
                        "is_star": "0",
                        "shortname": "qq",
                        "initial": "q",
                        "name": "q",
                        "last_name": "q",
                        "avcolor": "cir-22",
                        "answer": "asas",
                        "opted": 0,
                        "total_votes": "1",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "January 04, 2022 02:05 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [
                            {
                                "id": "209",
                                "ans_id": "263",
                                "user_id": "1673",
                                "is_star": "0",
                                "shortname": "qq",
                                "initial": "q",
                                "name": "q",
                                "last_name": "q",
                                "avcolor": "cir-22",
                                "answer": "new",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Introduction",
                                "like": "",
                                "datecreated": "January 04, 2022 04:13 PM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            }
                        ],
                        "total_reply": 1
                    },
                    {
                        "id": "264",
                        "ques_id": "246",
                        "user_id": "1506",
                        "is_star": "0",
                        "shortname": "mv",
                        "initial": "m",
                        "name": "mv",
                        "last_name": "vm",
                        "avcolor": "cir-11",
                        "answer": "new question",
                        "opted": 1,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "January 04, 2022 02:21 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [
                            {
                                "id": "207",
                                "ans_id": "264",
                                "user_id": "1673",
                                "is_star": "0",
                                "shortname": "qq",
                                "initial": "q",
                                "name": "q",
                                "last_name": "q",
                                "avcolor": "cir-22",
                                "answer": "answer",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Introduction",
                                "like": "",
                                "datecreated": "January 04, 2022 02:24 PM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            },
                            {
                                "id": "208",
                                "ans_id": "264",
                                "user_id": "1673",
                                "is_star": "0",
                                "shortname": "qq",
                                "initial": "q",
                                "name": "q",
                                "last_name": "q",
                                "avcolor": "cir-22",
                                "answer": "hi",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Introduction",
                                "like": "",
                                "datecreated": "January 04, 2022 02:29 PM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            },
                            {
                                "id": "210",
                                "ans_id": "264",
                                "user_id": "1673",
                                "is_star": "0",
                                "shortname": "qq",
                                "initial": "q",
                                "name": "q",
                                "last_name": "q",
                                "avcolor": "cir-22",
                                "answer": "khh",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Introduction",
                                "like": "",
                                "datecreated": "January 04, 2022 04:13 PM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            },
                            {
                                "id": "211",
                                "ans_id": "264",
                                "user_id": "1673",
                                "is_star": "0",
                                "shortname": "qq",
                                "initial": "q",
                                "name": "q",
                                "last_name": "q",
                                "avcolor": "cir-22",
                                "answer": "ikkkkkkk",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Introduction",
                                "like": "",
                                "datecreated": "January 04, 2022 04:14 PM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            }
                        ],
                        "total_reply": 4
                    }
                ],
                "total_ans": 7
            },
            {
                "id": "244",
                "course_id": "11",
                "user_id": "1562",
                "shortname": "vv",
                "initial": "v",
                "name": "vinod",
                "last_name": "valsan",
                "avcolor": "cir-15",
                "question": "Test",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "2",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "January 04, 2022 04:29 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "262",
                        "ques_id": "244",
                        "user_id": "1672",
                        "is_star": "0",
                        "shortname": "AS",
                        "initial": "a",
                        "name": "Aman ",
                        "last_name": "Singh",
                        "avcolor": "cir-21",
                        "answer": "Test A",
                        "opted": 0,
                        "total_votes": "1",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "January 04, 2022 04:30 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [
                            {
                                "id": "201",
                                "ans_id": "262",
                                "user_id": "1562",
                                "is_star": "0",
                                "shortname": "vv",
                                "initial": "v",
                                "name": "vinod",
                                "last_name": "valsan",
                                "avcolor": "cir-15",
                                "answer": "Test V",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Industry 4.0 Transformation Case Study",
                                "like": "",
                                "datecreated": "January 04, 2022 04:33 PM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            }
                        ],
                        "total_reply": 1
                    }
                ],
                "total_ans": 2
            },
            {
                "id": "243",
                "course_id": "11",
                "user_id": "1672",
                "shortname": "AS",
                "initial": "a",
                "name": "Aman ",
                "last_name": "Singh",
                "avcolor": "cir-21",
                "question": "Testing",
                "section_name": "Introduction",
                "total_votes": "2",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "January 04, 2022 04:24 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "260",
                        "ques_id": "243",
                        "user_id": "1562",
                        "is_star": "0",
                        "shortname": "vv",
                        "initial": "v",
                        "name": "vinod",
                        "last_name": "valsan",
                        "avcolor": "cir-15",
                        "answer": "Test V",
                        "opted": 0,
                        "total_votes": "1",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "January 04, 2022 04:25 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "261",
                        "ques_id": "243",
                        "user_id": "1672",
                        "is_star": "0",
                        "shortname": "AS",
                        "initial": "a",
                        "name": "Aman ",
                        "last_name": "Singh",
                        "avcolor": "cir-21",
                        "answer": "Test A",
                        "opted": 0,
                        "total_votes": "2",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "January 04, 2022 04:27 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [
                            {
                                "id": "202",
                                "ans_id": "261",
                                "user_id": "1576",
                                "is_star": "0",
                                "shortname": "qq",
                                "initial": "q",
                                "name": "qa",
                                "last_name": "qa",
                                "avcolor": "cir-3",
                                "answer": "test",
                                "total_votes": "1",
                                "is_edited": "0",
                                "section_name": "Introduction",
                                "like": "",
                                "datecreated": "January 04, 2022 04:34 PM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            },
                            {
                                "id": "203",
                                "ans_id": "261",
                                "user_id": "1576",
                                "is_star": "0",
                                "shortname": "qq",
                                "initial": "q",
                                "name": "qa",
                                "last_name": "qa",
                                "avcolor": "cir-3",
                                "answer": "new1",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Introduction",
                                "like": "",
                                "datecreated": "January 04, 2022 04:34 PM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            },
                            {
                                "id": "204",
                                "ans_id": "261",
                                "user_id": "1576",
                                "is_star": "0",
                                "shortname": "qq",
                                "initial": "q",
                                "name": "qa",
                                "last_name": "qa",
                                "avcolor": "cir-3",
                                "answer": "test4",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Introduction",
                                "like": "",
                                "datecreated": "January 04, 2022 04:37 PM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            },
                            {
                                "id": "205",
                                "ans_id": "261",
                                "user_id": "1576",
                                "is_star": "0",
                                "shortname": "qq",
                                "initial": "q",
                                "name": "qa",
                                "last_name": "qa",
                                "avcolor": "cir-3",
                                "answer": "new7",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Introduction",
                                "like": "",
                                "datecreated": "January 04, 2022 04:45 PM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            },
                            {
                                "id": "206",
                                "ans_id": "261",
                                "user_id": "1576",
                                "is_star": "0",
                                "shortname": "qq",
                                "initial": "q",
                                "name": "qa",
                                "last_name": "qa",
                                "avcolor": "cir-3",
                                "answer": "test9",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Introduction",
                                "like": "",
                                "datecreated": "January 04, 2022 04:49 PM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            }
                        ],
                        "total_reply": 5
                    }
                ],
                "total_ans": 7
            },
            {
                "id": "241",
                "course_id": "11",
                "user_id": "1562",
                "shortname": "vv",
                "initial": "v",
                "name": "vinod",
                "last_name": "valsan",
                "avcolor": "cir-15",
                "question": "TEst question4",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "2",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "January 04, 2022 10:22 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "258",
                        "ques_id": "241",
                        "user_id": "1562",
                        "is_star": "0",
                        "shortname": "vv",
                        "initial": "v",
                        "name": "vinod",
                        "last_name": "valsan",
                        "avcolor": "cir-15",
                        "answer": "Test\n",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "January 04, 2022 10:34 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [
                            {
                                "id": "197",
                                "ans_id": "258",
                                "user_id": "1562",
                                "is_star": "0",
                                "shortname": "vv",
                                "initial": "v",
                                "name": "vinod",
                                "last_name": "valsan",
                                "avcolor": "cir-15",
                                "answer": "TEst-2",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Industry 4.0 Transformation Case Study",
                                "like": "",
                                "datecreated": "January 04, 2022 10:48 AM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            },
                            {
                                "id": "198",
                                "ans_id": "258",
                                "user_id": "1562",
                                "is_star": "0",
                                "shortname": "vv",
                                "initial": "v",
                                "name": "vinod",
                                "last_name": "valsan",
                                "avcolor": "cir-15",
                                "answer": "Test-3",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Industry 4.0 Transformation Case Study",
                                "like": "",
                                "datecreated": "January 04, 2022 10:48 AM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            },
                            {
                                "id": "199",
                                "ans_id": "258",
                                "user_id": "1562",
                                "is_star": "0",
                                "shortname": "vv",
                                "initial": "v",
                                "name": "vinod",
                                "last_name": "valsan",
                                "avcolor": "cir-15",
                                "answer": "Test-4",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Industry 4.0 Transformation Case Study",
                                "like": "",
                                "datecreated": "January 04, 2022 12:00 PM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            },
                            {
                                "id": "200",
                                "ans_id": "258",
                                "user_id": "1562",
                                "is_star": "0",
                                "shortname": "vv",
                                "initial": "v",
                                "name": "vinod",
                                "last_name": "valsan",
                                "avcolor": "cir-15",
                                "answer": "Test-6",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Industry 4.0 Transformation Case Study",
                                "like": "",
                                "datecreated": "January 04, 2022 12:01 PM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            }
                        ],
                        "total_reply": 4
                    }
                ],
                "total_ans": 5
            },
            {
                "id": "239",
                "course_id": "11",
                "user_id": "1655",
                "shortname": "tT",
                "initial": "t",
                "name": "test",
                "last_name": "Test2",
                "avcolor": "cir-4",
                "question": "Test",
                "section_name": "Introduction",
                "total_votes": "4",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "January 03, 2022 01:24 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "251",
                        "ques_id": "239",
                        "user_id": "1562",
                        "is_star": "0",
                        "shortname": "vv",
                        "initial": "v",
                        "name": "vinod",
                        "last_name": "valsan",
                        "avcolor": "cir-15",
                        "answer": "test\n",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "January 03, 2022 02:41 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [
                            {
                                "id": "178",
                                "ans_id": "251",
                                "user_id": "1562",
                                "is_star": "0",
                                "shortname": "vv",
                                "initial": "v",
                                "name": "vinod",
                                "last_name": "valsan",
                                "avcolor": "cir-15",
                                "answer": "test2",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Introduction",
                                "like": "",
                                "datecreated": "January 03, 2022 04:19 PM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            },
                            {
                                "id": "179",
                                "ans_id": "251",
                                "user_id": "1562",
                                "is_star": "0",
                                "shortname": "vv",
                                "initial": "v",
                                "name": "vinod",
                                "last_name": "valsan",
                                "avcolor": "cir-15",
                                "answer": "test2",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Introduction",
                                "like": "",
                                "datecreated": "January 03, 2022 04:21 PM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            },
                            {
                                "id": "180",
                                "ans_id": "251",
                                "user_id": "1671",
                                "is_star": "0",
                                "shortname": "vv",
                                "initial": "v",
                                "name": "v",
                                "last_name": "v",
                                "avcolor": "cir-20",
                                "answer": "Test -reply2",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Introduction",
                                "like": "",
                                "datecreated": "January 03, 2022 04:31 PM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            },
                            {
                                "id": "181",
                                "ans_id": "251",
                                "user_id": "1671",
                                "is_star": "0",
                                "shortname": "vv",
                                "initial": "v",
                                "name": "v",
                                "last_name": "v",
                                "avcolor": "cir-20",
                                "answer": "Test-reply4\n",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Introduction",
                                "like": "",
                                "datecreated": "January 03, 2022 04:34 PM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            },
                            {
                                "id": "182",
                                "ans_id": "251",
                                "user_id": "1671",
                                "is_star": "0",
                                "shortname": "vv",
                                "initial": "v",
                                "name": "v",
                                "last_name": "v",
                                "avcolor": "cir-20",
                                "answer": "Test-reply5",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Introduction",
                                "like": "",
                                "datecreated": "January 03, 2022 05:22 PM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            }
                        ],
                        "total_reply": 5
                    },
                    {
                        "id": "252",
                        "ques_id": "239",
                        "user_id": "1562",
                        "is_star": "0",
                        "shortname": "vv",
                        "initial": "v",
                        "name": "vinod",
                        "last_name": "valsan",
                        "avcolor": "cir-15",
                        "answer": "test reply",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "January 03, 2022 02:51 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "253",
                        "ques_id": "239",
                        "user_id": "1562",
                        "is_star": "0",
                        "shortname": "vv",
                        "initial": "v",
                        "name": "vinod",
                        "last_name": "valsan",
                        "avcolor": "cir-15",
                        "answer": "Test reply2",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "January 03, 2022 02:51 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "259",
                        "ques_id": "239",
                        "user_id": "1576",
                        "is_star": "0",
                        "shortname": "qq",
                        "initial": "q",
                        "name": "qa",
                        "last_name": "qa",
                        "avcolor": "cir-3",
                        "answer": "test",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "January 04, 2022 03:04 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 9
            },
            {
                "id": "236",
                "course_id": "11",
                "user_id": "1562",
                "shortname": "vv",
                "initial": "v",
                "name": "vinod",
                "last_name": "valsan",
                "avcolor": "cir-15",
                "question": "Test question 2\n",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "2",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "January 03, 2022 08:48 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "250",
                        "ques_id": "236",
                        "user_id": "1562",
                        "is_star": "0",
                        "shortname": "vv",
                        "initial": "v",
                        "name": "vinod",
                        "last_name": "valsan",
                        "avcolor": "cir-15",
                        "answer": "Test\n",
                        "opted": 0,
                        "total_votes": "1",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "January 03, 2022 08:56 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "254",
                        "ques_id": "236",
                        "user_id": "1562",
                        "is_star": "0",
                        "shortname": "vv",
                        "initial": "v",
                        "name": "vinod",
                        "last_name": "valsan",
                        "avcolor": "cir-15",
                        "answer": "Test-2",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "January 03, 2022 05:32 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 2
            },
            {
                "id": "188",
                "course_id": "11",
                "user_id": "1562",
                "shortname": "vv",
                "initial": "v",
                "name": "vinod",
                "last_name": "valsan",
                "avcolor": "cir-15",
                "question": "TEst",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "2",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "December 29, 2021 01:07 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "248",
                        "ques_id": "188",
                        "user_id": "1562",
                        "is_star": "0",
                        "shortname": "vv",
                        "initial": "v",
                        "name": "vinod",
                        "last_name": "valsan",
                        "avcolor": "cir-15",
                        "answer": "Test",
                        "opted": 0,
                        "total_votes": "1",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "December 29, 2021 02:59 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [
                            {
                                "id": "167",
                                "ans_id": "248",
                                "user_id": "1668",
                                "is_star": "0",
                                "shortname": "VV",
                                "initial": "v",
                                "name": "Vinod",
                                "last_name": "V",
                                "avcolor": "cir-17",
                                "answer": "test",
                                "total_votes": "1",
                                "is_edited": "0",
                                "section_name": "Industry 4.0 Transformation Case Study",
                                "like": "",
                                "datecreated": "December 31, 2021 11:04 AM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            },
                            {
                                "id": "168",
                                "ans_id": "248",
                                "user_id": "1562",
                                "is_star": "0",
                                "shortname": "vv",
                                "initial": "v",
                                "name": "vinod",
                                "last_name": "valsan",
                                "avcolor": "cir-15",
                                "answer": "test reply",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Industry 4.0 Transformation Case Study",
                                "like": "",
                                "datecreated": "December 31, 2021 11:05 AM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            },
                            {
                                "id": "169",
                                "ans_id": "248",
                                "user_id": "1562",
                                "is_star": "0",
                                "shortname": "vv",
                                "initial": "v",
                                "name": "vinod",
                                "last_name": "valsan",
                                "avcolor": "cir-15",
                                "answer": "tesyt reply 2",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Industry 4.0 Transformation Case Study",
                                "like": "",
                                "datecreated": "December 31, 2021 11:07 AM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            },
                            {
                                "id": "170",
                                "ans_id": "248",
                                "user_id": "1668",
                                "is_star": "0",
                                "shortname": "VV",
                                "initial": "v",
                                "name": "Vinod",
                                "last_name": "V",
                                "avcolor": "cir-17",
                                "answer": "This is my reply",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Industry 4.0 Transformation Case Study",
                                "like": "",
                                "datecreated": "December 31, 2021 11:15 AM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            },
                            {
                                "id": "171",
                                "ans_id": "248",
                                "user_id": "1562",
                                "is_star": "0",
                                "shortname": "vv",
                                "initial": "v",
                                "name": "vinod",
                                "last_name": "valsan",
                                "avcolor": "cir-15",
                                "answer": "note",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Industry 4.0 Transformation Case Study",
                                "like": "",
                                "datecreated": "December 31, 2021 11:15 AM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            },
                            {
                                "id": "172",
                                "ans_id": "248",
                                "user_id": "1562",
                                "is_star": "0",
                                "shortname": "vv",
                                "initial": "v",
                                "name": "vinod",
                                "last_name": "valsan",
                                "avcolor": "cir-15",
                                "answer": "notesss",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Industry 4.0 Transformation Case Study",
                                "like": "",
                                "datecreated": "December 31, 2021 11:39 AM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            },
                            {
                                "id": "173",
                                "ans_id": "248",
                                "user_id": "1668",
                                "is_star": "0",
                                "shortname": "VV",
                                "initial": "v",
                                "name": "Vinod",
                                "last_name": "V",
                                "avcolor": "cir-17",
                                "answer": "test",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Industry 4.0 Transformation Case Study",
                                "like": "",
                                "datecreated": "December 31, 2021 11:40 AM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            },
                            {
                                "id": "174",
                                "ans_id": "248",
                                "user_id": "1668",
                                "is_star": "0",
                                "shortname": "VV",
                                "initial": "v",
                                "name": "Vinod",
                                "last_name": "V",
                                "avcolor": "cir-17",
                                "answer": "notesss",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Industry 4.0 Transformation Case Study",
                                "like": "",
                                "datecreated": "December 31, 2021 11:41 AM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            },
                            {
                                "id": "175",
                                "ans_id": "248",
                                "user_id": "1668",
                                "is_star": "0",
                                "shortname": "VV",
                                "initial": "v",
                                "name": "Vinod",
                                "last_name": "V",
                                "avcolor": "cir-17",
                                "answer": "notesss",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Industry 4.0 Transformation Case Study",
                                "like": "",
                                "datecreated": "December 31, 2021 11:42 AM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            },
                            {
                                "id": "176",
                                "ans_id": "248",
                                "user_id": "1668",
                                "is_star": "0",
                                "shortname": "VV",
                                "initial": "v",
                                "name": "Vinod",
                                "last_name": "V",
                                "avcolor": "cir-17",
                                "answer": "hi",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Industry 4.0 Transformation Case Study",
                                "like": "",
                                "datecreated": "December 31, 2021 11:52 AM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            },
                            {
                                "id": "177",
                                "ans_id": "248",
                                "user_id": "1668",
                                "is_star": "0",
                                "shortname": "VV",
                                "initial": "v",
                                "name": "Vinod",
                                "last_name": "V",
                                "avcolor": "cir-17",
                                "answer": "ans",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Industry 4.0 Transformation Case Study",
                                "like": "",
                                "datecreated": "December 31, 2021 11:54 AM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            },
                            {
                                "id": "183",
                                "ans_id": "248",
                                "user_id": "1668",
                                "is_star": "0",
                                "shortname": "VV",
                                "initial": "v",
                                "name": "Vinod",
                                "last_name": "V",
                                "avcolor": "cir-17",
                                "answer": "notesss",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Industry 4.0 Transformation Case Study",
                                "like": "",
                                "datecreated": "January 03, 2022 05:31 PM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            }
                        ],
                        "total_reply": 12
                    },
                    {
                        "id": "249",
                        "ques_id": "188",
                        "user_id": "1668",
                        "is_star": "0",
                        "shortname": "VV",
                        "initial": "v",
                        "name": "Vinod",
                        "last_name": "V",
                        "avcolor": "cir-17",
                        "answer": "Test",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "December 31, 2021 11:54 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "255",
                        "ques_id": "188",
                        "user_id": "1671",
                        "is_star": "0",
                        "shortname": "vv",
                        "initial": "v",
                        "name": "v",
                        "last_name": "v",
                        "avcolor": "cir-20",
                        "answer": "Test-2",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "January 03, 2022 05:34 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 15
            },
            {
                "id": "185",
                "course_id": "11",
                "user_id": "1400",
                "shortname": "11",
                "initial": "1",
                "name": "11",
                "last_name": "11",
                "avcolor": "cir-11",
                "question": "20",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "2",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "December 20, 2021 10:13 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "210",
                        "ques_id": "185",
                        "user_id": "1638",
                        "is_star": "0",
                        "shortname": "AK",
                        "initial": "a",
                        "name": "Amit",
                        "last_name": "Kumar",
                        "avcolor": "cir-13",
                        "answer": "11223344",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "December 22, 2021 04:56 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "242",
                        "ques_id": "185",
                        "user_id": "1562",
                        "is_star": "0",
                        "shortname": "vv",
                        "initial": "v",
                        "name": "vinod",
                        "last_name": "valsan",
                        "avcolor": "cir-15",
                        "answer": "Test",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "December 29, 2021 10:38 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "243",
                        "ques_id": "185",
                        "user_id": "1562",
                        "is_star": "0",
                        "shortname": "vv",
                        "initial": "v",
                        "name": "vinod",
                        "last_name": "valsan",
                        "avcolor": "cir-15",
                        "answer": "test",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "December 29, 2021 11:38 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "244",
                        "ques_id": "185",
                        "user_id": "1562",
                        "is_star": "0",
                        "shortname": "vv",
                        "initial": "v",
                        "name": "vinod",
                        "last_name": "valsan",
                        "avcolor": "cir-15",
                        "answer": "test",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "December 29, 2021 11:47 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "245",
                        "ques_id": "185",
                        "user_id": "1562",
                        "is_star": "0",
                        "shortname": "vv",
                        "initial": "v",
                        "name": "vinod",
                        "last_name": "valsan",
                        "avcolor": "cir-15",
                        "answer": "test",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "December 29, 2021 11:47 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "246",
                        "ques_id": "185",
                        "user_id": "1562",
                        "is_star": "0",
                        "shortname": "vv",
                        "initial": "v",
                        "name": "vinod",
                        "last_name": "valsan",
                        "avcolor": "cir-15",
                        "answer": "Test\n",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "December 29, 2021 11:49 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "247",
                        "ques_id": "185",
                        "user_id": "1562",
                        "is_star": "0",
                        "shortname": "vv",
                        "initial": "v",
                        "name": "vinod",
                        "last_name": "valsan",
                        "avcolor": "cir-15",
                        "answer": "I am testing",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "December 29, 2021 11:49 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 7
            },
            {
                "id": "184",
                "course_id": "11",
                "user_id": "1400",
                "shortname": "11",
                "initial": "1",
                "name": "11",
                "last_name": "11",
                "avcolor": "cir-11",
                "question": "10",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "1",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "December 20, 2021 10:13 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "180",
                "course_id": "11",
                "user_id": "1532",
                "shortname": "ee",
                "initial": "e",
                "name": "edeee",
                "last_name": "eeeee",
                "avcolor": "cir-11",
                "question": "Q1",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "1",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "December 16, 2021 12:54 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "198",
                        "ques_id": "180",
                        "user_id": "1576",
                        "is_star": "0",
                        "shortname": "qq",
                        "initial": "q",
                        "name": "qa",
                        "last_name": "qa",
                        "avcolor": "cir-3",
                        "answer": "Done",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "December 16, 2021 05:32 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 1
            },
            {
                "id": "179",
                "course_id": "11",
                "user_id": "1532",
                "shortname": "ee",
                "initial": "e",
                "name": "edeee",
                "last_name": "eeeee",
                "avcolor": "cir-11",
                "question": "dsdssd",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "1",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "December 16, 2021 12:49 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "197",
                        "ques_id": "179",
                        "user_id": "1",
                        "is_star": "0",
                        "shortname": "SA",
                        "initial": "s",
                        "name": "SmarterChains",
                        "last_name": "Admin",
                        "avcolor": "cir-1",
                        "answer": "tfryrfhr",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "December 16, 2021 12:49 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 1
            },
            {
                "id": "178",
                "course_id": "11",
                "user_id": "1571",
                "shortname": "ee",
                "initial": "e",
                "name": "ew",
                "last_name": "eww",
                "avcolor": "cir-24",
                "question": "to be answered",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "December 16, 2021 12:22 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "194",
                        "ques_id": "178",
                        "user_id": "1",
                        "is_star": "0",
                        "shortname": "SA",
                        "initial": "s",
                        "name": "SmarterChains",
                        "last_name": "Admin",
                        "avcolor": "cir-1",
                        "answer": "dddddddddd",
                        "opted": 1,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "December 16, 2021 12:23 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "195",
                        "ques_id": "178",
                        "user_id": "1329",
                        "is_star": "0",
                        "shortname": "ld",
                        "initial": "l",
                        "name": "lljl",
                        "last_name": "dlkdf",
                        "avcolor": "cir-18",
                        "answer": "rerer",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "December 16, 2021 12:47 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "196",
                        "ques_id": "178",
                        "user_id": "1",
                        "is_star": "0",
                        "shortname": "SA",
                        "initial": "s",
                        "name": "SmarterChains",
                        "last_name": "Admin",
                        "avcolor": "cir-1",
                        "answer": "trrrrrrrrrrrrr",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "December 16, 2021 12:48 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 3
            },
            {
                "id": "177",
                "course_id": "11",
                "user_id": "1532",
                "shortname": "ee",
                "initial": "e",
                "name": "edeee",
                "last_name": "eeeee",
                "avcolor": "cir-11",
                "question": "I have a new question",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "December 16, 2021 11:34 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "190",
                        "ques_id": "177",
                        "user_id": "1",
                        "is_star": "0",
                        "shortname": "SA",
                        "initial": "s",
                        "name": "SmarterChains",
                        "last_name": "Admin",
                        "avcolor": "cir-1",
                        "answer": "Please provide your question",
                        "opted": 1,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "December 16, 2021 11:35 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "191",
                        "ques_id": "177",
                        "user_id": "1532",
                        "is_star": "0",
                        "shortname": "ee",
                        "initial": "e",
                        "name": "edeee",
                        "last_name": "eeeee",
                        "avcolor": "cir-11",
                        "answer": "Question1",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "December 16, 2021 11:36 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "192",
                        "ques_id": "177",
                        "user_id": "1",
                        "is_star": "0",
                        "shortname": "SA",
                        "initial": "s",
                        "name": "SmarterChains",
                        "last_name": "Admin",
                        "avcolor": "cir-1",
                        "answer": "Answer1",
                        "opted": 1,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "December 16, 2021 11:40 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "193",
                        "ques_id": "177",
                        "user_id": "1",
                        "is_star": "0",
                        "shortname": "SA",
                        "initial": "s",
                        "name": "SmarterChains",
                        "last_name": "Admin",
                        "avcolor": "cir-1",
                        "answer": "About this course\nAn introduction to Industry 4.0 disruption and its effect in modern manufacturing.\n\nOur introductory course intends to make participants become aware of the philosophy evolution and prepare teams for the digital transformation journey, creating excitement and a pull approach.",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "December 16, 2021 11:55 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 4
            },
            {
                "id": "176",
                "course_id": "11",
                "user_id": "1571",
                "shortname": "ee",
                "initial": "e",
                "name": "ew",
                "last_name": "eww",
                "avcolor": "cir-24",
                "question": "good morning",
                "section_name": "Factory of the Future",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "December 16, 2021 11:28 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "175",
                "course_id": "11",
                "user_id": "1571",
                "shortname": "ee",
                "initial": "e",
                "name": "ew",
                "last_name": "eww",
                "avcolor": "cir-24",
                "question": "Hello q2",
                "section_name": "Factory of the Future",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "December 16, 2021 11:10 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "174",
                "course_id": "11",
                "user_id": "1571",
                "shortname": "ee",
                "initial": "e",
                "name": "ew",
                "last_name": "eww",
                "avcolor": "cir-24",
                "question": "Hello, Q1",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "December 16, 2021 10:44 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "199",
                        "ques_id": "174",
                        "user_id": "1485",
                        "is_star": "0",
                        "shortname": "Ut",
                        "initial": "u",
                        "name": "User",
                        "last_name": "test",
                        "avcolor": "cir-17",
                        "answer": "Test",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "December 16, 2021 06:01 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 1
            },
            {
                "id": "173",
                "course_id": "11",
                "user_id": "1571",
                "shortname": "ee",
                "initial": "e",
                "name": "ew",
                "last_name": "eww",
                "avcolor": "cir-24",
                "question": "eee",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "December 16, 2021 10:13 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "172",
                "course_id": "11",
                "user_id": "1563",
                "shortname": "VR",
                "initial": "v",
                "name": "Vivek",
                "last_name": "Rai",
                "avcolor": "cir-16",
                "question": "hi vivek",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "December 13, 2021 06:23 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "171",
                "course_id": "11",
                "user_id": "1418",
                "shortname": "11",
                "initial": "1",
                "name": "13",
                "last_name": "13",
                "avcolor": "cir-3",
                "question": "hi",
                "section_name": "Introduction",
                "total_votes": "1",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "December 13, 2021 12:26 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "200",
                        "ques_id": "171",
                        "user_id": "1485",
                        "is_star": "0",
                        "shortname": "Ut",
                        "initial": "u",
                        "name": "User",
                        "last_name": "test",
                        "avcolor": "cir-17",
                        "answer": "test",
                        "opted": 0,
                        "total_votes": "1",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "December 16, 2021 06:06 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 1
            },
            {
                "id": "170",
                "course_id": "11",
                "user_id": "1097",
                "shortname": "AL",
                "initial": "a",
                "name": "Amarillis",
                "last_name": "Loufardaki",
                "avcolor": "cir-3",
                "question": "follow this question",
                "section_name": "Introduction",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "December 06, 2021 06:01 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "188",
                        "ques_id": "170",
                        "user_id": "1097",
                        "is_star": "0",
                        "shortname": "AL",
                        "initial": "a",
                        "name": "Amarillis",
                        "last_name": "Loufardaki",
                        "avcolor": "cir-3",
                        "answer": "reply",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "December 06, 2021 06:05 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "189",
                        "ques_id": "170",
                        "user_id": "1524",
                        "is_star": "0",
                        "shortname": "DD",
                        "initial": "d",
                        "name": "DDDD",
                        "last_name": "DDDD",
                        "avcolor": "cir-3",
                        "answer": "HIII",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "December 06, 2021 06:09 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 2
            },
            {
                "id": "169",
                "course_id": "11",
                "user_id": "1097",
                "shortname": "AL",
                "initial": "a",
                "name": "Amarillis",
                "last_name": "Loufardaki",
                "avcolor": "cir-3",
                "question": "new question notification test",
                "section_name": "Introduction",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "December 06, 2021 05:52 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "186",
                        "ques_id": "169",
                        "user_id": "1511",
                        "is_star": "0",
                        "shortname": "TT",
                        "initial": "t",
                        "name": "Testing",
                        "last_name": "Test",
                        "avcolor": "cir-16",
                        "answer": "new reply",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "December 06, 2021 05:53 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "187",
                        "ques_id": "169",
                        "user_id": "1097",
                        "is_star": "0",
                        "shortname": "AL",
                        "initial": "a",
                        "name": "Amarillis",
                        "last_name": "Loufardaki",
                        "avcolor": "cir-3",
                        "answer": "response",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "December 06, 2021 05:58 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 2
            },
            {
                "id": "168",
                "course_id": "11",
                "user_id": "1511",
                "shortname": "TT",
                "initial": "t",
                "name": "Testing",
                "last_name": "Test",
                "avcolor": "cir-16",
                "question": "from vivek",
                "section_name": "Introduction",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "December 06, 2021 05:38 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "185",
                        "ques_id": "168",
                        "user_id": "152",
                        "is_star": "0",
                        "shortname": "NM",
                        "initial": "n",
                        "name": "Neos",
                        "last_name": "Mousakas",
                        "avcolor": "cir-16",
                        "answer": "hi there",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "December 06, 2021 05:40 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 1
            },
            {
                "id": "167",
                "course_id": "11",
                "user_id": "1393",
                "shortname": "N8",
                "initial": "n",
                "name": "Novemb",
                "last_name": "8",
                "avcolor": "cir-4",
                "question": "hi vivek",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "December 06, 2021 05:14 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "179",
                        "ques_id": "167",
                        "user_id": "152",
                        "is_star": "0",
                        "shortname": "NM",
                        "initial": "n",
                        "name": "Neos",
                        "last_name": "Mousakas",
                        "avcolor": "cir-16",
                        "answer": "hello",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "December 06, 2021 05:15 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "180",
                        "ques_id": "167",
                        "user_id": "152",
                        "is_star": "0",
                        "shortname": "NM",
                        "initial": "n",
                        "name": "Neos",
                        "last_name": "Mousakas",
                        "avcolor": "cir-16",
                        "answer": "hello2",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "December 06, 2021 05:27 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "181",
                        "ques_id": "167",
                        "user_id": "1511",
                        "is_star": "0",
                        "shortname": "TT",
                        "initial": "t",
                        "name": "Testing",
                        "last_name": "Test",
                        "avcolor": "cir-16",
                        "answer": "hi",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "December 06, 2021 05:30 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "182",
                        "ques_id": "167",
                        "user_id": "1511",
                        "is_star": "0",
                        "shortname": "TT",
                        "initial": "t",
                        "name": "Testing",
                        "last_name": "Test",
                        "avcolor": "cir-16",
                        "answer": "hello 2",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "December 06, 2021 05:34 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "183",
                        "ques_id": "167",
                        "user_id": "152",
                        "is_star": "0",
                        "shortname": "NM",
                        "initial": "n",
                        "name": "Neos",
                        "last_name": "Mousakas",
                        "avcolor": "cir-16",
                        "answer": "hi last",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "December 06, 2021 05:35 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 5
            },
            {
                "id": "166",
                "course_id": "11",
                "user_id": "1511",
                "shortname": "TT",
                "initial": "t",
                "name": "Testing",
                "last_name": "Test",
                "avcolor": "cir-16",
                "question": "test",
                "section_name": "Introduction",
                "total_votes": "1",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "December 06, 2021 01:16 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "178",
                        "ques_id": "166",
                        "user_id": "1461",
                        "is_star": "0",
                        "shortname": "AL",
                        "initial": "a",
                        "name": "Amarillis",
                        "last_name": "Loufardaki",
                        "avcolor": "cir-19",
                        "answer": "reply",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "December 06, 2021 01:17 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 1
            },
            {
                "id": "164",
                "course_id": "11",
                "user_id": "1459",
                "shortname": "ii",
                "initial": "i",
                "name": "inv1",
                "last_name": "inv1",
                "avcolor": "cir-17",
                "question": "asda",
                "section_name": "Introduction",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "November 16, 2021 09:56 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "163",
                "course_id": "11",
                "user_id": "1412",
                "shortname": "FA",
                "initial": "f",
                "name": "Fejano",
                "last_name": "Adaranko",
                "avcolor": "cir-23",
                "question": "Hi Gianni, do you see this???",
                "section_name": "Introduction",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "November 12, 2021 01:10 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "158",
                "course_id": "11",
                "user_id": "1405",
                "shortname": "AL",
                "initial": "a",
                "name": "Amarillis",
                "last_name": "Loufardaki",
                "avcolor": "cir-16",
                "question": "hello again 10\/11",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "2",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "November 10, 2021 10:06 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "170",
                        "ques_id": "158",
                        "user_id": "1397",
                        "is_star": "0",
                        "shortname": "TT",
                        "initial": "t",
                        "name": "Testing",
                        "last_name": "Test",
                        "avcolor": "cir-8",
                        "answer": "hey",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "November 10, 2021 10:15 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "171",
                        "ques_id": "158",
                        "user_id": "1405",
                        "is_star": "0",
                        "shortname": "AL",
                        "initial": "a",
                        "name": "Amarillis",
                        "last_name": "Loufardaki",
                        "avcolor": "cir-16",
                        "answer": "hello",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "November 10, 2021 10:16 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 2
            },
            {
                "id": "156",
                "course_id": "11",
                "user_id": "1397",
                "shortname": "TT",
                "initial": "t",
                "name": "Testing",
                "last_name": "Test",
                "avcolor": "cir-8",
                "question": "hello",
                "section_name": "Introduction",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "November 09, 2021 03:01 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "177",
                        "ques_id": "156",
                        "user_id": "1405",
                        "is_star": "0",
                        "shortname": "AL",
                        "initial": "a",
                        "name": "Amarillis",
                        "last_name": "Loufardaki",
                        "avcolor": "cir-16",
                        "answer": "blah blah",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "November 10, 2021 12:16 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "184",
                        "ques_id": "156",
                        "user_id": "152",
                        "is_star": "0",
                        "shortname": "NM",
                        "initial": "n",
                        "name": "Neos",
                        "last_name": "Mousakas",
                        "avcolor": "cir-16",
                        "answer": "hi",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "December 06, 2021 05:37 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 2
            },
            {
                "id": "154",
                "course_id": "11",
                "user_id": "1390",
                "shortname": "DD",
                "initial": "d",
                "name": "Dim",
                "last_name": "Dem",
                "avcolor": "cir-1",
                "question": "Hi AF!\n",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "November 09, 2021 09:48 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "168",
                        "ques_id": "154",
                        "user_id": "1402",
                        "is_star": "0",
                        "shortname": "AL",
                        "initial": "a",
                        "name": "Ama",
                        "last_name": "Lia",
                        "avcolor": "cir-13",
                        "answer": "response",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "November 09, 2021 09:48 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 1
            },
            {
                "id": "153",
                "course_id": "11",
                "user_id": "1395",
                "shortname": "N8",
                "initial": "n",
                "name": "Novemb",
                "last_name": "8_2",
                "avcolor": "cir-6",
                "question": "hello November",
                "section_name": "Introduction",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "November 08, 2021 10:54 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "167",
                        "ques_id": "153",
                        "user_id": "1379",
                        "is_star": "0",
                        "shortname": "AL",
                        "initial": "a",
                        "name": "Amarillis",
                        "last_name": "Loufardaki",
                        "avcolor": "cir-16",
                        "answer": "hello",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "November 08, 2021 10:54 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 1
            },
            {
                "id": "150",
                "course_id": "11",
                "user_id": "1393",
                "shortname": "N8",
                "initial": "n",
                "name": "Novemb",
                "last_name": "8",
                "avcolor": "cir-4",
                "question": "novemb 8",
                "section_name": "Introduction",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "November 08, 2021 09:25 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "166",
                        "ques_id": "150",
                        "user_id": "1379",
                        "is_star": "0",
                        "shortname": "AL",
                        "initial": "a",
                        "name": "Amarillis",
                        "last_name": "Loufardaki",
                        "avcolor": "cir-16",
                        "answer": "resp 1",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "November 08, 2021 09:26 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [
                            {
                                "id": "166",
                                "ans_id": "166",
                                "user_id": "1389",
                                "is_star": "0",
                                "shortname": "11",
                                "initial": "1",
                                "name": "10",
                                "last_name": "10",
                                "avcolor": "cir-26",
                                "answer": "good point",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Introduction",
                                "like": "",
                                "datecreated": "November 10, 2021 10:03 AM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            }
                        ],
                        "total_reply": 1
                    }
                ],
                "total_ans": 2
            },
            {
                "id": "139",
                "course_id": "11",
                "user_id": "1379",
                "shortname": "AL",
                "initial": "a",
                "name": "Amarillis",
                "last_name": "Loufardaki",
                "avcolor": "cir-16",
                "question": "blah blah",
                "section_name": "Introduction",
                "total_votes": "1",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "November 05, 2021 06:12 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "156",
                        "ques_id": "139",
                        "user_id": "1382",
                        "is_star": "0",
                        "shortname": "AL",
                        "initial": "a",
                        "name": "Amarillis",
                        "last_name": "Loufardaki",
                        "avcolor": "cir-19",
                        "answer": "response",
                        "opted": 1,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "November 05, 2021 06:14 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "157",
                        "ques_id": "139",
                        "user_id": "1382",
                        "is_star": "0",
                        "shortname": "AL",
                        "initial": "a",
                        "name": "Amarillis",
                        "last_name": "Loufardaki",
                        "avcolor": "cir-19",
                        "answer": "response to response",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "November 05, 2021 06:15 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "158",
                        "ques_id": "139",
                        "user_id": "1379",
                        "is_star": "0",
                        "shortname": "AL",
                        "initial": "a",
                        "name": "Amarillis",
                        "last_name": "Loufardaki",
                        "avcolor": "cir-16",
                        "answer": "very interesting",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "November 05, 2021 06:16 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 3
            },
            {
                "id": "137",
                "course_id": "11",
                "user_id": "1382",
                "shortname": "AL",
                "initial": "a",
                "name": "Amarillis",
                "last_name": "Loufardaki",
                "avcolor": "cir-19",
                "question": "what is industry 4.0? \/ edited ",
                "section_name": "Introduction",
                "total_votes": "1",
                "is_edited": "1",
                "follow": 0,
                "like": "",
                "datecreated": "November 05, 2021 11:26 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "155",
                        "ques_id": "137",
                        "user_id": "1379",
                        "is_star": "0",
                        "shortname": "AL",
                        "initial": "a",
                        "name": "Amarillis",
                        "last_name": "Loufardaki",
                        "avcolor": "cir-16",
                        "answer": "response",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "November 05, 2021 05:53 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "165",
                        "ques_id": "137",
                        "user_id": "1379",
                        "is_star": "0",
                        "shortname": "AL",
                        "initial": "a",
                        "name": "Amarillis",
                        "last_name": "Loufardaki",
                        "avcolor": "cir-16",
                        "answer": "2nd response",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "November 08, 2021 09:21 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 2
            },
            {
                "id": "133",
                "course_id": "11",
                "user_id": "1364",
                "shortname": "gl",
                "initial": "g",
                "name": "giannis",
                "last_name": "let",
                "avcolor": "cir-1",
                "question": "02",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "3",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "November 02, 2021 05:19 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "153",
                        "ques_id": "133",
                        "user_id": "1280",
                        "is_star": "0",
                        "shortname": "AL",
                        "initial": "a",
                        "name": "Amarillis",
                        "last_name": "Loufardaki",
                        "avcolor": "cir-21",
                        "answer": "reply",
                        "opted": 0,
                        "total_votes": "1",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "November 03, 2021 05:33 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 1
            },
            {
                "id": "132",
                "course_id": "11",
                "user_id": "1348",
                "shortname": "?g",
                "initial": "?",
                "name": "???????",
                "last_name": "giannis",
                "avcolor": "cir-11",
                "question": "01",
                "section_name": "Introduction",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "November 01, 2021 01:12 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "129",
                "course_id": "11",
                "user_id": "1309",
                "shortname": "11",
                "initial": "1",
                "name": "1",
                "last_name": "1",
                "avcolor": "cir-24",
                "question": "iu1",
                "section_name": "Introduction",
                "total_votes": "0",
                "is_edited": "1",
                "follow": 0,
                "like": "",
                "datecreated": "October 26, 2021 01:44 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "149",
                        "ques_id": "129",
                        "user_id": "1309",
                        "is_star": "0",
                        "shortname": "11",
                        "initial": "1",
                        "name": "1",
                        "last_name": "1",
                        "avcolor": "cir-24",
                        "answer": "j",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "October 26, 2021 01:44 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 1
            },
            {
                "id": "128",
                "course_id": "11",
                "user_id": "1102",
                "shortname": "ss",
                "initial": "s",
                "name": "shubhesh",
                "last_name": "srivastava",
                "avcolor": "cir-7",
                "question": "new 3\n",
                "section_name": "Introduction",
                "total_votes": "1",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "October 20, 2021 12:28 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "205",
                        "ques_id": "128",
                        "user_id": "1319",
                        "is_star": "0",
                        "shortname": "am",
                        "initial": "a",
                        "name": "a",
                        "last_name": "m",
                        "avcolor": "cir-8",
                        "answer": "Test",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "December 16, 2021 06:13 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 1
            },
            {
                "id": "123",
                "course_id": "11",
                "user_id": "1050",
                "shortname": "MP",
                "initial": "m",
                "name": "Martha",
                "last_name": "Pontika",
                "avcolor": "cir-15",
                "question": "Use the search box to make sure your question is unique\nKeep your question relevant to this training course",
                "section_name": "Industry 4.0",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "October 19, 2021 04:35 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "144",
                        "ques_id": "123",
                        "user_id": "1050",
                        "is_star": "0",
                        "shortname": "MP",
                        "initial": "m",
                        "name": "Martha",
                        "last_name": "Pontika",
                        "avcolor": "cir-15",
                        "answer": "jf",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "October 19, 2021 04:36 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 1
            },
            {
                "id": "122",
                "course_id": "11",
                "user_id": "1207",
                "shortname": "gl",
                "initial": "g",
                "name": "giannis",
                "last_name": "let",
                "avcolor": "cir-2",
                "question": "spammer",
                "section_name": "Introduction",
                "total_votes": "2",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "October 13, 2021 11:04 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "142",
                        "ques_id": "122",
                        "user_id": "1198",
                        "is_star": "0",
                        "shortname": "ss",
                        "initial": "s",
                        "name": "shubh",
                        "last_name": "srivastava",
                        "avcolor": "cir-19",
                        "answer": "first1",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "October 14, 2021 04:35 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [
                            {
                                "id": "157",
                                "ans_id": "142",
                                "user_id": "1198",
                                "is_star": "0",
                                "shortname": "ss",
                                "initial": "s",
                                "name": "shubh",
                                "last_name": "srivastava",
                                "avcolor": "cir-19",
                                "answer": "jjhh",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Introduction",
                                "like": "",
                                "datecreated": "October 14, 2021 04:35 PM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            },
                            {
                                "id": "158",
                                "ans_id": "142",
                                "user_id": "1198",
                                "is_star": "0",
                                "shortname": "ss",
                                "initial": "s",
                                "name": "shubh",
                                "last_name": "srivastava",
                                "avcolor": "cir-19",
                                "answer": "jhjhjh\n",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Introduction",
                                "like": "",
                                "datecreated": "October 14, 2021 04:35 PM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            },
                            {
                                "id": "160",
                                "ans_id": "142",
                                "user_id": "1",
                                "is_star": "0",
                                "shortname": "SA",
                                "initial": "s",
                                "name": "SmarterChains",
                                "last_name": "Admin",
                                "avcolor": "cir-1",
                                "answer": "hello",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Introduction",
                                "like": "",
                                "datecreated": "October 20, 2021 02:49 PM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            },
                            {
                                "id": "161",
                                "ans_id": "142",
                                "user_id": "1",
                                "is_star": "0",
                                "shortname": "SA",
                                "initial": "s",
                                "name": "SmarterChains",
                                "last_name": "Admin",
                                "avcolor": "cir-1",
                                "answer": "it is testing\n",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Introduction",
                                "like": "",
                                "datecreated": "October 20, 2021 03:43 PM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            },
                            {
                                "id": "162",
                                "ans_id": "142",
                                "user_id": "1",
                                "is_star": "0",
                                "shortname": "SA",
                                "initial": "s",
                                "name": "SmarterChains",
                                "last_name": "Admin",
                                "avcolor": "cir-1",
                                "answer": "testing\n\n\n\n\n\n\n\n\ntesting",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Introduction",
                                "like": "",
                                "datecreated": "October 20, 2021 03:44 PM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            }
                        ],
                        "total_reply": 5
                    }
                ],
                "total_ans": 6
            },
            {
                "id": "121",
                "course_id": "11",
                "user_id": "1207",
                "shortname": "gl",
                "initial": "g",
                "name": "giannis",
                "last_name": "let",
                "avcolor": "cir-2",
                "question": "like me please",
                "section_name": "Introduction",
                "total_votes": "2",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "October 13, 2021 11:03 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "141",
                        "ques_id": "121",
                        "user_id": "1201",
                        "is_star": "0",
                        "shortname": "AL",
                        "initial": "a",
                        "name": "Amarillis",
                        "last_name": "Loufardaki",
                        "avcolor": "cir-22",
                        "answer": "needy",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "October 13, 2021 11:05 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 1
            },
            {
                "id": "120",
                "course_id": "11",
                "user_id": "1207",
                "shortname": "gl",
                "initial": "g",
                "name": "giannis",
                "last_name": "let",
                "avcolor": "cir-2",
                "question": "120",
                "section_name": "Introduction",
                "total_votes": "2",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "October 13, 2021 11:02 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "118",
                "course_id": "11",
                "user_id": "1207",
                "shortname": "gl",
                "initial": "g",
                "name": "giannis",
                "last_name": "let",
                "avcolor": "cir-2",
                "question": "v10",
                "section_name": "Introduction",
                "total_votes": "2",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "October 12, 2021 06:26 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "135",
                        "ques_id": "118",
                        "user_id": "1",
                        "is_star": "0",
                        "shortname": "SA",
                        "initial": "s",
                        "name": "SmarterChains",
                        "last_name": "Admin",
                        "avcolor": "cir-1",
                        "answer": "v10 r",
                        "opted": 1,
                        "total_votes": "2",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "October 12, 2021 06:26 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [
                            {
                                "id": "156",
                                "ans_id": "135",
                                "user_id": "1175",
                                "is_star": "0",
                                "shortname": "VR",
                                "initial": "v",
                                "name": "Vivek",
                                "last_name": "Rai",
                                "avcolor": "cir-22",
                                "answer": "hello",
                                "total_votes": "2",
                                "is_edited": "0",
                                "section_name": "Introduction",
                                "like": "",
                                "datecreated": "October 13, 2021 12:48 PM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            }
                        ],
                        "total_reply": 1
                    }
                ],
                "total_ans": 2
            },
            {
                "id": "117",
                "course_id": "11",
                "user_id": "1207",
                "shortname": "gl",
                "initial": "g",
                "name": "giannis",
                "last_name": "let",
                "avcolor": "cir-2",
                "question": "v3",
                "section_name": "Introduction",
                "total_votes": "2",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "October 12, 2021 06:25 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "134",
                        "ques_id": "117",
                        "user_id": "1",
                        "is_star": "0",
                        "shortname": "SA",
                        "initial": "s",
                        "name": "SmarterChains",
                        "last_name": "Admin",
                        "avcolor": "cir-1",
                        "answer": "admin v4",
                        "opted": 1,
                        "total_votes": "2",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "October 12, 2021 06:26 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 1
            },
            {
                "id": "114",
                "course_id": "11",
                "user_id": "1207",
                "shortname": "gl",
                "initial": "g",
                "name": "giannis",
                "last_name": "let",
                "avcolor": "cir-2",
                "question": "1888",
                "section_name": "Introduction",
                "total_votes": "1",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "October 12, 2021 04:35 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "113",
                "course_id": "11",
                "user_id": "1207",
                "shortname": "gl",
                "initial": "g",
                "name": "giannis",
                "last_name": "let",
                "avcolor": "cir-2",
                "question": "1444",
                "section_name": "Introduction",
                "total_votes": "2",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "October 12, 2021 04:35 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "131",
                        "ques_id": "113",
                        "user_id": "1207",
                        "is_star": "0",
                        "shortname": "gl",
                        "initial": "g",
                        "name": "giannis",
                        "last_name": "let",
                        "avcolor": "cir-2",
                        "answer": "1445",
                        "opted": 0,
                        "total_votes": "1",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "October 12, 2021 04:35 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 1
            },
            {
                "id": "106",
                "course_id": "11",
                "user_id": "1120",
                "shortname": "11",
                "initial": "1",
                "name": "1",
                "last_name": "1",
                "avcolor": "cir-19",
                "question": "Tips on raising a question\n\nUse the search box to make sure your question is unique\nKeep your question relevant to this training course",
                "section_name": "Introduction",
                "total_votes": "2",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "October 11, 2021 07:42 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "105",
                "course_id": "11",
                "user_id": "1120",
                "shortname": "11",
                "initial": "1",
                "name": "1",
                "last_name": "1",
                "avcolor": "cir-19",
                "question": "ffff",
                "section_name": "Introduction",
                "total_votes": "2",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "October 11, 2021 07:40 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "120",
                        "ques_id": "105",
                        "user_id": "1120",
                        "is_star": "0",
                        "shortname": "11",
                        "initial": "1",
                        "name": "1",
                        "last_name": "1",
                        "avcolor": "cir-19",
                        "answer": "daaaaaaaaaa",
                        "opted": 0,
                        "total_votes": "1",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "October 11, 2021 07:42 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 1
            },
            {
                "id": "103",
                "course_id": "11",
                "user_id": "1183",
                "shortname": "11",
                "initial": "1",
                "name": "1",
                "last_name": "1",
                "avcolor": "cir-4",
                "question": "a",
                "section_name": "Introduction",
                "total_votes": "2",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "October 11, 2021 06:45 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "117",
                        "ques_id": "103",
                        "user_id": "1183",
                        "is_star": "0",
                        "shortname": "11",
                        "initial": "1",
                        "name": "1",
                        "last_name": "1",
                        "avcolor": "cir-4",
                        "answer": "aa",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "October 11, 2021 06:45 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [
                            {
                                "id": "153",
                                "ans_id": "117",
                                "user_id": "1183",
                                "is_star": "0",
                                "shortname": "11",
                                "initial": "1",
                                "name": "1",
                                "last_name": "1",
                                "avcolor": "cir-4",
                                "answer": "aaa",
                                "total_votes": "1",
                                "is_edited": "0",
                                "section_name": "Introduction",
                                "like": "",
                                "datecreated": "October 11, 2021 06:45 PM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            },
                            {
                                "id": "154",
                                "ans_id": "117",
                                "user_id": "1183",
                                "is_star": "0",
                                "shortname": "11",
                                "initial": "1",
                                "name": "1",
                                "last_name": "1",
                                "avcolor": "cir-4",
                                "answer": "aaaa",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Introduction",
                                "like": "",
                                "datecreated": "October 11, 2021 06:45 PM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            }
                        ],
                        "total_reply": 2
                    }
                ],
                "total_ans": 3
            },
            {
                "id": "101",
                "course_id": "11",
                "user_id": "1147",
                "shortname": "gg",
                "initial": "g",
                "name": "g",
                "last_name": "g",
                "avcolor": "cir-20",
                "question": "99",
                "section_name": "SmarterChains",
                "total_votes": "4",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "October 08, 2021 04:54 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "98",
                "course_id": "11",
                "user_id": "1104",
                "shortname": "gv",
                "initial": "g",
                "name": "gianis",
                "last_name": "var",
                "avcolor": "cir-9",
                "question": "new 08",
                "section_name": "Introduction",
                "total_votes": "2",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "October 08, 2021 10:49 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "95",
                "course_id": "11",
                "user_id": "1095",
                "shortname": "gl",
                "initial": "g",
                "name": "giannis",
                "last_name": "let",
                "avcolor": "cir-2",
                "question": "photo profile still doesn't work ",
                "section_name": "Introduction",
                "total_votes": "1",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "October 07, 2021 02:35 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "94",
                "course_id": "11",
                "user_id": "1095",
                "shortname": "gl",
                "initial": "g",
                "name": "giannis",
                "last_name": "let",
                "avcolor": "cir-2",
                "question": "new photo ",
                "section_name": "Introduction",
                "total_votes": "1",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "October 07, 2021 02:35 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "89",
                "course_id": "11",
                "user_id": "1076",
                "shortname": "gl",
                "initial": "g",
                "name": "giannis",
                "last_name": "letsos",
                "avcolor": "cir-11",
                "question": "neww",
                "section_name": "Introduction",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "October 06, 2021 05:00 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "87",
                "course_id": "11",
                "user_id": "1076",
                "shortname": "gl",
                "initial": "g",
                "name": "giannis",
                "last_name": "letsos",
                "avcolor": "cir-11",
                "question": "my photo profile is a golden retriever",
                "section_name": "Introduction",
                "total_votes": "2",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "October 06, 2021 02:18 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "85",
                "course_id": "11",
                "user_id": "1089",
                "shortname": "gl",
                "initial": "g",
                "name": "giannis2",
                "last_name": "letsos",
                "avcolor": "cir-23",
                "question": "new photo",
                "section_name": "Introduction",
                "total_votes": "1",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "October 06, 2021 01:59 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "82",
                "course_id": "11",
                "user_id": "1037",
                "shortname": "qq",
                "initial": "q",
                "name": "q",
                "last_name": "q",
                "avcolor": "cir-6",
                "question": "hello",
                "section_name": "Industry 4.0 on Supply Chain",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "October 06, 2021 09:33 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "111",
                        "ques_id": "82",
                        "user_id": "1080",
                        "is_star": "0",
                        "shortname": "ww",
                        "initial": "w",
                        "name": "w",
                        "last_name": "w",
                        "avcolor": "cir-15",
                        "answer": "how are you?",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "October 08, 2021 12:19 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "112",
                        "ques_id": "82",
                        "user_id": "1080",
                        "is_star": "0",
                        "shortname": "ww",
                        "initial": "w",
                        "name": "w",
                        "last_name": "w",
                        "avcolor": "cir-15",
                        "answer": "good",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "October 08, 2021 12:21 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 2
            },
            {
                "id": "71",
                "course_id": "11",
                "user_id": "132",
                "shortname": "ee",
                "initial": "e",
                "name": "ef",
                "last_name": "e",
                "avcolor": "cir-24",
                "question": "hi",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "October 04, 2021 11:08 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "81",
                        "ques_id": "71",
                        "user_id": "132",
                        "is_star": "0",
                        "shortname": "ee",
                        "initial": "e",
                        "name": "ef",
                        "last_name": "e",
                        "avcolor": "cir-24",
                        "answer": "hi\n",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "October 04, 2021 11:17 AM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [
                            {
                                "id": "127",
                                "ans_id": "81",
                                "user_id": "132",
                                "is_star": "0",
                                "shortname": "ee",
                                "initial": "e",
                                "name": "ef",
                                "last_name": "e",
                                "avcolor": "cir-24",
                                "answer": "hi",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Industry 4.0 Transformation Case Study",
                                "like": "",
                                "datecreated": "October 04, 2021 11:25 AM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            },
                            {
                                "id": "128",
                                "ans_id": "81",
                                "user_id": "132",
                                "is_star": "0",
                                "shortname": "ee",
                                "initial": "e",
                                "name": "ef",
                                "last_name": "e",
                                "avcolor": "cir-24",
                                "answer": "hi",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Industry 4.0 Transformation Case Study",
                                "like": "",
                                "datecreated": "October 04, 2021 11:25 AM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            }
                        ],
                        "total_reply": 2
                    }
                ],
                "total_ans": 3
            },
            {
                "id": "70",
                "course_id": "11",
                "user_id": "132",
                "shortname": "ee",
                "initial": "e",
                "name": "ef",
                "last_name": "e",
                "avcolor": "cir-24",
                "question": "hi",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "October 04, 2021 10:56 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "69",
                "course_id": "11",
                "user_id": "885",
                "shortname": "at",
                "initial": "a",
                "name": "ashishgkp1",
                "last_name": "test",
                "avcolor": "cir-25",
                "question": "vvv",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "October 03, 2021 09:23 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "57",
                "course_id": "11",
                "user_id": "152",
                "shortname": "NM",
                "initial": "n",
                "name": "Neos",
                "last_name": "Mousakas",
                "avcolor": "cir-16",
                "question": "hello my question",
                "section_name": "SmarterChains",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "October 03, 2021 04:20 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "54",
                "course_id": "11",
                "user_id": "1050",
                "shortname": "MP",
                "initial": "m",
                "name": "Martha",
                "last_name": "Pontika",
                "avcolor": "cir-15",
                "question": "Asking",
                "section_name": "Industry 4.0",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "October 01, 2021 04:55 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "51",
                        "ques_id": "54",
                        "user_id": "945",
                        "is_star": "0",
                        "shortname": "MP",
                        "initial": "m",
                        "name": "Martha",
                        "last_name": "Pontika",
                        "avcolor": "cir-9",
                        "answer": "replying",
                        "opted": 1,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "October 01, 2021 04:56 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [
                            {
                                "id": "56",
                                "ans_id": "51",
                                "user_id": "1050",
                                "is_star": "0",
                                "shortname": "MP",
                                "initial": "m",
                                "name": "Martha",
                                "last_name": "Pontika",
                                "avcolor": "cir-15",
                                "answer": "reply2",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Industry 4.0",
                                "like": "",
                                "datecreated": "October 01, 2021 04:57 PM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            }
                        ],
                        "total_reply": 1
                    }
                ],
                "total_ans": 2
            },
            {
                "id": "52",
                "course_id": "11",
                "user_id": "9",
                "shortname": "AK",
                "initial": "a",
                "name": "Amits",
                "last_name": "Kumar",
                "avcolor": "cir-2",
                "question": "hello",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "1",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "October 01, 2021 06:27 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "51",
                "course_id": "11",
                "user_id": "132",
                "shortname": "ee",
                "initial": "e",
                "name": "ef",
                "last_name": "e",
                "avcolor": "cir-24",
                "question": "trew",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "1",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "October 01, 2021 03:25 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "49",
                "course_id": "11",
                "user_id": "9",
                "shortname": "AK",
                "initial": "a",
                "name": "Amits",
                "last_name": "Kumar",
                "avcolor": "cir-2",
                "question": "hello",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "October 01, 2021 01:48 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "46",
                "course_id": "11",
                "user_id": "1049",
                "shortname": "AT",
                "initial": "a",
                "name": "A",
                "last_name": "T",
                "avcolor": "cir-14",
                "question": "talking to myself once again",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "September 30, 2021 01:43 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "44",
                        "ques_id": "46",
                        "user_id": "1049",
                        "is_star": "0",
                        "shortname": "AT",
                        "initial": "a",
                        "name": "A",
                        "last_name": "T",
                        "avcolor": "cir-14",
                        "answer": "answering to a question",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "September 30, 2021 01:43 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [
                            {
                                "id": "41",
                                "ans_id": "44",
                                "user_id": "1049",
                                "is_star": "0",
                                "shortname": "AT",
                                "initial": "a",
                                "name": "A",
                                "last_name": "T",
                                "avcolor": "cir-14",
                                "answer": "answering to my ansswer",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Industry 4.0 Transformation Case Study",
                                "like": "",
                                "datecreated": "September 30, 2021 01:44 PM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            },
                            {
                                "id": "48",
                                "ans_id": "44",
                                "user_id": "132",
                                "is_star": "0",
                                "shortname": "ee",
                                "initial": "e",
                                "name": "ef",
                                "last_name": "e",
                                "avcolor": "cir-24",
                                "answer": "asss",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Industry 4.0 Transformation Case Study",
                                "like": "",
                                "datecreated": "October 01, 2021 04:24 PM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            },
                            {
                                "id": "50",
                                "ans_id": "44",
                                "user_id": "132",
                                "is_star": "0",
                                "shortname": "ee",
                                "initial": "e",
                                "name": "ef",
                                "last_name": "e",
                                "avcolor": "cir-24",
                                "answer": "dddd",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Industry 4.0 Transformation Case Study",
                                "like": "",
                                "datecreated": "October 01, 2021 04:37 PM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            },
                            {
                                "id": "51",
                                "ans_id": "44",
                                "user_id": "132",
                                "is_star": "0",
                                "shortname": "ee",
                                "initial": "e",
                                "name": "ef",
                                "last_name": "e",
                                "avcolor": "cir-24",
                                "answer": "asd",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Industry 4.0 Transformation Case Study",
                                "like": "",
                                "datecreated": "October 01, 2021 02:11 PM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            },
                            {
                                "id": "52",
                                "ans_id": "44",
                                "user_id": "945",
                                "is_star": "0",
                                "shortname": "MP",
                                "initial": "m",
                                "name": "Martha",
                                "last_name": "Pontika",
                                "avcolor": "cir-9",
                                "answer": "commnet 1",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Industry 4.0 Transformation Case Study",
                                "like": "",
                                "datecreated": "October 01, 2021 02:45 PM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            },
                            {
                                "id": "53",
                                "ans_id": "44",
                                "user_id": "945",
                                "is_star": "0",
                                "shortname": "MP",
                                "initial": "m",
                                "name": "Martha",
                                "last_name": "Pontika",
                                "avcolor": "cir-9",
                                "answer": "comment to ef e",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Industry 4.0 Transformation Case Study",
                                "like": "",
                                "datecreated": "October 01, 2021 02:46 PM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            },
                            {
                                "id": "54",
                                "ans_id": "44",
                                "user_id": "945",
                                "is_star": "0",
                                "shortname": "MP",
                                "initial": "m",
                                "name": "Martha",
                                "last_name": "Pontika",
                                "avcolor": "cir-9",
                                "answer": "comment to AT",
                                "total_votes": "0",
                                "is_edited": "0",
                                "section_name": "Industry 4.0 Transformation Case Study",
                                "like": "",
                                "datecreated": "October 01, 2021 02:46 PM",
                                "datecreated_default": "2022-06-14 11:17:32"
                            }
                        ],
                        "total_reply": 7
                    },
                    {
                        "id": "45",
                        "ques_id": "46",
                        "user_id": "1",
                        "is_star": "0",
                        "shortname": "SA",
                        "initial": "s",
                        "name": "SmarterChains",
                        "last_name": "Admin",
                        "avcolor": "cir-1",
                        "answer": "asaaffff",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "September 30, 2021 01:44 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 9
            },
            {
                "id": "44",
                "course_id": "11",
                "user_id": "9",
                "shortname": "AK",
                "initial": "a",
                "name": "Amits",
                "last_name": "Kumar",
                "avcolor": "cir-2",
                "question": "hi new ques",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "September 30, 2021 01:03 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "41",
                "course_id": "11",
                "user_id": "1054",
                "shortname": "MB",
                "initial": "m",
                "name": "Marina",
                "last_name": "Bassuo",
                "avcolor": "cir-19",
                "question": "test question",
                "section_name": "Industry 4.0 on Supply Chain",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "September 30, 2021 09:20 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "38",
                "course_id": "11",
                "user_id": "1050",
                "shortname": "MP",
                "initial": "m",
                "name": "Martha",
                "last_name": "Pontika",
                "avcolor": "cir-15",
                "question": "hi",
                "section_name": "Industry 4.0",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "September 29, 2021 08:52 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "17",
                "course_id": "11",
                "user_id": "885",
                "shortname": "at",
                "initial": "a",
                "name": "ashishgkp1",
                "last_name": "test",
                "avcolor": "cir-25",
                "question": "2\nTips on raising a question\n\nUse the search box to make sure your question is unique\nKeep your question relevant to this training course\n",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "September 29, 2021 11:00 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "16",
                "course_id": "11",
                "user_id": "885",
                "shortname": "at",
                "initial": "a",
                "name": "ashishgkp1",
                "last_name": "test",
                "avcolor": "cir-25",
                "question": "Tips on raising a question\n\nUse the search box to make sure your question is unique\nKeep your question relevant to this training course",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "September 29, 2021 10:59 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "15",
                "course_id": "11",
                "user_id": "885",
                "shortname": "at",
                "initial": "a",
                "name": "ashishgkp1",
                "last_name": "test",
                "avcolor": "cir-25",
                "question": "test9",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "September 29, 2021 10:59 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "14",
                "course_id": "11",
                "user_id": "885",
                "shortname": "at",
                "initial": "a",
                "name": "ashishgkp1",
                "last_name": "test",
                "avcolor": "cir-25",
                "question": "test8",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "September 29, 2021 10:59 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "13",
                "course_id": "11",
                "user_id": "885",
                "shortname": "at",
                "initial": "a",
                "name": "ashishgkp1",
                "last_name": "test",
                "avcolor": "cir-25",
                "question": "test7\n",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "September 29, 2021 10:59 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "12",
                "course_id": "11",
                "user_id": "885",
                "shortname": "at",
                "initial": "a",
                "name": "ashishgkp1",
                "last_name": "test",
                "avcolor": "cir-25",
                "question": "test6",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "September 29, 2021 10:58 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "11",
                "course_id": "11",
                "user_id": "885",
                "shortname": "at",
                "initial": "a",
                "name": "ashishgkp1",
                "last_name": "test",
                "avcolor": "cir-25",
                "question": "test 5",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "September 29, 2021 10:58 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "204",
                        "ques_id": "11",
                        "user_id": "1319",
                        "is_star": "0",
                        "shortname": "am",
                        "initial": "a",
                        "name": "a",
                        "last_name": "m",
                        "avcolor": "cir-8",
                        "answer": "done",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "December 16, 2021 06:12 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 1
            },
            {
                "id": "10",
                "course_id": "11",
                "user_id": "885",
                "shortname": "at",
                "initial": "a",
                "name": "ashishgkp1",
                "last_name": "test",
                "avcolor": "cir-25",
                "question": "test 4\n",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "September 29, 2021 10:58 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [],
                "total_ans": 0
            },
            {
                "id": "9",
                "course_id": "11",
                "user_id": "885",
                "shortname": "at",
                "initial": "a",
                "name": "ashishgkp1",
                "last_name": "test",
                "avcolor": "cir-25",
                "question": "test3",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "September 29, 2021 10:58 AM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "332",
                        "ques_id": "9",
                        "user_id": "1330",
                        "is_star": "0",
                        "shortname": "AK",
                        "initial": "a",
                        "name": "Amit",
                        "last_name": "Kumar",
                        "avcolor": "cir-19",
                        "answer": "Hello",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "April 29, 2022 03:19 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    }
                ],
                "total_ans": 1
            },
            {
                "id": "5",
                "course_id": "11",
                "user_id": "1037",
                "shortname": "qq",
                "initial": "q",
                "name": "q",
                "last_name": "q",
                "avcolor": "cir-6",
                "question": "Use the search box to make sure your question is unique\nKeep your question relevant to this training course\nUse the search box to make sure your question is unique\nKeep your question relevant to this training course\nUse the search box to make sure your question is unique\nKeep your question relevant to this training course\nUse the search box to make sure your question is unique\nKeep your question relevant to this training course\nUse the search box to make sure your question is unique\nKeep your question relevant to this training course",
                "section_name": "Research & Development in Industry 4.0",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "September 28, 2021 05:40 PM",
                "datecreated_default": "2022-06-14 11:00:08",
                "answers": [
                    {
                        "id": "5",
                        "ques_id": "5",
                        "user_id": "885",
                        "is_star": "0",
                        "shortname": "at",
                        "initial": "a",
                        "name": "ashishgkp1",
                        "last_name": "test",
                        "avcolor": "cir-25",
                        "answer": "gg",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "September 28, 2021 09:32 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                    {
                        "id": "209",
                        "ques_id": "5",
                        "user_id": "1638",
                        "is_star": "0",
                        "shortname": "AK",
                        "initial": "a",
                        "name": "Amit",
                        "last_name": "Kumar",
                        "avcolor": "cir-13",
                        "answer": "Hi, I am Amit.",
                        "opted": 0,
                        "total_votes": "0",
                        "is_edited": "0",
                        "like": "",
                        "datecreated": "December 22, 2021 04:47 PM",
                        "datecreated_default": "2022-06-14 11:15:39",
                        "reply_ans": [],
                        "total_reply": 0
                    },
                ],
                "total_ans": 2
            }
        ],
        "total_ques": 166,
        "total_time_watch": 0
    };
    const courseCurrentItem = courseDataItem.current;
    const uid = courseDataItem.uid;
    const sid = props.sid ? props.sid : courseCurrentItem.id;
    const [isLockedVidPopup, setIsLockedVidPopup] = useState(false);
    const [isStateChange, setIsStateChange] = useState(false);
    const [isCongratulationsPopup, setIsCongratulationsPopup] = useState(false);
    const [activeTabIndex, setActiveTabIndex] = useState(0);
    const [vidHeight, setVidHeight] = useState(350);
    const [count, setCount] = useState(0);

    const vidDiv = useRef();
    useLayoutEffect(()=>{
        let trainingScroll = document.querySelector('.training-content');
        let tabSec = document.querySelector('.course__inner__top__sec');
        if (props.slideIndex == 2) {
            setActiveTabIndex(1);
            trainingScroll.scrollTop = tabSec.offsetHeight+90;
        } else if (props.slideIndex == 4) {
            setActiveTabIndex(2);
            trainingScroll.scrollTop = trainingScroll.scrollHeight;
        }else{
            trainingScroll.scrollTop = 0;
        }
    })
    useEffect(() => {
        let timer;
        const player = new Plyr("#player", {
            controls: ["play-large", "play", "progress", "current-time", "duration", "mute", "volume", "settings", "fullscreen"],
        });
        if (count) {
            player.source = {
                type: "video",
                sources: [
                    {
                        src: `http://185.19.30.43/educateprepare/api/assets/videos/${courseCurrentItem.video_url}`,
                        type: "video/mp4",
                    },
                ],
                autoplay: true,
            };
        } else {
            player.source = {
                type: "video",
                sources: [
                    {
                        src: `http://185.19.30.43/educateprepare/api/assets/videos/${courseCurrentItem.video_url}`,
                        type: "video/mp4",
                    },
                ],
            };
        }
        player.once("canplay", (event) => {
            const currentTime = courseCurrentItem.time_watched ? courseCurrentItem.time_watched : 0;
            // console.log(currentTime);
            player.currentTime = currentTime;
            setVidHeight(event.detail.plyr.media.clientHeight);
        });
        if (courseCurrentItem.has_seen == null || courseCurrentItem.has_seen == 0) {
            serviceProvider.post("/item?type=sethasseen", JSON.stringify({ uid: uid, sid: sid }), true);
        }
        player.on("playing", (event) => {
            var secid = document.getElementById("sectionid").value;
            var time = player.currentTime;
            serviceProvider.post("/item?type=settime", JSON.stringify({ uid: uid, sid: secid, time: time }), true);

        });
        player.on("ended", (event) => {
            var secid = document.getElementById("sectionid").value;
            serviceProvider.post("/item?type=sethascomplete", JSON.stringify({ uid: uid, sid: secid }), true).then((response) => {
                if (response.data.islast == 1) {
                    setIsCongratulationsPopup(!isCongratulationsPopup);
                } else {
                    const vurl = `http://185.19.30.43/educateprepare/api/assets/videos/${response.data.video_url}`;
                    player.source = {
                        type: "video",
                        sources: [{ src: vurl, type: "video/mp4" }],
                        autoplay: true,
                    };
                    props.onComplete(response.data.nsid);
                }
            });
        });

        player.on("loadeddata", (event) => {
            setVidHeight(event.detail.plyr.media.clientHeight);
        });
        const vidTimeout = setTimeout(() => {
            if (1) {
                const tmpVidDiv = vidDiv;
                setVidHeight(tmpVidDiv.current?.offsetHeight);
            }
        }, 1000);
        return () => {
            setCount(1);
            clearTimeout(vidTimeout);
            player.destroy();

        };
    }, [sid, props.tid, courseCurrentItem.id]);
    const TrainTabPane = (props) => {
        return <>{props.item == activeTabIndex ? <>{props.children}</> : ""}</>;
    };

    const HandleTabChange = (index) => {
        setActiveTabIndex(index);
    };
    const HandlePlayPrevious = (index) => {
        setIsStateChange(true);
        props.onComplete(index);
    };
    const HandlePlayPreviousPopup = (index) => {
        props.onComplete(0);
        props.onAllComplete(1);
        setIsCongratulationsPopup(!isCongratulationsPopup);
    };
    const HandleLockVidPopup = () => {
        setIsLockedVidPopup(!isLockedVidPopup);
    };
    const HandleCongratulationsPopup = () => {
        props.onAllComplete(1);
        setIsCongratulationsPopup(!isCongratulationsPopup);
    };
    const HandleValueOnChange = (e) => {
        return true;
    };
    const submitQuestion = () => {
        var ques = document.getElementById("txtSendMsg").value;
        if (ques) {
            serviceProvider
                .post("/item?type=savequestion", JSON.stringify({ uid: uid, cid: courseDataItem.id, ques: ques }), true)
                .then((response) => {
                    document.getElementById("txtSendMsg").value = "";
                    props.onSubmitQues(response.data);
                });
        }
    };
    const submitAnswers = (event) => {
        const qid = event.target.id;
        if (document.getElementById("txtReplyMsg-" + qid) != null) {
            var ans = document.getElementById("txtReplyMsg-" + qid).value;
            if (ans) {
                serviceProvider.post("/item?type=saveanswer", JSON.stringify({ uid: uid, qid: qid, ans: ans }), true).then((response) => {
                    props.onSubmitAns(response.data);
                });
            }
        }
    };
    const secondsToHms = (d) => {
        d = Number(d);
        var h = Math.floor(d / 3600);
        var m = Math.floor((d % 3600) / 60);
        var s = Math.floor((d % 3600) % 60);
        if (d == 0) {
            return "0m";
        }
        var hDisplay = h > 0 ? h + (h == 1 ? "h " : "h ") : "";
        var mDisplay = m > 0 ? m + (m == 1 ? "m " : "m ") : "";
        var sDisplay = s > 0 ? s + (s == 1 ? "s" : "s") : "";
        return hDisplay + mDisplay + sDisplay;
    };
    const secondsToHmOnly = (d) => {
        d = Number(d);
        var h = Math.floor(d / 3600);
        var m = Math.floor((d % 3600) / 60);
        var s = Math.floor((d % 3600) % 60);
        if (d == 0) {
            return "0m";
        }
        var hDisplay = h == 0 ? "0h " : h + "h ";
        var mDisplay = m > 0 ? m + (m == 1 ? "m " : "m ") : "";
        // var sDisplay = s > 0 ? s + (s == 1 ? "s" : "s") : "";
        var sDisplay = "";
        return hDisplay + mDisplay + sDisplay;
    };
    let totalTime = 0;
    let doneTime = 0;
    const courseDataItemSections = courseDataItem.sections.map((section, index) => {
        totalTime = totalTime + parseInt(section.section_duration);
        if (section.has_complete == 1) {
            doneTime = doneTime + parseInt(section.section_duration);
        }

        if (section.id == sid) {
            var status =
                section.id == courseCurrentItem.id && courseDataItem.currentsid != 0 ? "play" : courseDataItem.allcomplete == 1 ? "complete" : "play";
            return (
                <ContentList key={section.id} course_slug={section.course_slug} section_slug={section.section_slug} status={status} listTitle={section.section_name} listTime={secondsToHms(section.section_duration)} />
            );
        } else if (section.has_complete == 1 || section.has_seen == 1) {
            return (
                <ContentList
                    key={section.id}
                    course_slug={section.course_slug}
                    section_slug={section.section_slug}
                    status="complete"
                    listTitle={section.section_name}
                    listTime={secondsToHms(section.section_duration)}
                    callBackFunction={() => HandlePlayPrevious(section.id)}
                />
            );
        } else {
            return (
                <ContentList
                    key={section.id}
                    course_slug={section.course_slug}
                    section_slug={section.section_slug}
                    status="none"
                    listTitle={section.section_name}
                    listTime={secondsToHms(section.section_duration)}
                    callBackFunction={HandleLockVidPopup}
                />
            );
        }
    });
    const courseDataItemDetails = courseDataItem.details.map((detail) => {
        return (
            <div key={detail.id} className="wyl__col">
                <p className="wyl__chk__text">
                    <span className="wyl__chk__icon">
                        <img src={require("../../assets/img/course-detail/checkmark.svg").default} alt="true" />
                    </span>
                    <span>{detail.detail}</span>
                </p>
            </div>
        );
    });
    const Qnasection = courseDataItem.questions.map((ques) => {
        return (
            <ul key={ques.id} id={`qna-${ques.id}`} className="qna__tabpane__card__ul">
                <li className="qna__tabpane__card__li">
                    <Box className="commented__box" component="div">
                        <Box className="commented__head" component="header">
                            <Box component="section" className="cmnt__head__lft">
                                <Avatar className={`name__cir cir-${ques.initial}`}>{ques.shortname}</Avatar>
                                <Box component="p" className="cmnt__head__name">
                                    <span>
                                        {ques.name} {ques.last_name}
                                    </span>
                                </Box>
                            </Box>

                            <Box component="section" className="cmnt__head__rgt">
                                <span>{ques.datecreated}</span>
                            </Box>
                        </Box>

                        <Box className="commented__body" component="div">
                            <p className="txt">{ques.question}</p>

                            <button className="commented__forward__btn">
                                <img src={require("../../assets/img/common-img/forward.svg").default} />
                            </button>
                        </Box>
                    </Box>
                </li>
                {ques.answers.length ? (
                    ques.answers.map((ans) => (
                        <li key={ans.id} className="qna__tabpane__card__li">
                            <div className="sub__li">
                                <Box className="commented__box" component="div">
                                    <Box className="commented__head" component="header">
                                        <Box component="section" className="cmnt__head__lft">
                                            <Avatar className={`name__cir cir-${ans.initial}`}>
                                                {/* <img src={require("../../assets/img/course-overview/instructor.svg").default} atr="true" /> */}
                                                {ans.shortname}
                                            </Avatar>
                                            <Box component="p" className="cmnt__head__name">
                                                <span>
                                                    {ans.name} {ans.last_name}
                                                </span>
                                                {ans.is_star == 1 && (
                                                    <span className="star__img">
                                                        <img src={require("../../assets/img/course-overview/star-blue-cir.svg").default} alt="true" />
                                                    </span>
                                                )}
                                            </Box>
                                        </Box>

                                        <Box component="section" className="cmnt__head__rgt">
                                            <span>{ans.datecreated}</span>
                                        </Box>
                                    </Box>

                                    <Box className="commented__body" component="div">
                                        <p className="txt">{ans.answer}</p>
                                        <button className="commented__forward__btn">
                                            <img src={require("../../assets/img/common-img/forward.svg").default} />
                                        </button>
                                    </Box>
                                </Box>
                            </div>
                        </li>
                    ))
                ) : (
                    <></>
                )}
                <li className="qna__tabpane__card__li">
                    <div className="sub__li">
                        <div className="course__tabpane__card send__comment__card">
                            <div className="send__comment__card__content">
                                <div className="name__cir__wrapper">
                                    <Avatar className={`name__cir cir-${courseDataItem.initial}`}>{courseDataItem.shortname}</Avatar>
                                </div>
                                <textarea
                                    id={`txtReplyMsg-${ques.id}`}
                                    placeholder="Reply to this thread"
                                    className="text__send__msg text__reply__msgs"
                                />

                                <div className="send__btn__div">
                                    <button className="send__btn" id={ques.id} onClick={submitAnswers}>
                                        <span>Reply</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        );
    });
    let leftTime = totalTime - doneTime;
    let completePerc = 0;
    if (doneTime) {
        completePerc = Math.round((doneTime / totalTime) * 100);
    }
    return (
        <React.Fragment>
            {/*<Helmet>
                <title>{courseDataItem.course_name} | SmarterChains</title>
                <meta name="description" content={courseDataItem.meta_desc} />
                <meta name="og:image" content={`http://185.19.30.43/educateprepare/api/assets/img/meta/${courseDataItem.meta_img}`} />
            </Helmet>
            <BreadcrumbsItem to="/">Home</BreadcrumbsItem>
            <BreadcrumbsItem to="/training-courses">Training Courses</BreadcrumbsItem>
            <BreadcrumbsItem to="#">{courseDataItem.course_name}</BreadcrumbsItem>*/}
            <div className="master_wrapper course__overview">
                <div className="course__overview__head">
                    <div className="head__left__frame">
                        <h1 className="course__overView__h1">
                            {/* <span
                                className="course__back__btn"
                                onClick={() => {
                                    HandlePageOnClick("/training-courses", { ...props });
                                }}
                            >
                                <img
                                    className="course__back__btn_img"
                                    src={require("../../assets/img/course-detail/back-course.svg").default}
                                    alt="true"
                                />
                            </span> */}
                            <span className={`${props.sid}-${courseCurrentItem.id}-${sid}`}>{courseDataItem.course_name}</span>
                        </h1>
                        <h2 className="course__overView__h1_small">
                            {courseDataItem.id == 11 ? "INDUSTRY 4.0 INTRODUCTORY COURSE" : "INDUSTRY 4.0 DIMENSION TRAININGS"}
                        </h2>
                    </div>

                    <div className="head__right__frame">
                        <TrainProgressBar value={completePerc} doneTime={secondsToHmOnly(doneTime)} leftTime={secondsToHmOnly(leftTime)} />
                    </div>
                </div>

                <div className="course__inner__wrapper">
                    <div className="course__inner__top__sec">
                        <div className="course__inner__top__left" style={{ height: `${vidHeight}px` }}>
                            <div className="course__inner__ul__wrapper">
                                <div className="course__inner__ul__head">
                                    <div className="course__inner__ul__head__h1">
                                        <div className="head__h1__icon">
                                            <img src={require("../../assets/img/course-overview/content_head.svg").default} alt="true" />
                                        </div>
                                        <div className="head__h1__text">
                                            <span>Contents</span>
                                        </div>
                                    </div>
                                </div>

                                <ul className="course__inner__ul">{courseDataItemSections}</ul>
                            </div>
                        </div>

                        <div className="course__inner__top__right" ref={vidDiv}>
                            {/* <VideoPlayer videoSrc={videoSrc} /> */}
                            <input id="sectionid" value={sid} readOnly style={{ display: "none" }} />
                            <video id="player" controls crossorigin playsInline></video>
                        </div>
                    </div>

                    <div className="course__inner__tab__sec">
                        <div className="course__inner__tabs">
                            <button
                                className={activeTabIndex === 0 ? "course__inner__tab__btn active" : "course__inner__tab__btn"}
                                onClick={() => HandleTabChange(0)}
                                type="button"
                            >
                                <span className="course__inner__tab__img">
                                    <img src={require("../../assets/img/course-overview/tab_overview_active.svg").default} className="active" />
                                    <img src={require("../../assets/img/course-overview/tab_overview_inactive.svg").default} className="inactive" />
                                </span>
                                <span>Overview</span>
                            </button>

                            <button
                                className={activeTabIndex === 1 ? "course__inner__tab__btn active" : "course__inner__tab__btn"}
                                onClick={() => HandleTabChange(1)}
                                type="button"
                            >
                                <span className="course__inner__tab__img">
                                    <img src={require("../../assets/img/course-overview/tab_qna_active.svg").default} className="active" />
                                    <img src={require("../../assets/img/course-overview/tab_qna_inactive.svg").default} className="inactive" />
                                </span>
                                <span>Questions & Answers</span>
                            </button>

                            <button
                                className={activeTabIndex === 2 ? "course__inner__tab__btn active" : "course__inner__tab__btn"}
                                onClick={() => HandleTabChange(2)}
                                type="button"
                            >
                                <span className="course__inner__tab__img">
                                    <img src={require("../../assets/img/course-overview/tab_quiz_active.svg").default} className="active" />
                                    <img src={require("../../assets/img/course-overview/tab_quiz_inactive.svg").default} className="inactive" />
                                </span>
                                <span>Quiz</span>
                            </button>
                        </div>

                        <div className="course__inner__tab__panels">
                            <TrainTabPane item={0} activeTabIndex={activeTabIndex} {...props}>
                                <div className="course__overview__tabpane">
                                    <div className="course__overview__frame__wrapper overview_tabpane_frame">
                                        <div className="course__overview__frame__left">
                                            <div className="course__tabpane__card abt__course">
                                                <h3 className="h1">About this course</h3>
                                                <div className="abt__course__row">
                                                    <div className="abt__course__col__lft">
                                                        <div
                                                            dangerouslySetInnerHTML={{
                                                                __html: courseDataItem.course_description,
                                                            }}
                                                        ></div>
                                                    </div>
                                                    <div className="abt__course__col__rgt">
                                                        <img
                                                            src={
                                                                require(`../../assets/img/training-card/inner-${courseDataItem.course_icon}`).default
                                                            }
                                                            alt={courseDataItem.course_name}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="course__overview__frame__right">
                                            <div className="share__course__card">
                                                <div className="share__course__row">
                                                    <span className="share__course__txt">Share this course:</span>
                                                    <div className="share__course__link">
                                                        <LinkedinShareButton quote="" url={window.location.href}>
                                                            <img
                                                                className="linkedin"
                                                                src={require("../../assets/img/social-media/linked-in.svg").default}
                                                                alt="share_linked_in"
                                                            />
                                                        </LinkedinShareButton>
                                                    </div>
                                                    <div className="share__course__link">
                                                        <FacebookShareButton quote="" url={window.location.href}>
                                                            <img
                                                                className="facebook"
                                                                src={require("../../assets/img/social-media/facebook.svg").default}
                                                                alt="share_facebook"
                                                            />
                                                        </FacebookShareButton>
                                                    </div>
                                                    <div className="share__course__link">
                                                        <TwitterShareButton quote="" url={window.location.href}>
                                                            <img
                                                                className="twitter"
                                                                src={require("../../assets/img/social-media/twitter.svg").default}
                                                                alt="share_twitter"
                                                            />
                                                        </TwitterShareButton>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="course__overview__frame__right" style={{ display: "none" }}>
                                            <div className="course__tabpane__card instructor">
                                                <h3 className="title">Instructor</h3>
                                                <Avatar
                                                    alt={courseDataItem.i_name}
                                                    className="instructor__img"
                                                    src={require(`../../assets/img/course-instructor/${courseDataItem.i_avatar}`).default}
                                                />
                                                <div className="inst__social__icons">
                                                    <a href={courseDataItem.i_linkedin} target="_blank">
                                                        <img src={require("../../assets/img/social-media/linked-in.svg").default} alt="linked_in" />
                                                    </a>
                                                </div>
                                                <div className="about__instructor">
                                                    <p className="inst__name">{courseDataItem.i_name}</p>
                                                    <p className="inst__about__text">{courseDataItem.i_position}</p>
                                                    <p className="inst__about__text i_from">{courseDataItem.i_from}</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="course__overview__frame__left">
                                            <div className="course__tabpane__card wyl">
                                                <h3 className="h1">What you’ll learn</h3>
                                                <div className="wyl__row">{courseDataItemDetails}</div>
                                            </div>
                                        </div>


                                    </div>
                                </div>
                            </TrainTabPane>
                            <TrainTabPane item={1} activeTabIndex={activeTabIndex} {...props}>
                                <div className="course__overview__tabpane">
                                    <div className="course__overview__frame__wrapper qna__tabpane__frame">
                                        <QNAUpdate {...props} />
                                    </div>
                                </div>
                            </TrainTabPane>
                            <TrainTabPane item={2} activeTabIndex={activeTabIndex} {...props}>
                                <div className="course__overview__tabpane">
                                <div className="course__overview__frame__wrapper quiz__tabpane__frame">
                                            <div className="course__overview__frame__left">
                                                <div className="course__tabpane__card congrats__main__card">
                                                    <div className="cong__card">
                                                        <div className="cong__card__img">
                                                            <img
                                                                className=""
                                                                src={require("../../assets/img/course-overview/congrats-completed.svg").default}
                                                                alt="true"
                                                            />
                                                        </div>

                                                        <div className="cong__card__content">
                                                            <p className="cong_blue_text">Congratulations!</p>
                                                            <p>You've successfully completed the Quiz:</p>
                                                            <p className="b">{courseDataItem.course_name}</p>
                                                            <a target="_blank" href={courseDataItem.certificateUrl} className="cong__btue__btn">
                                                                Download your certificate
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="course__overview__frame__right">
                                                <div className="course__tabpane__card your__score__card course__hover__card">
                                                    <h3 className="h1">Your Score is</h3>
                                                    <div className="your__score__cir">
                                                        <SvgCircle value={100} />
                                                    </div>
                                                    <p>You have passed the Quiz!</p>
                                                    <Link to="/" className="quiz__card__hv_btn">
                                                        See the Quiz Results
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                </div>
                            </TrainTabPane>
                        </div>
                    </div>
                </div>
            </div>

            {/* {props.isLockedVidPopup ? <LockedVideoPoup HandleLockVidPopup={props.HandleLockVidPopup} /> : ""} */}
            <div className={`locked__video__parent ${isLockedVidPopup ? "visible active" : ""}`}>
                <div className="locked__video__popup">
                    <div className="popup__content">
                        <button className="close__popup" onClick={HandleLockVidPopup}>
                            <img src={require("../../assets/img/common-img/close-icon-blue.svg").default} />
                        </button>
                        <img src={require("../../assets/img/course-overview/vid_lock.svg").default} className="popup__top__img" alt="true" />
                        <p>Please complete the previous course section to be able to access this video</p>
                        <button className="popup__btn" onClick={HandleLockVidPopup}>
                            OK
                        </button>
                    </div>
                </div>
            </div>
            <div className={`congratulation__popup__parent ${isCongratulationsPopup ? "visible active" : ""}`}>
                <div className="congratulation__popup">
                    <div className="congratulation__content">
                        <button className="close__popup" onClick={HandlePlayPreviousPopup}>
                            <img src={require("../../assets/img/common-img/close-icon-blue.svg").default} />
                        </button>
                        <img className="congrats_img" src={require("../../assets/img/course-overview/congrats__top__img.gif").default} alt="true" />
                        <div>
                            <p className="congratulation__blue">Congratulations!</p>
                            <p>You've successfully completed the Course:</p>
                            <p className="b">{courseDataItem.course_name}</p>
                            <div className="cong__btn__wrapper">
                                <div className="cong__btn__col">
                                    <button className="cong__btn__blue__border" onClick={HandlePlayPreviousPopup}>
                                        I’ll do the Quiz later
                                    </button>
                                </div>
                                <div className="cong__btn__col">
                                    <Link to={`/training-quiz/${courseDataItem.course_slug}`} className="cong__btn__blue">
                                        Take the Quiz
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};




// QNAUpdate Component
const QNAUpdate = (props) => {

    const [searchVal, setSearchVal] = React.useState('');
    const [filterOpen, setFilterOpen] = React.useState(null);
    const [isReportPopup, setIsReportPopup] = React.useState(false);
    const [isCardReply, setIsCardReply] = React.useState(0);
    const questDataItem = {
        "uid": "1571",
        "id": "11",
        "certificate_ref_id": "1",
        "course_name": "Introduction to Industry 4.0",
        "course_slug": "introduction-to-industry-40",
        "course_icon": "course-symb.svg",
        "course_snippet": "Our introductory course intends to make participants become aware of the philosophy evolution and prepare teams for the digital transformation journey, creating excitement and a pull approach.",
        "course_technology": "",
        "course_description": "An introduction to Industry 4.0 disruption and its effect in modern manufacturing.<br\/><br\/>Our introductory course intends to make participants become aware of the philosophy evolution and prepare teams for the digital transformation journey, creating excitement and a pull approach.",
        "course_image": "Introduction-to-Industry-40-Training.png",
        "course_instructor": "1",
        "course_order": "1",
        "social_url": "https:\/\/www.smarterchains.com\/industry-40-training-courses\/introduction-to-industry-40",
        "price": "0",
        "meta_desc": "Industry 4.0 introductory course intends to make you become aware of the philosophy evolution and prepare teams for the digital transformation journey, creating excitement and a pull approach.​",
        "meta_img": "Introduction-to-Industry-40-Training.png\n",
        "is_imd": "1",
        "is_active": "1",
        "i_name": "Angelos Tsoutsias",
        "i_position": "Industry 4.0 Research and Development team Lead",
        "i_from": "National Technical University of Athens",
        "i_linkedin": "https:\/\/gr.linkedin.com\/in\/angelos-v-tsoutsias",
        "i_avatar": "i_angelos.svg",
        "certificateUrl": "",
        "has_opt": 0,
        "has_completed": 0,
        "score": 0,
        "shortname": "ua",
        "name": "ui",
        "avcolor": null,
        "last_name": "admin",
        "profile_pic": "",
        "initial": "u",
        "has_paid": 1,
        "details": [
            {
                "id": "7",
                "course_id": "11",
                "detail": "Get exposed to Industry 4.0 characteristics and enable the discovery of new knowledge"
            },
            {
                "id": "8",
                "course_id": "11",
                "detail": "Showcase the benefits of the Factory of the Future approach"
            },
            {
                "id": "9",
                "course_id": "11",
                "detail": "Gain knowledge over the changes in today’s Supply Chain and Manufacturing"
            },
            {
                "id": "10",
                "course_id": "11",
                "detail": "Engage with Industry 4.0 as continuity to the world of Industry 3.0"
            },
            {
                "id": "11",
                "course_id": "11",
                "detail": "Review an enterprise-wide strategy sprint case study"
            }
        ],
        "current": {
            "id": "44",
            "course_id": "11",
            "section_name": "Introduction",
            "section_detail": "Introduction to Industry 4.0 Training.",
            "section_duration": "51",
            "video_url": "11\/44.mp4",
            "has_quiz": "0",
            "section_order": "1",
            "slug": "introduction",
            "is_active": "1",
            "time_watched": "0",
            "has_seen": "1",
            "has_complete": "0"
        },
        "sections": [
            {
                "id": "44",
                "course_id": "11",
                "section_name": "Introduction",
                "section_slug": "introduction",
                "course_slug": "introduction-to-industry-40",
                "section_detail": "Introduction to Industry 4.0 Training.",
                "section_order": "1",
                "section_duration": "51",
                "video_url": "11\/44.mp4",
                "time_watched": "0",
                "has_complete": "0",
                "has_quiz": "0",
                "has_seen": "1"
            },
            {
                "id": "45",
                "course_id": "11",
                "section_name": "SmarterChains",
                "section_slug": "smarterchains",
                "course_slug": "introduction-to-industry-40",
                "section_detail": "Get to know SmarterChains.",
                "section_order": "2",
                "section_duration": "50",
                "video_url": "11\/45.mp4",
                "time_watched": 0,
                "has_complete": 0,
                "has_quiz": 0,
                "has_seen": 0
            },
            {
                "id": "46",
                "course_id": "11",
                "section_name": "Innovation",
                "section_slug": "innovation",
                "course_slug": "introduction-to-industry-40",
                "section_detail": "Defining Innovation in the concept of manufacturing.",
                "section_order": "3",
                "section_duration": "521",
                "video_url": "11\/46.mp4",
                "time_watched": 0,
                "has_complete": 0,
                "has_quiz": 0,
                "has_seen": 0
            },
            {
                "id": "47",
                "course_id": "11",
                "section_name": "Industry 4.0",
                "section_slug": "industry-40",
                "course_slug": "introduction-to-industry-40",
                "section_detail": "What is the impact Industry 4.0 brings to our lives.",
                "section_order": "4",
                "section_duration": "777",
                "video_url": "11\/47.mp4",
                "time_watched": 0,
                "has_complete": 0,
                "has_quiz": 0,
                "has_seen": 0
            },
            {
                "id": "48",
                "course_id": "11",
                "section_name": "Research & Development in Industry 4.0",
                "section_slug": "research-development-in-industry-40",
                "course_slug": "introduction-to-industry-40",
                "section_detail": "Examine the research activity around Industry 4.0.",
                "section_order": "5",
                "section_duration": "306",
                "video_url": "11\/48.mp4",
                "time_watched": 0,
                "has_complete": 0,
                "has_quiz": 0,
                "has_seen": 0
            },
            {
                "id": "49",
                "course_id": "11",
                "section_name": "Industry 4.0 on Society",
                "section_slug": "industry-40-on-society",
                "course_slug": "introduction-to-industry-40",
                "section_detail": "What are the changes that Industry 4.0 brings to society.",
                "section_order": "6",
                "section_duration": "329",
                "video_url": "11\/49.mp4",
                "time_watched": 0,
                "has_complete": 0,
                "has_quiz": 0,
                "has_seen": 0
            },
            {
                "id": "50",
                "course_id": "11",
                "section_name": "Industry 4.0 on Supply Chain",
                "section_slug": "industry-40-on-supply-chain",
                "course_slug": "introduction-to-industry-40",
                "section_detail": "Learn about the impact of Industry 4.0 on Supply Chain.",
                "section_order": "7",
                "section_duration": "273",
                "video_url": "11\/50.mp4",
                "time_watched": 0,
                "has_complete": 0,
                "has_quiz": 0,
                "has_seen": 0
            },
            {
                "id": "51",
                "course_id": "11",
                "section_name": "Industry 4.0 on Manufacturing",
                "section_slug": "industry-40-on-manufacturing",
                "course_slug": "introduction-to-industry-40",
                "section_detail": "Understand the relation between Industry 4.0 and Manufacturing.",
                "section_order": "8",
                "section_duration": "326",
                "video_url": "11\/51.mp4",
                "time_watched": 0,
                "has_complete": 0,
                "has_quiz": 0,
                "has_seen": 0
            },
            {
                "id": "52",
                "course_id": "11",
                "section_name": "Factory of the Future",
                "section_slug": "factory-of-the-future",
                "course_slug": "introduction-to-industry-40",
                "section_detail": "Learn about the vision of the Factory of the Future.",
                "section_order": "9",
                "section_duration": "93",
                "video_url": "11\/52.mp4",
                "time_watched": 0,
                "has_complete": 0,
                "has_quiz": 0,
                "has_seen": 0
            },
            {
                "id": "53",
                "course_id": "11",
                "section_name": "Factory of the Future Benefits",
                "section_slug": "factory-of-the-future-benefits",
                "course_slug": "introduction-to-industry-40",
                "section_detail": "Outcome generated from applying a Factory of the Future approach.",
                "section_order": "10",
                "section_duration": "78",
                "video_url": "11\/53.mp4",
                "time_watched": 0,
                "has_complete": 0,
                "has_quiz": 0,
                "has_seen": 0
            },
            {
                "id": "54",
                "course_id": "11",
                "section_name": "SmarterChains Framework",
                "section_slug": "smarterchains-framework",
                "course_slug": "introduction-to-industry-40",
                "section_detail": "Showcase the benefits of SmarterChains Framework.",
                "section_order": "11",
                "section_duration": "186",
                "video_url": "11\/54.mp4",
                "time_watched": 0,
                "has_complete": 0,
                "has_quiz": 0,
                "has_seen": 0
            },
            {
                "id": "113",
                "course_id": "11",
                "section_name": "Industry 4.0 Transformation Case Study",
                "section_slug": "industry-40-transformation-case-study",
                "course_slug": "introduction-to-industry-40",
                "section_detail": "See a real case study about an Industry 4.0 Enterprise Wide Strategy Sprint of a Fortune 100 Manufacturing Organization.",
                "section_order": "12",
                "section_duration": "152",
                "video_url": "11\/113.mp4",
                "time_watched": 0,
                "has_complete": 0,
                "has_quiz": 0,
                "has_seen": 0
            }
        ],
        "currentsid": "44",
        "allcomplete": 0,
        "is_first_quiz": "1",
        "questions": [
            {
                "id": "1",
                "course_id": "1",
                "user_id": "11",
                "shortname": "SC",
                "initial": "s",
                "name": "Somnath",
                "profile_pic": "",
                "avcolor": 'cir-1',
                "last_name": "Chakraborty",
                "question": "Exercitation veniam consequat sunt nostrud amet.",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "October 12, 2022 04:00 PM",
                "datecreated_default": "2022-10-12 12:33:12",
                "total_ans": 0,
                answers: []
            },
            {
                "id": "2",
                "course_id": "1",
                "user_id": "11",
                "shortname": "LA",
                "initial": "s",
                "name": "Leslie",
                "profile_pic": "",
                "avcolor": 'cir-12',
                "last_name": "Alexander",
                "question": "Which technology of the above can be used in non-touch production?",
                "section_name": "Innovation",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "October 12, 2022 04:00 PM",
                "datecreated_default": "2022-10-12 12:33:12",
                "total_ans": 0,
                answers: []
            },
            {
                "id": "3",
                "course_id": "3",
                "user_id": "11",
                "shortname": "SC",
                "initial": "s",
                "name": "Somnath",
                "profile_pic": "",
                "avcolor": 'cir-1',
                "last_name": "Chakraborty",
                "question": "Exercitation veniam consequat sunt nostrud amet.",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "October 12, 2022 04:00 PM",
                "datecreated_default": "2022-10-12 12:33:12",
                "total_ans": 0,
                answers: []
            },
            {
                "id": "4",
                "course_id": "4",
                "user_id": "11",
                "shortname": "LA",
                "initial": "s",
                "name": "Leslie",
                "profile_pic": "",
                "avcolor": 'cir-12',
                "last_name": "Alexander",
                "question": "Which technology of the above can be used in non-touch production?",
                "section_name": "Innovation",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "October 12, 2022 04:00 PM",
                "datecreated_default": "2022-10-12 12:33:12",
                "total_ans": 0,
                answers: []
            },
            {
                "id": "5",
                "course_id": "3",
                "user_id": "11",
                "shortname": "SC",
                "initial": "s",
                "name": "Somnath",
                "profile_pic": "",
                "avcolor": 'cir-1',
                "last_name": "Chakraborty",
                "question": "Exercitation veniam consequat sunt nostrud amet.",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "October 12, 2022 04:00 PM",
                "datecreated_default": "2022-10-12 12:33:12",
                "total_ans": 0,
                answers: []
            },
            {
                "id": "6",
                "course_id": "4",
                "user_id": "11",
                "shortname": "LA",
                "initial": "s",
                "name": "Leslie",
                "profile_pic": "",
                "avcolor": 'cir-12',
                "last_name": "Alexander",
                "question": "Which technology of the above can be used in non-touch production?",
                "section_name": "Innovation",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "October 12, 2022 04:00 PM",
                "datecreated_default": "2022-10-12 12:33:12",
                "total_ans": 0,
                answers: []
            },
            {
                "id": "7",
                "course_id": "3",
                "user_id": "11",
                "shortname": "SC",
                "initial": "s",
                "name": "Somnath",
                "profile_pic": "",
                "avcolor": 'cir-1',
                "last_name": "Chakraborty",
                "question": "Exercitation veniam consequat sunt nostrud amet.",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "October 12, 2022 04:00 PM",
                "datecreated_default": "2022-10-12 12:33:12",
                "total_ans": 0,
                answers: []
            },
            {
                "id": "8",
                "course_id": "4",
                "user_id": "11",
                "shortname": "LA",
                "initial": "s",
                "name": "Leslie",
                "profile_pic": "",
                "avcolor": 'cir-12',
                "last_name": "Alexander",
                "question": "Which technology of the above can be used in non-touch production?",
                "section_name": "Innovation",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "October 12, 2022 04:00 PM",
                "datecreated_default": "2022-10-12 12:33:12",
                "total_ans": 0,
                answers: []
            },
            {
                "id": "9",
                "course_id": "3",
                "user_id": "11",
                "shortname": "SC",
                "initial": "s",
                "name": "Somnath",
                "profile_pic": "",
                "avcolor": 'cir-1',
                "last_name": "Chakraborty",
                "question": "Exercitation veniam consequat sunt nostrud amet.",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "October 12, 2022 04:00 PM",
                "datecreated_default": "2022-10-12 12:33:12",
                "total_ans": 0,
                answers: []
            },
            {
                "id": "10",
                "course_id": "4",
                "user_id": "11",
                "shortname": "LA",
                "initial": "s",
                "name": "Leslie",
                "profile_pic": "",
                "avcolor": 'cir-12',
                "last_name": "Alexander",
                "question": "Which technology of the above can be used in non-touch production?",
                "section_name": "Innovation",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "October 12, 2022 04:00 PM",
                "datecreated_default": "2022-10-12 12:33:12",
                "total_ans": 0,
                answers: []
            },
            {
                "id": "11",
                "course_id": "3",
                "user_id": "11",
                "shortname": "SC",
                "initial": "s",
                "name": "Somnath",
                "profile_pic": "",
                "avcolor": 'cir-1',
                "last_name": "Chakraborty",
                "question": "Exercitation veniam consequat sunt nostrud amet.",
                "section_name": "Industry 4.0 Transformation Case Study",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "October 12, 2022 04:00 PM",
                "datecreated_default": "2022-10-12 12:33:12",
                "total_ans": 0,
                answers: []
            },
            {
                "id": "12",
                "course_id": "4",
                "user_id": "11",
                "shortname": "LA",
                "initial": "s",
                "name": "Leslie",
                "profile_pic": "",
                "avcolor": 'cir-12',
                "last_name": "Alexander",
                "question": "Which technology of the above can be used in non-touch production?",
                "section_name": "Innovation",
                "total_votes": "0",
                "is_edited": "0",
                "follow": 0,
                "like": "",
                "datecreated": "October 12, 2022 04:00 PM",
                "datecreated_default": "2022-10-12 12:33:12",
                "total_ans": 0,
                answers: []
            },
        ],
        "total_ques": 2,
        "total_time_watch": 0
    };
    const searchInput = React.useRef();
    const HandleInputValue = (e) => {
        let val = e.target.value;
        setSearchVal(val);
    }
    const HandleSearch = () => {
        if (searchVal.length == 0) {
            searchInput.current.focus();
        } else {
            setSearchVal('');
            searchInput.current.focus();
        }
    }
    const HandleReportPopup = () => {
        setIsReportPopup(!isReportPopup);
    }
    const HandleCard = (value) => {
        setIsCardReply(value)
    }


    return (
        <>
            <div className="edu-qa-wrapper">
                <div className="course__inner__tab__sec">
                    <div className="course__inner__tab__panels">
                        <div className="course__overview__tabpane">
                            <div className="course__overview__frame__wrapper qna__tabpane__frame">
                                {/* search and filter sec  */}
                                <div className="course__overview__frame__left">
                                    <div className={`qna-search-box ${searchVal.length > 0 && 'active'}`}>
                                        <input
                                            type="text"
                                            value={searchVal}
                                            onChange={(e) => HandleInputValue(e)}
                                            ref={searchInput}
                                            placeholder="Search questions that can help you"
                                        />
                                        <button onClick={HandleSearch}>
                                            <img src={require('../../assets/img/common-img/qna-search.svg').default} className="inactive" alt="true" />
                                            <img src={require('../../assets/img/common-img/qna-cancel-src.svg').default} className="active" alt="true" />
                                        </button>
                                    </div>
                                    <div className="qna-filter-wrapper">
                                        <div className="qna-filter-col">
                                            <QnaFilter
                                                itemNumber={1}
                                                ActiveItem={filterOpen}
                                                setActiveItem={setFilterOpen}
                                                options={
                                                    [
                                                        {
                                                            title: 'Sort by most recent',
                                                            value: '1'
                                                        },
                                                        {
                                                            title: 'Sort by most upvoted',
                                                            value: '2'
                                                        },
                                                        {
                                                            title: 'Sort by reccommended',
                                                            value: '3'
                                                        },
                                                    ]
                                                } title="Sort by reccommended" {...props} />
                                        </div>
                                        <div className="qna-filter-col">
                                            <QnaFilter
                                                itemNumber={2}
                                                ActiveItem={filterOpen}
                                                setActiveItem={setFilterOpen}
                                                title="Filter Questions"
                                                options={
                                                    [
                                                        {
                                                            title: 'All Questions',
                                                            value: '1'
                                                        },
                                                        {
                                                            title: 'Questions I asked',
                                                            value: '2'
                                                        },
                                                        {
                                                            title: 'Questions I am following',
                                                            value: '3'
                                                        },
                                                    ]
                                                }  {...props} />
                                        </div>
                                        <div className="qna-filter-col">
                                            <button className={`qna-btn-submit ${isCardReply === 2 ? 'active' : ''}`} onClick={() => HandleCard(2)}>
                                                Submit a new question
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                {/* search and filter sec  */}
                                <div
                                    className="course__overview__frame__left"
                                    style={{ display: isCardReply === 0 ? '' : 'none' }}
                                >
                                    <h2 className="h2">
                                        All questions in this course<span>({questDataItem.total_ques})</span>
                                    </h2>
                                    <div className="course__tabpane__card">
                                        <ul id="qna-80" className="qna__tabpane__card__ul">
                                            {questDataItem.questions.map((ques) => {
                                                return (
                                                    <li className="qna__tabpane__card__li s-566-cmnt-wrapper">
                                                        <div className="s-566-cmnt-1 d-flex-box">
                                                            <div className="MuiBox-root MuiBox-root-2 commented__box">
                                                                <header className="MuiBox-root MuiBox-root-4 commented__head">
                                                                    <section className="MuiBox-root MuiBox-root-6 cmnt__head__lft">
                                                                        <div className={`MuiAvatar-root MuiAvatar-circle name__cir  MuiAvatar-colorDefault ${ques.avcolor}`}>
                                                                            {ques.shortname}
                                                                        </div>
                                                                        <p className="MuiBox-root MuiBox-root-8 cmnt__head__name">
                                                                            <span>
                                                                                {ques.name} {ques.last_name}
                                                                            </span>
                                                                        </p>
                                                                    </section>
                                                                </header>
                                                                <div className="MuiBox-root MuiBox-root-12 commented__body">
                                                                    <p className={`txt qnaAllTxt-${ques.id}`}>
                                                                        {ques.question}
                                                                    </p>
                                                                </div>
                                                                <section className="MuiBox-root MuiBox-root-10 cmnt__head__rgt">
                                                                    <span className="cmnt__head__rgt-date gray">
                                                                        {ques.datecreated_default}
                                                                    </span>
                                                                    <span className="from-text">
                                                                        Section: <label>{ques.section_name}</label>
                                                                    </span>
                                                                </section>
                                                            </div>
                                                            <div className="qa_share_like_wrap">
                                                                <button className={`commented__forward__btn ${ques.like} likeFront${ques.id} `}>
                                                                    <span className="commented__forward__btn-count">
                                                                        1
                                                                    </span>
                                                                    <img
                                                                        className="inactive-icon"
                                                                        src={
                                                                            require("../../assets/img/common-img/qa-like-icon.svg")
                                                                                .default
                                                                        }
                                                                    />
                                                                    <img
                                                                        className="active-icon"
                                                                        src={
                                                                            require("../../assets/img/common-img/qa-liked-icon.svg")
                                                                                .default
                                                                        }
                                                                    />
                                                                </button>
                                                                <button className="commented__forward__btn">
                                                                    <span className="commented__forward__btn-count">
                                                                        0
                                                                    </span>
                                                                    <img
                                                                        src={
                                                                            require("../../assets/img/common-img/qa-reply-icon.svg")
                                                                                .default
                                                                        }
                                                                    />
                                                                </button>
                                                                {/* scnv-566 */}
                                                                <div className="scnv-566-3dots">
                                                                    <>
                                                                        <button className="btn-566-3dot">
                                                                            <svg
                                                                                width={30}
                                                                                height={30}
                                                                                viewBox="0 0 30 30"
                                                                                fill="none"
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                            >
                                                                                <circle
                                                                                    className="hover-cir"
                                                                                    cx={15}
                                                                                    cy={15}
                                                                                    r={15}
                                                                                />
                                                                                <circle
                                                                                    cx={15}
                                                                                    cy={7}
                                                                                    r={2}
                                                                                    fill="#7D868C"
                                                                                />
                                                                                <circle
                                                                                    cx={15}
                                                                                    cy={15}
                                                                                    r={2}
                                                                                    fill="#7D868C"
                                                                                />
                                                                                <circle
                                                                                    cx={15}
                                                                                    cy={23}
                                                                                    r={2}
                                                                                    fill="#7D868C"
                                                                                />
                                                                            </svg>
                                                                        </button>
                                                                        <div className="ul-566-3dots">
                                                                            <button className="btn-s566 edit-btn">
                                                                                Edit
                                                                            </button>
                                                                            <button className="btn-s566 del-btn a">
                                                                                Delete
                                                                            </button>
                                                                        </div>
                                                                    </>
                                                                </div>
                                                                {/* scnv-566 end*/}
                                                            </div>
                                                        </div>
                                                    </li>

                                                );
                                            })}
                                        </ul>
                                    </div>
                                </div>
                                {/* view question wrap end */}
                                <div className="course__overview__frame__left back-to-q" style={{ display: isCardReply === 1 ? '' : 'none' }}>
                                    <button className="h2" onClick={() => HandleCard(0)}>
                                        <img
                                            className="qa-back_arrow"
                                            src={
                                                require("../../assets/img/common-img/qa-arrow_back.svg")
                                                    .default
                                            }
                                        />
                                        Back to all questions
                                    </button>
                                    <div className="course__tabpane__card">
                                        <ul id="qna-80" className="qna__tabpane__card__ul">
                                            <li className="qna__tabpane__card__li">
                                                <div className="MuiBox-root MuiBox-root-2 commented__box">
                                                    <header className="MuiBox-root MuiBox-root-4 commented__head">
                                                        <section className="MuiBox-root MuiBox-root-6 cmnt__head__lft">
                                                            <div className="MuiAvatar-root MuiAvatar-circle name__cir cir-p MuiAvatar-colorDefault">
                                                                AK
                                                            </div>
                                                            <p className="MuiBox-root MuiBox-root-8 cmnt__head__name">
                                                                <span>Adam Kirsten</span>
                                                            </p>
                                                        </section>
                                                    </header>
                                                    <div className="MuiBox-root MuiBox-root-12 commented__body">
                                                        <p className="txt">
                                                            Which technology of the above can be used in
                                                            non-touch production?
                                                        </p>
                                                    </div>
                                                    <section className="MuiBox-root MuiBox-root-10 cmnt__head__rgt">
                                                        <span className="cmnt__head__rgt-date gray">
                                                            October 14, 2021 5:58 PM
                                                        </span>
                                                        <span className="from-text">
                                                            From: <label>Innovation</label>
                                                        </span>
                                                    </section>
                                                </div>
                                                <div className="qa_share_like_wrap">
                                                    <button className="commented__forward__btn">
                                                        <span className="commented__forward__btn-count">
                                                            21
                                                        </span>

                                                        <svg
                                                            width="30"
                                                            height="30"
                                                            className="qa-like-icon"
                                                            viewBox="0 0 30 30"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <path
                                                                d="M25 16.8751C25 16.3742 24.8008 15.9076 24.4575 15.5634C24.8467 15.1376 25.045 14.5667 24.9908 13.9726C24.8933 12.9134 23.9391 12.0834 22.8175 12.0834H17.67C17.925 11.3092 18.3333 9.89007 18.3333 8.75007C18.3333 6.94257 16.7975 5.41675 15.8333 5.41675C14.9683 5.41675 14.3491 5.90425 14.3233 5.92425C14.2241 6.00343 14.1666 6.12343 14.1666 6.25007V9.07589L11.7658 14.2751L11.6666 14.3259V14.1667C11.6666 13.9367 11.48 13.75 11.25 13.75H7.08332C5.93418 13.7501 5 14.6842 5 15.8334V22.5001C5 23.6492 5.93418 24.5834 7.08332 24.5834H9.58332C10.4841 24.5834 11.2541 24.0084 11.5441 23.2059C12.2375 23.5626 13.1708 23.7501 13.75 23.7501H21.3992C22.3067 23.7501 23.1009 23.1384 23.2875 22.2951C23.3833 21.8601 23.3275 21.4226 23.1375 21.0426C23.7525 20.7334 24.1667 20.0976 24.1667 19.3751C24.1667 19.0801 24.0992 18.7976 23.9717 18.5426C24.5867 18.2326 25 17.5976 25 16.8751ZM23.2425 17.9034C23.0817 17.9226 22.9458 18.0317 22.8942 18.1859C22.8434 18.3401 22.8859 18.5092 23.0042 18.6209C23.2159 18.8201 23.3334 19.0884 23.3334 19.3751C23.3334 19.9009 22.9359 20.3426 22.41 20.4034C22.2492 20.4226 22.1134 20.5317 22.0617 20.6859C22.0109 20.8401 22.0534 21.0092 22.1717 21.1209C22.4459 21.3792 22.5559 21.7417 22.4734 22.1151C22.3709 22.5801 21.9192 22.9167 21.3992 22.9167H13.75C13.0733 22.9167 11.9383 22.5992 11.545 22.2051C11.4258 22.0867 11.2458 22.0517 11.0908 22.1151C10.935 22.1792 10.8333 22.3317 10.8333 22.5001C10.8333 23.1892 10.2725 23.7501 9.58332 23.7501H7.08332C6.39414 23.7501 5.83332 23.1892 5.83332 22.5001V15.8334C5.83332 15.1442 6.39414 14.5834 7.08332 14.5834H10.8333V15.0001C10.8333 15.1442 10.9083 15.2784 11.0316 15.3551C11.1533 15.4284 11.3066 15.4359 11.4366 15.3726L12.27 14.9559C12.3541 14.9142 12.4216 14.8442 12.4616 14.7584L14.9616 9.34171C14.9866 9.28671 15 9.22671 15 9.16671V6.47589C15.1733 6.38007 15.4742 6.25007 15.8333 6.25007C16.29 6.25007 17.5 7.38507 17.5 8.75007C17.5 10.2167 16.7017 12.3309 16.6942 12.3517C16.6459 12.4792 16.6625 12.6234 16.74 12.7367C16.8183 12.8492 16.9467 12.9167 17.0833 12.9167H22.8175C23.5125 12.9167 24.1025 13.4142 24.1608 14.0492C24.205 14.5242 23.9766 14.9759 23.5675 15.2284C23.44 15.3067 23.3642 15.4484 23.37 15.5992C23.3758 15.7501 23.4625 15.8851 23.5958 15.9542C23.9483 16.1334 24.1666 16.4867 24.1666 16.8751C24.1667 17.4009 23.7692 17.8426 23.2425 17.9034Z"
                                                                fill="url(#paint0_linear)"
                                                            />
                                                            <path
                                                                d="M11.2499 14.5833C11.0199 14.5833 10.8333 14.7699 10.8333 14.9999V22.4999C10.8333 22.7299 11.0199 22.9166 11.2499 22.9166C11.4799 22.9166 11.6666 22.7299 11.6666 22.4999V14.9999C11.6666 14.7699 11.4799 14.5833 11.2499 14.5833Z"
                                                                fill="url(#paint1_linear)"
                                                            />
                                                            <defs>
                                                                <linearGradient
                                                                    id="paint0_linear"
                                                                    x1="7.66667"
                                                                    y1="1.10423"
                                                                    x2="25.8487"
                                                                    y2="1.71109"
                                                                    gradientUnits="userSpaceOnUse"
                                                                >
                                                                    <stop stop-color="#139BD6" />
                                                                    <stop offset="1" stop-color="#0789CF" />
                                                                </linearGradient>
                                                                <linearGradient
                                                                    id="paint1_linear"
                                                                    x1="10.9444"
                                                                    y1="12.7082"
                                                                    x2="11.7028"
                                                                    y2="12.7107"
                                                                    gradientUnits="userSpaceOnUse"
                                                                >
                                                                    <stop stop-color="#139BD6" />
                                                                    <stop offset="1" stop-color="#0789CF" />
                                                                </linearGradient>
                                                            </defs>
                                                        </svg>

                                                        {/* <img
                                src={
                                  require("../../assets/img/common-img/qa-like-icon.svg")
                                    .default
                                }
                              /> */}
                                                    </button>

                                                </div>
                                                <div className="qa-rep-foll-wrap">
                                                    <span className="qa-reply">4 Replies</span>

                                                </div>
                                            </li>
                                            <li className="qna__tabpane__card__li qa-instructor">
                                                <div className="qa-instructor-in">
                                                    <div className="MuiBox-root MuiBox-root-2 commented__box">
                                                        <header className="MuiBox-root MuiBox-root-4 commented__head">
                                                            <section className="MuiBox-root MuiBox-root-6 cmnt__head__lft">
                                                                <div className="MuiAvatar-root MuiAvatar-circle name__cir cir-p MuiAvatar-colorDefault">
                                                                    AT
                                                                </div>
                                                                <p className="MuiBox-root MuiBox-root-8 cmnt__head__name">
                                                                    <span>Angelos Tsoutsias</span>
                                                                    <img
                                                                        className="instructor-badge"
                                                                        src={
                                                                            require("../../assets/img/common-img/instructor-badge.svg")
                                                                                .default
                                                                        }
                                                                    />
                                                                </p>
                                                            </section>
                                                        </header>
                                                        <div className="MuiBox-root MuiBox-root-12 commented__body">
                                                            <p className="txt">
                                                                Hey Adam! All of them can be used in non-touch
                                                                prduction.
                                                            </p>
                                                        </div>
                                                        <section className="MuiBox-root MuiBox-root-10 cmnt__head__rgt">
                                                            <span className="cmnt__head__rgt-date gray">
                                                                October 14, 2021 5:58 PM
                                                            </span>
                                                            <span className="from-text">
                                                                From: <label>Innovation</label>
                                                            </span>
                                                        </section>
                                                    </div>
                                                    <div className="qa_share_like_wrap">
                                                        <button className="commented__forward__btn">
                                                            <span className="commented__forward__btn-count">
                                                                21
                                                            </span>
                                                            <svg
                                                                width="30"
                                                                height="30"
                                                                className="qa-like-icon"
                                                                viewBox="0 0 30 30"
                                                                fill="none"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                <path
                                                                    d="M25 16.8751C25 16.3742 24.8008 15.9076 24.4575 15.5634C24.8467 15.1376 25.045 14.5667 24.9908 13.9726C24.8933 12.9134 23.9391 12.0834 22.8175 12.0834H17.67C17.925 11.3092 18.3333 9.89007 18.3333 8.75007C18.3333 6.94257 16.7975 5.41675 15.8333 5.41675C14.9683 5.41675 14.3491 5.90425 14.3233 5.92425C14.2241 6.00343 14.1666 6.12343 14.1666 6.25007V9.07589L11.7658 14.2751L11.6666 14.3259V14.1667C11.6666 13.9367 11.48 13.75 11.25 13.75H7.08332C5.93418 13.7501 5 14.6842 5 15.8334V22.5001C5 23.6492 5.93418 24.5834 7.08332 24.5834H9.58332C10.4841 24.5834 11.2541 24.0084 11.5441 23.2059C12.2375 23.5626 13.1708 23.7501 13.75 23.7501H21.3992C22.3067 23.7501 23.1009 23.1384 23.2875 22.2951C23.3833 21.8601 23.3275 21.4226 23.1375 21.0426C23.7525 20.7334 24.1667 20.0976 24.1667 19.3751C24.1667 19.0801 24.0992 18.7976 23.9717 18.5426C24.5867 18.2326 25 17.5976 25 16.8751ZM23.2425 17.9034C23.0817 17.9226 22.9458 18.0317 22.8942 18.1859C22.8434 18.3401 22.8859 18.5092 23.0042 18.6209C23.2159 18.8201 23.3334 19.0884 23.3334 19.3751C23.3334 19.9009 22.9359 20.3426 22.41 20.4034C22.2492 20.4226 22.1134 20.5317 22.0617 20.6859C22.0109 20.8401 22.0534 21.0092 22.1717 21.1209C22.4459 21.3792 22.5559 21.7417 22.4734 22.1151C22.3709 22.5801 21.9192 22.9167 21.3992 22.9167H13.75C13.0733 22.9167 11.9383 22.5992 11.545 22.2051C11.4258 22.0867 11.2458 22.0517 11.0908 22.1151C10.935 22.1792 10.8333 22.3317 10.8333 22.5001C10.8333 23.1892 10.2725 23.7501 9.58332 23.7501H7.08332C6.39414 23.7501 5.83332 23.1892 5.83332 22.5001V15.8334C5.83332 15.1442 6.39414 14.5834 7.08332 14.5834H10.8333V15.0001C10.8333 15.1442 10.9083 15.2784 11.0316 15.3551C11.1533 15.4284 11.3066 15.4359 11.4366 15.3726L12.27 14.9559C12.3541 14.9142 12.4216 14.8442 12.4616 14.7584L14.9616 9.34171C14.9866 9.28671 15 9.22671 15 9.16671V6.47589C15.1733 6.38007 15.4742 6.25007 15.8333 6.25007C16.29 6.25007 17.5 7.38507 17.5 8.75007C17.5 10.2167 16.7017 12.3309 16.6942 12.3517C16.6459 12.4792 16.6625 12.6234 16.74 12.7367C16.8183 12.8492 16.9467 12.9167 17.0833 12.9167H22.8175C23.5125 12.9167 24.1025 13.4142 24.1608 14.0492C24.205 14.5242 23.9766 14.9759 23.5675 15.2284C23.44 15.3067 23.3642 15.4484 23.37 15.5992C23.3758 15.7501 23.4625 15.8851 23.5958 15.9542C23.9483 16.1334 24.1666 16.4867 24.1666 16.8751C24.1667 17.4009 23.7692 17.8426 23.2425 17.9034Z"
                                                                    fill="url(#paint0_linear)"
                                                                />
                                                                <path
                                                                    d="M11.2499 14.5833C11.0199 14.5833 10.8333 14.7699 10.8333 14.9999V22.4999C10.8333 22.7299 11.0199 22.9166 11.2499 22.9166C11.4799 22.9166 11.6666 22.7299 11.6666 22.4999V14.9999C11.6666 14.7699 11.4799 14.5833 11.2499 14.5833Z"
                                                                    fill="url(#paint1_linear)"
                                                                />
                                                                <defs>
                                                                    <linearGradient
                                                                        id="paint0_linear"
                                                                        x1="7.66667"
                                                                        y1="1.10423"
                                                                        x2="25.8487"
                                                                        y2="1.71109"
                                                                        gradientUnits="userSpaceOnUse"
                                                                    >
                                                                        <stop stop-color="#139BD6" />
                                                                        <stop offset="1" stop-color="#0789CF" />
                                                                    </linearGradient>
                                                                    <linearGradient
                                                                        id="paint1_linear"
                                                                        x1="10.9444"
                                                                        y1="12.7082"
                                                                        x2="11.7028"
                                                                        y2="12.7107"
                                                                        gradientUnits="userSpaceOnUse"
                                                                    >
                                                                        <stop stop-color="#139BD6" />
                                                                        <stop offset="1" stop-color="#0789CF" />
                                                                    </linearGradient>
                                                                </defs>
                                                            </svg>
                                                        </button>

                                                    </div>
                                                </div>
                                            </li>
                                            <li className="qna__tabpane__card__li comment-reply-wrap">
                                                <div className="course__tabpane__card send__comment__card">
                                                    <div className="send__comment__card__content">
                                                        <div className="name__cir__wrapper">
                                                            <div className="MuiAvatar-root MuiAvatar-circle name__cir cir-t MuiAvatar-colorDefault">
                                                                TP
                                                            </div>
                                                            <div className="txtReplyWrap280621">
                                                                <textarea
                                                                    id="txtReplyMsg-80"
                                                                    placeholder="Write your response"
                                                                    className="text__send__msg text__reply__msgs"
                                                                    defaultValue={""}
                                                                />
                                                                <div className="send__btn__div">
                                                                    <button className="send__btn" id={80}>
                                                                        <span>Add Reply</span>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>

                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                {/* course overview frame end */}
                                <div
                                    className="course__overview__frame__left submit-new-question"
                                    style={{ display: isCardReply === 2 ? '' : 'none' }}
                                >
                                    <button className="h2" onClick={() => HandleCard(0)}>
                                        <img
                                            className="qa-back_arrow"
                                            src={
                                                require("../../assets/img/common-img/qa-arrow_back.svg")
                                                    .default
                                            }
                                        />
                                        Back to all questions
                                    </button>
                                    <div className="snq-content">
                                        <div className="snq-ul-div">
                                            <p className="ul-title">
                                                Tips on raising a question *dummy text*
                                            </p>
                                            <ul>
                                                <li>
                                                    Search to see if your question has been asked before.
                                                </li>
                                                <li>
                                                    Search to see if your question has been asked before.
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="snq-text-area">
                                            <p className="snq-text-area-h1">
                                                Enter Question
                                            </p>
                                            <textarea className="snq-textarea" defaultValue="" placeholder="Please enter your question here">

                                            </textarea>
                                            <button className="btn-publish">
                                                Publish
                                            </button>
                                        </div>
                                    </div>
                                    <div className="course__tabpane__card">
                                        <ul className="qna__tabpane__card__ul">
                                            <li className="qna__tabpane__card__li">
                                                <div className="MuiBox-root MuiBox-root-2 commented__box">
                                                    <header className="MuiBox-root MuiBox-root-4 commented__head">
                                                        <section className="MuiBox-root MuiBox-root-6 cmnt__head__lft">
                                                            <div className="MuiAvatar-root MuiAvatar-circle name__cir cir-p MuiAvatar-colorDefault">AK
                                                            </div>
                                                            <p className="MuiBox-root MuiBox-root-8 cmnt__head__name">
                                                                <span>Adam Kirsten</span>
                                                            </p>
                                                        </section>
                                                    </header>
                                                    <div className="MuiBox-root MuiBox-root-12 commented__body">
                                                        <p className="txt">Which technology of the above can be used in non-touch production?
                                                        </p>
                                                    </div>
                                                    <section className="MuiBox-root MuiBox-root-10 cmnt__head__rgt">
                                                        <span className="cmnt__head__rgt-date gray">
                                                            October 14, 2021 5:58 PM
                                                        </span>
                                                        <span className="from-text">
                                                            From: <label>Innovation</label>
                                                        </span>
                                                    </section>
                                                </div>
                                                <div className="qa_share_like_wrap">
                                                    <button className="commented__forward__btn">
                                                        <span className="commented__forward__btn-count">
                                                            21
                                                        </span>
                                                        <img
                                                            src={
                                                                require("../../assets/img/common-img/qa-like-icon.svg")
                                                                    .default
                                                            }
                                                        />
                                                    </button>
                                                    <button className="commented__forward__btn">
                                                        <span className="commented__forward__btn-count">
                                                            4
                                                        </span>
                                                        <img
                                                            src={
                                                                require("../../assets/img/common-img/qa-reply-icon.svg")
                                                                    .default
                                                            }
                                                        />
                                                    </button>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                {/* submit-new-question end */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ReportAbusePopup open={isReportPopup} HandleReportPopup={HandleReportPopup} {...props} />
        </>
    );
};

// filter-component
const QnaFilter = (props) => {
    const { itemNumber, ActiveItem, setActiveItem, options, title } = props;
    const ddlbox = React.useRef(null);
    const [btnTitle, setBtnTitle] = React.useState(title);
    const HandleValue = (val) => {
        setBtnTitle(val.title);
        setActiveItem(null);
    }
    const HandleOpenState = (e) => {
        if (e === ActiveItem) {
            setActiveItem(null)
        } else {
            setActiveItem(e)
        }
    }

    window.onclick = (e) => {
        if (!e.target.closest('.qna-filter-ddl-box')) {
            setActiveItem(null);
        }
    }
    return (
        <>
            <div className={`qna-filter-ddl-box ${itemNumber === ActiveItem ? 'active' : ''}`} ref={ddlbox}>
                <button className="top-btn" onClick={() => HandleOpenState(itemNumber)}>
                    <span>
                        {btnTitle}
                    </span>
                    <svg viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.41 0.590088L6 5.17009L10.59 0.590088L12 2.00009L6 8.00009L0 2.00009L1.41 0.590088Z" />
                    </svg>
                </button>
                <div className="filter-ddl-list">
                    {options.map(
                        (item, index) => <button key={index} onClick={() => HandleValue(item)}>{item.title}</button>
                    )
                    }
                </div>
            </div>
        </>
    )
}
// report abuse popup
const ReportAbusePopup = (props) => {
    const [ddlFilter, setDdlFilter] = React.useState('null')
    return (
        <>
            {props.open && <div className="qnaReportAbuse-popup">
                <div className="inner-wrapper">
                    <div className="card">
                        <h1>
                            <span>
                                Report Abuse
                            </span>
                            <button onClick={props.HandleReportPopup}>
                                <img src={require('../../assets/img/common-img/close-icon-blue.svg').default} className="active" alt="true" />
                            </button>
                        </h1>
                        <p>
                            Flagged content is reviewed by SmarterChains staff to determine whether it violates Terms of Service or Community Guidelines. *Dummy text*
                        </p>
                        <div className="qna-form-ctrl">
                            <label>Issue type</label>
                            <div className="qna-filter-wrapper form-content-wrapper">
                                <QnaFilter
                                    itemNumber={1}
                                    ActiveItem={ddlFilter}
                                    setActiveItem={setDdlFilter}
                                    options={
                                        [
                                            {
                                                title: 'Issue 1',
                                                value: '1'
                                            },
                                            {
                                                title: 'Issue 2',
                                                value: '2'
                                            },
                                            {
                                                title: 'Issue 3',
                                                value: '3'
                                            },
                                            {
                                                title: 'Issue 4',
                                                value: '4'
                                            }
                                        ]
                                    } title="Select an issue" {...props} />
                            </div>
                        </div>
                        <div className="qna-form-ctrl">
                            <label>Issue details</label>
                            <textarea placeholder="Mention your issue in detail (optional)"></textarea>
                        </div>
                        <div className="qna-action-btn-wrapper">
                            <button className="btn-blue-txt" onClick={props.HandleReportPopup}>
                                Cancel
                            </button>
                            <button className="btn-blue-bg">
                                Submit
                            </button>
                        </div>
                    </div>
                </div>
            </div>}
        </>
    )
}